<template>
  <ion-page :key="uniqueKey">
    <ion-header class="headerTop">
      <headertoolbar></headertoolbar>
    </ion-header>

    <ion-content :fullscreen="true">
      <ion-header collapse="condense"> </ion-header>
      <div class="SpeedTestNotification" v-show="false"><!-- SPEEDTEST ALERT -->
        <div class="listSpeedTest">
          <div class="itemSpeedTest">
            <div aria-hidden="true" slot="start" class="avatarSpeedTest">
              <img class="imgSpeedTest"  alt="" src="img-admin/disconnected-y.png" />
            </div>
            <ion-label class="labelSpeedTest"><p><strong>{{ speedTest }}</strong>, bajo rendimiento de red</p>
              <p class="desc">
                Si experimentas problemas de reproducción,<br>por favor verifica tu conexión a internet.
              </p>
            </ion-label>
          </div>
        </div>
      </div>
      <button
        class="concursoNotification"
        :class="concursoActivo"
        @click="showContestModalButton()">
        <ion-img src="assets/ICONOS/ticket.svg"></ion-img>
        <span class="tooltip">¡Concurso Activo!</span>
      </button>
      <button
        v-if="enableOriginalABTest && showFloatingABTest"
        class="abTestFloating"
        :disabled="abSwitchInProgress"
        :class="{ 'abOriginalMode': isOriginalABMode }"
        @click="toggleSongSourceAB()"
        :title="isOriginalABMode ? 'Modo actual: ORIGINAL' : 'Modo actual: NORMALIZADO'">
        {{ isOriginalABMode ? 'ORIGINAL' : 'NORMALIZADO' }}
      </button>
      <ion-img
        src="assets/reproductor/logo_default.jpg"
        v-if="!clientImageSrc"
        class="playerImage"
        :style="{ 'background-color': '#FFFFFF' }"></ion-img>
      <ion-img
        :src="clientImageSrc"
        v-else
        class="playerImage"
        :style="{ 'background-color': clientColor }"
        :alt="clientName + '_logo'"></ion-img>
      <!-- default -->
      <div
        class="playerImage2_out"
        v-if="!clientImageSrc"
        :style="{ 'background-color': '#FFFFFF' }">
        <div
          class="playerImage2"
          :style="{
            'background-image': 'url(assets/reproductor/logo_default.jpg)',
          }"></div>
      </div>
      <!-- imagen cliente -->
      <div
        class="playerImage2_out"
        v-else
        :style="{ 'background-color': clientColor }">
        <div
          class="playerImage2"
          :style="{ 'background-image': 'url(' + clientImageSrc + ')' }"
          :alt="clientName + '_logo'"></div>
      </div>
      <ion-grid class="reproductor_small">
        <ion-row>
          <ion-col size="8" class="songInfoCol">
            <p class="songName">
                <span>
                  <!--<ion-img class="storeIcon" v-show="storedFileType" src="assets/ICONOS/rep-save.png"></ion-img> -->
                  {{ title }}
                </span>
            </p>
            <p class="playlistName">
              <span>{{ artist }}</span>
            </p>
          </ion-col>
          <ion-col size="4" class="likeCol">
            <ion-button
              fill="clear"
              v-on:click="liked == 0 ? likeInteraction('1') : ''"
              class="likeButton"
              ><ion-icon
                :src="
                  liked == 1
                    ? 'assets/ICONOS/like.svg'
                    : 'assets/ICONOS/like-linea.svg'
                "
                name="botón like"></ion-icon
            ></ion-button>
            <!-- <ion-button fill="clear" v-else-if="liked=1" class="likeButton"><ion-icon src="assets/ICONOS/like.svg"></ion-icon></ion-button> -->
            <ion-button
              fill="clear"
              v-on:click="liked == 0 ? likeInteraction('2') : ''"
              class="dislikeButton"
              ><ion-icon
                :src="
                  liked == 2
                    ? 'assets/ICONOS/dislike.svg'
                    : 'assets/ICONOS/dislike-linea.svg'
                "></ion-icon
            ></ion-button>
            <!-- <ion-button v-on:click="next()">Next</ion-button> -->
          </ion-col>
          <ion-col size="12" class="progressBarCol">
            <ion-progress-bar
              :value="songProgress"
              buffer="1"></ion-progress-bar>
          </ion-col>
          <ion-col size="6" class="songTimeCol" style="color: white">
            <p class="songTime">
              {{ currentlyTimer ? currentlyTimer : '00:00' }}
            </p>
          </ion-col>
          <ion-col size="6" class="songTimeRemainingCol" style="color: white">
            <p class="songTimeRemaining">{{ totalTimer }}</p>
          </ion-col>
          <!-- <ion-col size="12" class="rep_nativo">
            <audio class="player_audio" controls id="audio">
                <source src="https://vybroo.net/a/music/V/VAN%20HALEN%20-%20Panama.m4a" type="audio/mpeg"/>
            </audio>
          </ion-col> -->
          <ion-col size="12" class="playPauseCol" shape="round">
            <!-- <ion-button fill="clear" class="playPauseButton volumeButton" v-on:click="showVolumeButton()" shape="round"><ion-icon src="assets/ICONOS/volume_white.svg"></ion-icon></ion-button> -->
            <ion-button
              fill="clear"
              class="playPauseButton playButton"
              v-if="!globalPlay"
              ref="playButton"
              v-on:click="play()"
              shape="round"
              ><ion-icon src="assets/ICONOS/play.svg"></ion-icon
            ></ion-button>
            <ion-button
              fill="clear"
              class="playPauseButton playButton"
              v-if="!isPlaying && globalPlay"
              ref="playButton"
              v-on:click="play()"
              shape="round"
              ><ion-icon src="assets/ICONOS/play.svg"></ion-icon></ion-button
            ><!--audios-griss.svg-->
            <ion-button
              fill="clear"
              class="playPauseButton pauseButton"
              v-else-if="globalPlay"
              ref="pauseButton"
              v-on:click="pause('user-click')"
              shape="round"
              ><ion-icon src="assets/ICONOS/pausa.svg"></ion-icon></ion-button
            ><!--audios-blanco.svg-->
            <!-- botón de opciones fijo en el sector derecho del boton de play/pause -->
            <ion-button
              fill="clear"
              class="playPauseButton optionsButton"
              id="qualityOptions"
              v-on:click="showQualityOptionsButton()"
              v-if="this.sound.controls"
              shape="round"
              title="Calidad de sonido"
              ><ion-icon src="assets/ICONOS/options2_white.svg"></ion-icon
            ></ion-button>
          </ion-col>
          <!-- Boton de next -->
          <ion-col size="12" class="nextCol">
            <ion-button
              fill="clear"
              class="nextButton"
              v-on:dblclick="next()"
              shape="round">
              Next
              <ion-img
                class="nextButtonImg"
                src="assets/ICONOS/next.png"></ion-img>
            </ion-button>
            <small>memoria usada:{{ memorySize }}</small>
            <!--
              <input type="text" ref="songIddd">
              <button @click='playStoredAudio(this.$refs.songIddd.value)'>playStoredAudio</button>
              <button @click="vBackNext()">vBackNext</button>
            -->
            <ul>
              <li><span style="color: yellow;">isPlaying:</span> {{ this.isPlaying }}</li>
              <li><span style="color: yellow;">title:</span> {{ this.title }}</li>
              <li><span style="color: yellow;">artist:</span> {{ this.artist }}</li>
              <li><span style="color: yellow;">type:</span> {{ this.type }}</li>
              <li><span style="color: yellow;">playerAudioSource:</span> {{ this.playerAudioSource }}</li>
              <li><span style="color: yellow;">tags:</span> {{ this.tags }}</li>
              <li><span style="color: yellow;">formula:</span> {{ this.formula }}</li>
              <li><span style="color: yellow;">filter:</span> {{ this.filter }}</li>
              <li><span style="color: yellow;">token:</span> {{ this.token }}</li>
              <li><span style="color: yellow;">vBackToken:</span> {{ this.vBackToken }}</li>
              <li><span style="color: yellow;">connected:</span> {{ this.networkStatus.connected }}</li>
              <li><span style="color: yellow;">enLinea:</span> {{ this.enLinea }}</li>
              <li><span style="color: yellow;">fullScreenOn:</span> {{ this.fullScreenOn }}</li>
              <li><span style="color: yellow;">videoOn:</span> {{ this.videoOn }}</li>
              <li><span style="color: yellow;">playErrorCount:</span> {{ this.playErrorCount }}</li>
              <li></li>
              <li><span style="color: yellow;">lastPauseReason:</span> {{ this.lastPauseReason }}</li>
              <li><span style="color: yellow;">lastPauseAt:</span> {{ this.lastPauseAt }}</li>
              <li><span style="color: yellow;">lastPlaySuccessAt:</span> {{ this.lastPlaySuccessAt }}</li>
              <li><span style="color: yellow;">lastSourceChangeAt:</span> {{ this.lastSourceChangeAt }}</li>
              <li><span style="color: yellow;">pauseRetryTimer:</span> {{ this.pauseRetryTimer }}</li>
              <li><span style="color: yellow;">pauseRetryRunning:</span> {{ this.pauseRetryRunning ? 'sí' : 'no' }}</li>
              <li><span style="color: yellow;">pauseRetryAttempts:</span> {{ this.pauseRetryAttempts }}</li>
              <li><span style="color: yellow;">pauseRetryMaxAttempts:</span> {{ this.pauseRetryMaxAttempts }}</li>
              <li></li>
              <li><span style="color: yellow;">wakeLock:</span> {{ this.wakeLock ? 'activo' : 'inactivo' }}</li>
              <li><span style="color: yellow;">wakeLockOn:</span> {{ (this.wakeLock || this.wakeLockNativeActive) ? 'sí' : 'no' }}</li>
              <li><span style="color: yellow;">wakeLockSupported:</span> {{ this.supportsWebWakeLock() ? 'sí' : 'no' }}</li>
              <li><span style="color: yellow;">wakeLockNative:</span> {{ this.isNativePlatform() ? 'sí' : 'no' }}</li>  
              <li><span style="color: yellow;">wakeLockInNative:</span> {{ this.isNativePlatform() && KeepAwake ? 'sí' : 'no' }}</li> 
              <li><span style="color: yellow;">wakeLockWeb:</span> {{ !this.isNativePlatform() && this.supportsWebWakeLock() ? 'sí' : 'no' }}</li>  
              <li><span style="color: yellow;">wakeLockActive:</span> {{ this.wakeLock ? 'sí' : 'no' }}</li>
              <li><span style="color: yellow;">wakeLockError:</span> {{ this.wakeLockError ? 'sí' : 'no' }}</li>
              <li><span style="color: yellow;">wakeLockErrorMessage:</span> {{ this.wakeLockErrorMessage }}</li>
              <li><span style="color: yellow;">wakeLockAutoplayBlocked:</span> {{ this.autoplayBlocked ? 'sí' : 'no' }}</li>
                            
              
              
            </ul>
          </ion-col>
          <!-- <ion-button v-on:click="pause()">Pausar</ion-button>
            <ion-button v-on:click="play()">Play</ion-button> -->
          <!-- <ion-button v-on:click="scheduleBasic()">Schedule basic</ion-button> -->
          <!-- <ion-button v-on:click="scheduleAdvanced()">Schedule advanced</ion-button> -->
          <ion-col size="12" class="rep_nativo">
            <!-- <audio class="player_audio" controls ref="audioPlayer" id="audio">
                <source :src="playerAudioSource" type="audio/mpeg"/>
                <source src="https://vybroo.net/a/music/V/VAN%20HALEN%20-%20Panama.m4a" type="audio/mpeg"/>
            </audio> -->
          </ion-col>
        </ion-row>
      </ion-grid>
      <div class="loaderOutDiv" v-show="vBackStatus">
        <p class="vBackMessage">Funcionando Offline</p>
        <ion-icon class="vbackimg" src="assets/ICONOS/vback.svg"></ion-icon>
        <div class="loaderr"></div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="js">
/* eslint-disable */
import {
  alertController,
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonCol,
  IonGrid,
  IonRow,
  IonButton,
  IonProgressBar,
  IonLabel,
  menuController,
  IonImg,
  IonIcon,
  modalController,
  toastController,
} from '@ionic/vue';
import axios from 'axios';
import { defineComponent, version } from 'vue';
import { Storage } from '@capacitor/storage';
import headertoolbar from './header_toolbar.vue';
// import App from '../App.vue';
// import $ from 'jquery';
import Vue from 'vue';
import { App } from '@capacitor/app';
import { BackgroundMode } from '@ionic-native/background-mode';
import { Capacitor } from '@capacitor/core';
// import { Insomnia } from '@ionic-native/insomnia';
import { Network } from '@capacitor/network';
import deviceLogger from '../services/DeviceLogger';
// import { PowerManagement } from '@ionic-native/power-management';
import { Toast } from '@capacitor/toast';
import moment from 'moment-timezone';
import contestModal from './contestModal.vue';
import RepModal from './ModalRepFullView.vue';
import { NativeAudio } from '@capacitor-community/native-audio';
import { KeepAwake } from '@capacitor-community/keep-awake';
import { openDB } from 'idb';

export default {
  name: 'Reproductor',
  components: {
    IonHeader,
    IonToolbar,
    IonContent,
    IonPage,
    IonCol,
    IonGrid,
    IonRow,
    IonButton,
    IonProgressBar,
    IonLabel,
    headertoolbar,
    IonImg,
    IonIcon,
  },
  props: ['playTest'],
  data() {
    return {
      platform: '',
      sound: {
        quality: 'm4a_32',
        controls: false,
        fileExtension: '.mp3',
        volume: 0.5,
        musicVolume: 0.9,
        spotsVolume: 1.0,
        file: '',
        legacyFile: '',
        url: '',
      },
      isLoaded: false,
      urlSongsApi: 'https://media.vybroo.com/',
      // CDN para contenido multimedia (centralized)
      cdnBaseUrl: 'https://media.vybroo.com/',
      uniqueKey: 1,
      videoOn: false,
      fullScreenOn: false,
      modalisopen: false,
      modalWasClosed: false,
      concursoActivo: 'concursoInactivo',
      audio: null,
      title: 'Cargando...',
      bkTitle: '',
      artist: 'Vybroo',
      bkArtist: '',
      type: 'spot',
      location: '',
      tags: 's',
      formula: 's',
      filter: 's',
      token: -1,
      previousToken: -1,
      active: false,
      lastTry: 0,
      client: { color: '', name: '', logo: 'logo.svg', mobile_logo: '' },
      imageStyle: {},
      // Variables nuevas
      showPlayButton: false,
      playerAudioSource: '',
      current: {},
      coverObject: { cover: true, animated: false },
      index: 0,
      isPlaying: false,
      currentlyTimer: "00:00",
      totalTimer: "00:00",
      songs: [],
      player: new Audio(),
      songProgress: 0,
      clientData: {},
      clientName: "",
      clientImageSrc: "",
      clientColor: "",
      liked: 0,
      muted: false,
      unmutedVolume: null,
      globalPlay: false,
      currentSucursal: "",
      currentCategoria: "0",
      currentCategoriaAux: null,
      currentVariante: "0",
      currentVarianteAux: null,
      currentDataApiRequest: {},
      playerAudioDemanda: new Audio(),
      playingAudioDemanda: false,
      playerAudioDemandaSource: '',
      playerError: false,
      enLinea: 0,
      nextRunning: false,
      urlParams: {},
      saveMusicVariant: {},
      networkStatus: {},
      listenedChanges: {},
      alertRefreshPresented: false,
      updateInfo: "2026.08.27a (v1.9.7: alert system)",
      clientVersion: "1.9.7",
      contest: {

      },
      horaServer: "",
      horaLocal: "",
      horaMenor: "",
      horaActual: "",
      playErrorCount: 0,
      tokenErrorCount: 0,
      lastTokenError: 0,
      lastCategoriaError: "",
      errorReport: {},
      running500msInterval: false,
      autoplayBlocked: false,
      playRequestInFlight: false,
      lastContentFailureToken: null,
      sonara: false,
      audio_id: '0',
      ip: "",
      nextApiErrors: 0,
      vBackStatus: false,
      vBackList: [],
      vBackToken: -1,
      wakeLock: null,
      wakeLockError: false,
      wakeLockErrorMessage: '',
      wakeLockNativeActive: false,
      nativeBackgroundConfigured: false,
      appIsActive: true,
      speedTest: "",
      speedTestHistory: [],
      db: null,
      memorySize: "",
      storedFileType: false,
      storedInterval: false,
      // Feature temporal: cambiar entre audio normalizado/original en tiempo real.
      enableOriginalABTest: true,
      showFloatingABTest: false,
      // Fuente de verdad del estado inicial del switch en toda la app.
      normalizeSongsDefaultEnabled: true,
      normalizeSongsEnabled: false,
      // Persistencia desactivada temporalmente: siempre usar valor por defecto al iniciar.
      normalizeSongsPersistenceEnabled: false,
      normalizeSongsPreferenceVersion: 'v1',
      normalizeSongsPreferenceKey: '',
      normalizeSongsPreferenceUpdatedAt: 0,
      // Control fijo para definir en qué versión se guardan canciones offline.
      // false = guardar ORIGINAL, true = guardar NORMALIZADA.
      offlineSongsStoreNormalized: false,
      isOriginalABMode: false,
      abSwitchInProgress: false,
      abPreloadAudio: new Audio(),
      abPreloadedUrl: '',
      abPreloadReady: false,
      abBlobUrlByRemote: {},
      abBlobOrder: [],
      lastPauseReason: 'init',
      lastPauseAt: 0,
      lastPlaySuccessAt: 0,
      lastSourceChangeAt: 0,
      pauseRetryTimer: null,
      pauseRetryRunning: false,
      pauseRetryAttempts: 0,
      pauseRetryMaxAttempts: 10,
      // === MEJORAS DE ROBUSTEZ (Fases 1-4) ===
      playerStalledTimer: null,
      isWaitingForData: false,
      userPaused: false,
      networkListenersRegistered: false,
      // === ALERTAS CONFIGURABLES POR CANAL ===
      alertConfig: {},
      lastAlertFired: {},
      volumeLowSince: null,
      pauseStartAt: null,
      disconnectStartAt: null,
    }
  },
  methods: {
    // Normaliza strings para comparaciones tolerantes a caracteres invisibles
    // (Word Joiner U+2060, Zero Width Space U+200B, BOM U+FEFF, etc.).
    // Se usa al comparar identifiers con sucursalName del URL.
    normalizeIdentifierString(str) {
      return String(str || '')
        .replace(/[\u200B-\u200F\u2028\u2029\u202A-\u202E\u2060\uFEFF]/g, '')
        .trim();
    },

    // Conversión de volumen lineal a logarítmico para percepción natural del oído humano
    linearToLog(linearValue) {
      // linearValue debe estar entre 0.0 y 1.0
      // Usamos una curva cuadrática para que los valores se perciban más naturales
      return Math.pow(linearValue, 2);
    },

    safeDecodeURIComponent(value) {
      const text = (value ?? '').toString();
      if (!text) return '';
      try {
        return decodeURIComponent(text);
      } catch (error) {
        console.warn('safeDecodeURIComponent fallback por URL inválida:', text);
        return text;
      }
    },

    normalizeMediaPath(path) {
      if (!path || typeof path !== 'string') return '';
      return path
        .split('/')
        .map((segment, index) => {
          if (!segment && index === 0) return '';
          return encodeURIComponent(this.safeDecodeURIComponent(segment));
        })
        .join('/');
    },

    isExpectedBlobType(blob, mediaType, sourceUrl, responseContentType) {
      const blobType = (blob && blob.type ? blob.type : '').toLowerCase();
      const headerType = (responseContentType || '').toLowerCase();
      const mimeType = blobType || headerType;
      const url = (sourceUrl || '').toLowerCase().split('?')[0];
      const isVideo = (mediaType || '').toLowerCase() === 'video';

      if (mimeType) {
        if (isVideo) return mimeType.startsWith('video/');
        return mimeType.startsWith('audio/') || mimeType.includes('mpeg') || mimeType.includes('mp4a');
      }

      if (isVideo) return url.endsWith('.mp4') || url.includes('/videos/');
      return url.endsWith('.mp3') || url.endsWith('.m4a') || url.endsWith('.aac');
    },

    isNotSupportedPlaybackError(error) {
      const text = (error && error.toString ? error.toString() : String(error || '')).toLowerCase();
      return text.includes('notsupportederror') || text.includes('webkitblobresource');
    },

    isAbortPlaybackError(error) {
      const text = (error && error.toString ? error.toString() : String(error || '')).toLowerCase();
      return text.includes('aborterror') || text.includes('operation was aborted');
    },

    async showUserToast(message, duration = 'long') {
      try {
        if (this.isNativePlatform()) {
          await Toast.show({ text: message, duration });
          return;
        }

        const toast = await toastController.create({
          message,
          duration: duration === 'long' ? 6000 : 3000,
          position: 'bottom',
        });
        await toast.present();
      } catch (error) {
        console.warn('No se pudo mostrar toast:', error);
      }
    },

    setAutoplayBlocked(reason) {
      if (!this.autoplayBlocked) {
        console.warn('Autoplay bloqueado por navegador; esperando interacción del usuario.', reason);
        //Show toast solo la primera vez que se bloquea el autoplay para no molestar al usuario repetidamente.
        this.showUserToast('La reproducción automática ha sido bloqueada por tu navegador. Por favor, toca el botón de reproducir para continuar.', 'long');
      }
      this.autoplayBlocked = true;
    },

    clearAutoplayBlocked(trigger) {
      if (!this.autoplayBlocked) return;
      this.autoplayBlocked = false;
      console.log('Autoplay desbloqueado por interacción del usuario:', trigger);
    },

    setPauseReason(reason = 'unknown') {
      this.lastPauseReason = (reason || 'unknown').toString();
      this.lastPauseAt = Date.now();
    },

    stopAutoResumeLoop(reason = '') {
      if (this.pauseRetryTimer) {
        clearTimeout(this.pauseRetryTimer);
        this.pauseRetryTimer = null;
      }
      this.pauseRetryRunning = false;
      this.pauseRetryAttempts = 0;
      if (reason) {
        console.log('AutoResume detenido:', reason);
      }
    },

    getAutoResumeDelayMs(attempt) {
      const delays = [800, 1200, 1700, 2400, 3200, 4200, 5200, 6200, 7200, 8200];
      return delays[Math.min(Math.max(attempt - 1, 0), delays.length - 1)];
    },

    shouldAutoResumePlayback() {
      if (this.type === 'video') return false;
      if (this.playingAudioDemanda) return false;
      if (this.autoplayBlocked && this.userPaused) return false;
      if (!this.globalPlay) return false;
      if (this.abSwitchInProgress) return false;
      if (this.playRequestInFlight) return false;
      if (!this.playerAudioSource) return false;

      // Propuesta 1: autoplay-blocked ahora sí permite reintentar (el loop tiene delays progresivos)
      if (this.lastPauseReason === 'user-click' ||
          this.lastPauseReason === 'manual-pause' ||
          this.lastPauseReason === 'ab-switch' ||
          this.lastPauseReason === 'source-change' ||
          this.lastPauseReason === 'before-unmount' ||
          this.lastPauseReason === 'kill-audio') return false;

      // Evita reintentos durante cambios intencionales de fuente.
      if (Date.now() - this.lastSourceChangeAt < 1400) return false;

      return true;
    },

    scheduleAutoResumeLoop(trigger = 'pause-event') {
      if (this.pauseRetryRunning) return;
      if (!this.shouldAutoResumePlayback()) return;

      this.pauseRetryRunning = true;
      this.pauseRetryAttempts = 0;

      const runAttempt = () => {
        if (!this.pauseRetryRunning) return;
        if (!this.shouldAutoResumePlayback()) {
          this.stopAutoResumeLoop('condicion invalida para reintento');
          return;
        }
        if (this.pauseRetryAttempts >= this.pauseRetryMaxAttempts) {
          console.warn('AutoResume agotó intentos. reason=', this.lastPauseReason, 'source=', this.playerAudioSource);
          this.stopAutoResumeLoop('max-intentos');
          return;
        }

        this.pauseRetryAttempts += 1;
        const delayMs = this.getAutoResumeDelayMs(this.pauseRetryAttempts);

        this.pauseRetryTimer = setTimeout(() => {
          this.pauseRetryTimer = null;
          if (!this.pauseRetryRunning) return;

          if (this.player && !this.player.paused) {
            this.onPlaybackStarted('auto-resume-detect-playing');
            return;
          }

          console.warn('AutoResume intento', this.pauseRetryAttempts, 'trigger=', trigger, 'reason=', this.lastPauseReason);
          this.play('auto-retry');

          if (this.pauseRetryRunning) {
            runAttempt();
          }
        }, delayMs);
      };

      runAttempt();
    },

    onPlaybackStarted(reason = 'play-success') {
      this.lastPlaySuccessAt = Date.now();
      this.lastPauseReason = reason;
      
      // Si se recuperó de un auto-resume, enviar reporte al servidor
      if (this.pauseRetryAttempts > 0) {
        this.reportAutoResumeSuccess();
      }
      
      this.stopAutoResumeLoop('playback-ok');
    },

    setPlayerSource(url, reason = 'source-change') {
      this.lastSourceChangeAt = Date.now();
      this.setPauseReason(reason);
      this.stopAutoResumeLoop('source-change');
      this.player.src = url;
    },

    handleUserPlaybackGesture() {
      this.clearAutoplayBlocked('gesture');
      this.wakeLockOn();
      if (this.globalPlay && this.playerAudioSource && !this.isPlaying && !this.userPaused) {
        this.play('user-gesture');
      }
    },

    handleWakeLockVisibilityChange() {
      if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
      this.wakeLockOn();
    },

    isNativePlatform() {
      const currentPlatform = this.platform || Capacitor.getPlatform();
      return currentPlatform === 'android' || currentPlatform === 'ios';
    },

    supportsWebWakeLock() {
      return typeof navigator !== 'undefined' && navigator.wakeLock && typeof navigator.wakeLock.request === 'function';
    },

    emitWakeLockStatus(reason = '') {
      try {
        const currentPlatform = this.platform || Capacitor.getPlatform();
        const nativePlatform = this.isNativePlatform();
        const payload = {
          reason,
          active: nativePlatform ? !!this.wakeLockNativeActive : !!this.wakeLock,
          supported: nativePlatform ? true : this.supportsWebWakeLock(),
          mode: nativePlatform ? 'native' : 'web',
          platform: currentPlatform,
          appVersion: this.clientVersion,
          updateInfo: this.updateInfo,
          appIsActive: !!this.appIsActive,
          nativeBackgroundConfigured: !!this.nativeBackgroundConfigured,
          timestamp: Date.now(),
        };
        this.emitter.emit('wake-lock-status', payload);
      } catch (error) {
        console.warn('No se pudo emitir estado de wake lock:', error);
      }
    },

    async wakeLockOff() {
      try {
        if (this.isNativePlatform()) {
          try {
            await KeepAwake.allowSleep();
            this.wakeLockNativeActive = false;
            console.log('KeepAwake nativo liberado.');
          } catch (nativeErr) {
            console.warn('No se pudo liberar KeepAwake nativo:', nativeErr);
          }
          this.emitWakeLockStatus('wake-lock-off-native');
          return;
        }

        if (this.wakeLock) {
          await this.wakeLock.release();
          this.wakeLock = null;
          console.log('WakeLock web liberado.');
        }
        this.emitWakeLockStatus('wake-lock-off-web');
      } catch (e) {
        console.error('ha ocurrido un error en la función wakeLockOff - ' + e);
      }
    },

    advanceTokenAfterContentFailure(reason) {
      const currentToken = Number(this.token);
      if (!Number.isFinite(currentToken)) return;
      if (this.lastContentFailureToken === currentToken) return;

      this.lastContentFailureToken = currentToken;
      this.token = currentToken + 1;
      console.warn(`Token ${currentToken} marcado como no reproducible (${reason}), avanzando a ${this.token}`);
      this.emitter.emit("rep-token", this.token);
    },

    // Inicializa la base de datos
    async initDB() {
      this.db = await openDB('vybrooDB', 3, {
        upgrade(db) {
          if (!db.objectStoreNames.contains('media')) {
            db.createObjectStore('media', { keyPath: 'id' });
          }
          if (!db.objectStoreNames.contains('vback')) {
            db.createObjectStore('vback', { keyPath: 'id', autoIncrement: true });
          }
          if (!db.objectStoreNames.contains('device_logs')) {
            const store = db.createObjectStore('device_logs', { keyPath: 'id', autoIncrement: true });
            store.createIndex('event', 'event', { unique: false });
            store.createIndex('ts', 'ts', { unique: false });
            store.createIndex('device_id', 'device_id', { unique: false });
          }
        },
      });
      await this.calculateDatabaseSize();
    },
    async memorySizeFree() {
      if (!this.db) {
        console.log("Inicializando base de datos.");
        await this.initDB();
      }
      const limit = 60;
      const vback = await this.db.getAll('vback');
      const media = await this.db.getAll('media');
      let logs = [];
      let audios = [];
      let logsToDelete = [];

      if (vback.length > limit) {
        logs = vback.filter(log => log.stream === this.clientData.stream).slice(-limit);
      } else {
        logs = vback.filter(log => log.stream === this.clientData.stream);
      }
      console.log("logs: ", logs);
      for (const log of logs) {
        audios.push(log.url);
      }
      console.log("audios: ", audios);
      for (const song of media) {
        if (!audios.includes(song.id)) {
          console.log("Eliminando audio: ", song.id);
          await this.db.delete('media', song.id);
        }
      } 
      for (const log of vback) {
        if (!logs.some(l => l.id === log.id)) {
          console.log("Eliminando log: ", log.id);
          await this.db.delete('vback', log.id);
        }
      }
      
      await this.calculateDatabaseSize();
      
    },
    getStorageId(id) {
      //console.log("1getStorageId>>>>>", id);
        id = this.safeDecodeURIComponent(id);
        id = id.replace("https://media.vybroo.com/", "");
        id = id.replace("https://media.vybroo.com/", "");
        id = id.replace("https://vybroo.net/", "");
        id = id.replace(/\//g, "_");
        id = id.replace(/%20/g, "-");
        id = id.toLowerCase();
      //console.log("2getStorageId>>>>>", id);

        if (id.startsWith("videos_")) { id = id.replace("videos_", ""); }
        if (id.startsWith("mp3_320_norm_")) { id = id.replace("mp3_320_norm_", ""); }
        if (id.startsWith("mp3_320_")) { id = id.replace("mp3_320_", ""); }
        if (id.startsWith("mp3_128_")) { id = id.replace("mp3_128_", ""); }
        if (id.startsWith("m4a_32_")) { id = id.replace("m4a_32_", ""); }
        if (id.startsWith("a_spots_")) { id = id.replace("a_spots_", ""); }
        
        if (id.endsWith(".mp4")) { id = id.slice(0, -4); }
        if (id.endsWith(".m4a")) { id = id.slice(0, -4); }
        if (id.endsWith(".mp3")) { id = id.slice(0, -4); }
 
        id = id.replace(/[á]/g, "a")
         .replace(/[é]/g, "e")
         .replace(/[í]/g, "i")
         .replace(/[ó]/g, "o")
         .replace(/[ú]/g, "u")
         .replace(/[ñ]/g, "n");
        id = id.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        id = id.replace(/[^a-zA-Z0-9-_]/g, "");

        //console.log("3getStorageId>>>>>", id);
        return id;
    },

    // Helper para operaciones DB con re-intento automático si la conexión se cierra
    async dbGetSafe(storeName, id, maxRetries = 2) {
      for (let attempt = 0; attempt <= maxRetries; attempt++) {
        if (!this.db) {
          await this.initDB();
        }
        try {
          return await this.db.get(storeName, id);
        } catch (error) {
          const errStr = (error && error.toString ? error.toString() : String(error || '')).toLowerCase();
          if (errStr.includes('invalidstateerror') || errStr.includes('database connection is closing')) {
            console.warn('dbGetSafe: conexión cerrada (intento ' + (attempt + 1) + '/' + (maxRetries + 1) + '), re-inicializando DB');
            this.db = null;
            if (attempt < maxRetries) {
              await this.initDB();
              continue;
            }
          }
          // Si no es error de conexión o ya agotamos reintentos, propagar
          throw error;
        }
      }
    },

    async audioExistsDB(id) {
      if (!this.db) {
        console.log("Inicializando base de datos.");
        await this.initDB();
      }
      //console.log("audioExistsDB>>>>>", this.getStorageId(id));
      if (id.startsWith('blob:http://localhost')) {
        //console.log("audioExistsDB::: Este archivo ya se encuentra descargado :::");
        return;
      }
      if (id != "" && id != null && id != undefined && id != "undefined" && id != "null" && id != "0") {
        const song = await this.dbGetSafe('media', id);
        let exist = song && song.stream === this.clientData.stream ? true : false;
        //console.log("audioExistsDB>>>>>", exist);
        if (exist) {
          console.log("PLAY DATABASE");
          this.storedFileType = true;
          //this.storePlayLog(this.token, title, artist, url, type, moment().format('YYYY-MM-DD HH:mm:ss'), filter);
          this.storePlayLog(this.token, song.title, song.artist, song.id, song.type, moment().format('YYYY-MM-DD HH:mm:ss'), song.filter);
          this.playStoredAudio(id);
        } else {
          if (this.vBackStatus == true) {
            console.log("Omitiendo reproduucción... datos no encontrados");
            this.vBackNext();
            return;
          }
          console.log("PLAY DIRECTO");
          this.storedFileType = false;
          //print this.token, this.title, this.artist, this.getStorageId(this.playerAudioSource), this.type, moment().format('YYYY-MM-DD HH:mm:ss')
          
          //console.log("audioExistsDB::: token:", this.token);
          //console.log("audioExistsDB::: title:", this.title);
          //console.log("audioExistsDB::: artist:", this.artist);
          //console.log("audioExistsDB::: url:", this.getStorageId(this.playerAudioSource));
          //console.log("audioExistsDB::: type:", this.type);
          //console.log("audioExistsDB::: date:", moment().format('YYYY-MM-DD HH:mm:ss'));
          
          this.storePlayLog(this.token, this.title, this.artist, this.getStorageId(this.playerAudioSource), this.type, moment().format('YYYY-MM-DD HH:mm:ss'), this.filter);
          this.play();
        }
      }else{
        console.log("audioExistsDB::: No se encontró el archivo de audio con el ID proporcionado (id vacio).");
      }
    },
    async videoExistsDB(id) {
      if (!this.db) {
        console.log("Inicializando base de datos.");
        await this.initDB();
      }
      //console.log("videoExistsDB>>>>>", this.getStorageId(id));
      const video = await this.dbGetSafe('media', this.getStorageId(id));
      let exist = video && video.stream === this.clientData.stream ? true : false;
      //console.log("videoExistsDB>>>>>", exist);
      if (exist) {
        console.log("PLAY DATABASE");
        this.storePlayLog(this.token, video.title, video.artist, video.id, video.type, moment().format('YYYY-MM-DD HH:mm:ss'), video.filter);
        let localUrlFileBlob = await this.getAudioFileUrl(id);
        if (localUrlFileBlob) {
           if (this.videoOn == false) {//send url from local file
              this.showVideoModal(localUrlFileBlob);
          } else {
              this.emitter.emit("rep-VideoSource", localUrlFileBlob);
          }
        }
      } else {
        console.log("PLAY DIRECTO");
        this.storePlayLog(this.token, this.title, this.artist, this.getStorageId(this.playerAudioSource), this.type, moment().format('YYYY-MM-DD HH:mm:ss'), this.filter);
        if (this.videoOn == false) {
            this.showVideoModal(this.playerAudioSource);
        } else {
            this.emitter.emit("rep-VideoSource", this.playerAudioSource);
        }
      }
    },
    // Función para almacenar el archivo de audio en IndexedDB
    async storeAudioFile(id, title, artist, url, type, tags, formula, filter) {
      if (!this.db) {
        console.log("Inicializando base de datos.");
        await this.initDB();
      }
      var id_audio = id;
      var id = this.getStorageId(url); 
      /*console.log("storeAudioFile>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      console.log("storeAudioFile>>>>id:", id);
      console.log("storeAudioFile>>>>title:", title);
      console.log("storeAudioFile>>>>artist:", artist);
      console.log("storeAudioFile>>>>url:", url);
      console.log("storeAudioFile>>>>type:", type);
      console.log("storeAudioFile>>>>tags:", tags);
      console.log("storeAudioFile>>>>formula:", formula);
      console.log("storeAudioFile>>>>filter:", filter);*/
      if (url.startsWith('blob:http://')) {
      console.log("::: Este archivo ya se encuentra descargado :::");
      //console.log("storeAudioFile>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        return;
      }
      try {

      if (id != "" && id != null && id != undefined && id != "undefined" && id != "null" && id != "0") {
        const existingFile = await this.db.get('media', id);
        if (existingFile && existingFile.stream === this.clientData.stream) {
          // Si el archivo ya existe, solo actualizar la fecha
          existingFile.date = moment().format('YYYY-MM-DD HH:mm:ss');
          await this.db.put('media', existingFile);
          console.log(`storeAudioFile>>>>Fecha del archivo "${title}" actualizada con éxito`);
        } else {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`Respuesta inválida al descargar archivo (${response.status})`);
          }
          const blob = await response.blob();
          const responseType = response.headers ? response.headers.get('content-type') : '';
          if (!blob || blob.size === 0) {
            throw new Error('Archivo descargado vacío');
          }
          if (!this.isExpectedBlobType(blob, type, url, responseType)) {
            throw new Error(`Tipo MIME no soportado para cache offline: ${blob.type || responseType || 'desconocido'}`);
          }
          // Verificar el tipo MIME del archivo de audio
          //console.log("storeAudioFile>>>>Tipo MIME del archivo de audio:", blob.type);
          
          artist = artist ? artist : 'Vybroo';
          tags = tags ? tags : '';
          formula = formula ? formula : '';
          filter = filter ? filter : '';

          await this.db.put('media', { 
            id,
            id_audio,
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
            title, 
            artist, 
            url,
            fileBlob: blob,
            type,
            tags,
            formula,
            filter,
            stream: this.clientData.stream
          });
          console.log(`storeAudioFile>>>>Archivo de audio "${title}" almacenado con éxito`);
        }

        // Calcular el tamaño total de la base de datos
        await this.calculateDatabaseSize();
      }else{
        console.log("storeAudioFile::: No se encontró el archivo de audio con el ID proporcionado (id vacio).");
      }
      } catch (error) {
        console.error("storeAudioFile>>>>Error al almacenar el archivo de audio:", error);
      }
     // console.log("storeAudioFile<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
    },
    async storePlayLog(token, title, artist, url, type, date, filter) {
      if (!this.db) {
        console.log("Inicializando base de datos.");
        await this.initDB();
      }
      console.log("storePlayLog>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      var id = moment(date).format('YYYY-MM-DD|') +""+ this.tokenId(token);
      var url = this.getStorageId(url); 
      try {
        const existingFile = await this.db.get('vback', id);
        if (existingFile && existingFile.stream === this.clientData.stream) {
          console.log(`storePlayLog>>>>Log ya guardado "${id}" "${title}" `);
        } else {
          await this.db.put('vback', { 
            id,
            token,
            date: date,
            title, 
            artist, 
            url,
            type,
            filter,
            stream: this.clientData.stream
          });
        }
      } catch (error) {
        console.error("storePlayLog>>>>Error al almacenar el registro de reproducción:", error);
      }
      console.log("storePlayLog<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
    },
    // Función para recuperar el archivo de audio de IndexedDB
    async getAudioFileUrl(id) {this.storedFileType = false;
      if (!this.db) {
        console.log("Inicializando base de datos.");
        await this.initDB();
      }
      try {
        id = this.getStorageId(id);
        const song = await this.dbGetSafe('media', id);

        if (song) {
          this.storedFileType = true;
          this.title = song.title;
          this.artist = song.artist;
          //console.log(`Archivo de audio "${song.title}" recuperado con éxito`);
          //console.log("Tipo MIME del archivo de audio recuperado:", song.fileBlob.type);
          return URL.createObjectURL(song.fileBlob);
        } else {
          this.storedFileType = false;
          console.log("No se encontró el archivo de audio con el ID proporcionado.");
          return null;
        }
      } catch (error) {
        console.error("Error al obtener el archivo de audio:", error);
        return null;
      }
    },

    // Función para reproducir el audio almacenado
    async playStoredAudio(id) {
      console.log("Reproduciendo audio almacenado con ID:", id);
      if (!this.db) {
        console.log("Inicializando base de datos.");
        await this.initDB();
      }

      const storageId = this.getStorageId(id);
      const storedSong = await this.db.get('media', storageId);
      const audioUrl = await this.getAudioFileUrl(storageId);
      if (audioUrl) {
        this.setPlayerSource(audioUrl, 'source-change');
        try {
          await this.player.play();
          this.syncPlayUiState(true);
          this.onPlaybackStarted('playStoredAudio-success');
        } catch (error) {
          if (this.isAbortPlaybackError(error)) {
            console.log("Reproducción interrumpida (AbortError), omitiendo fallback porque pudo iniciar otra pista.");
            return;
          }

          console.error("Error al reproducir el audio:", error);
          this.syncPlayUiState(false);

          if (this.isNotSupportedPlaybackError(error)) {
            try {
              await this.db.delete('media', storageId);
              console.warn('Blob offline inválido eliminado de IndexedDB:', storageId);
            } catch (deleteError) {
              console.error('No se pudo eliminar blob inválido de IndexedDB:', deleteError);
            }
          }

          const fallbackRemoteUrl = storedSong && storedSong.url
            ? this.resolveOfflineStoreUrl(storedSong.url, storedSong.type)
            : '';

          if (fallbackRemoteUrl) {
            try {
              this.storedFileType = false;
              this.playerAudioSource = fallbackRemoteUrl;
              this.setPlayerSource(fallbackRemoteUrl, 'source-change');
              await this.player.play();
              this.syncPlayUiState(true);
              this.onPlaybackStarted('playStoredAudio-fallback-success');
            } catch (fallbackError) {
              console.error('Fallback remoto falló al reproducir audio almacenado:', fallbackError);
              this.syncPlayUiState(false);
              this.errorNext();
            }
          } else {
            this.errorNext();
          }
        }
      } else {
        console.log("No se puede reproducir el audio, no se encontró el archivo.");
      }
    },

    async calculateDatabaseSize() {
      if (!this.db) {
        console.log("Inicializando base de datos.");
        await this.initDB();
      }
      let totalSize = 0;
      const tx = this.db.transaction('media', 'readwrite');
      const store = tx.objectStore('media');
      const allSongs = await store.getAll();

      for (const song of allSongs) {
        if (!song.date || !song.url || !song.fileBlob || song.url === '') {
          await store.delete(song.id);
        } else {
          totalSize += song.fileBlob.size;
        }
      }
      let memorySizeGB = 0;
      let memorySizeMB = 0;
      
        memorySizeGB = (totalSize / (1024 * 1024 * 1024)).toFixed(2);
        memorySizeMB = (totalSize / (1024 * 1024)).toFixed(2);
    
      if (totalSize >= 1024 * 1024 * 1024) {
        this.memorySize = memorySizeGB + ' GB';
      } else {
        this.memorySize = memorySizeMB + ' MB';
      }
      this.emitter.emit("memorySize", this.memorySize);
      console.log("Tamaño total de la base de datos:", this.memorySize);

      
      if (this.clientData.storage) {
        var storageLimit = this.clientData.storage;
        if (memorySizeGB >= storageLimit) { // limitador de 
          const oldestSong = allSongs.sort((a, b) => new Date(a.date) - new Date(b.date))[0];
          console.log("Espacio "+memorySizeGB+"GB es mayor a "+storageLimit+"GB");
          console.log("eliminando por espacio: ", oldestSong);

          const Vtx = this.db.transaction('vback', 'readwrite');
          const Vstore = Vtx.objectStore('vback');
          const VallLogs = await Vstore.getAll();
          //to delete array
          const oldLogs = [];
          for (const log of VallLogs) {
            if (log.url == oldestSong.id) {
              //console.log("Log eliminado por espacio: ", log);
              oldLogs.push(log);
            }else {
              if (log.date <= oldestSong.date) {
                oldLogs.push(log);
              }
            }
          }
          console.log("oldLogs: ", oldLogs);
          // remve all old logs from vback db 
          for (const log of oldLogs) {
            console.log("Eliminando log: ", log.id);
            await Vstore.delete(log.id);
          }
          console.log("Eliminando audio: ", oldestSong.id);
          const deleteTransaction = this.db.transaction('media', 'readwrite');
          const deleteStore = deleteTransaction.objectStore('media');
          await deleteStore.delete(oldestSong.id);
          console.log("RECALCULANDO ESPACIO:::::::::::");
          await this.calculateDatabaseSize();
        }else{
          console.log("Espacio "+memorySizeGB+"GB es menor a "+storageLimit+"GB");
        }
      }else{
        console.log("::: No se encontró el límite de almacenamiento en la base de datos.");
      }
    },
    fileLocationReBuild(fileToRebuild){
      var legacyFile = "";
      legacyFile = fileToRebuild;
      if (fileToRebuild) {
        fileToRebuild = fileToRebuild.startsWith("/a/") ? fileToRebuild.replace("/a/", "") : fileToRebuild;
        let split = fileToRebuild.split("/");
        //imprimir la ultima posición del array
        // console.log("Ultima posición del array: " + split[split.length - 1]);
        legacyFile = split[split.length - 2] + "/" + split[split.length - 1];
        //Poner cada una de las palabras solo con la primera letra en mayúscula y el resto en minúscula
        let capitalized = split[split.length - 1].replace(/\w\S*/g, function (txt) { return txt.charAt(0).toLowerCase() + txt.substr(1).toLowerCase(); });
        //imprimir la ultima posición del array capitalizada
        // console.log("Ultima posición del array capitalizada: " + capitalized);
        //juntar las ultimas dos posiciones del array con un / entre medio e imprimirlo
        let stringFinal = split[split.length - 2] + "/" + capitalized;
        let stringFinalLegacy = legacyFile;
        //reemplazar espacios por %20
        stringFinal = stringFinal.replace(/ /g, "%20");
        stringFinalLegacy = stringFinalLegacy.replace(/ /g, "%20");
        //eliminar la extensiòn del archivo
        stringFinal = stringFinal.replace(".mp3", "");
        stringFinal = stringFinal.replace(".m4a", "");
        stringFinalLegacy = stringFinalLegacy.replace(".mp3", "");
        stringFinalLegacy = stringFinalLegacy.replace(".m4a", "");

        //console.log("stringFinalLegacy: ", stringFinalLegacy);
        //console.log("stringFinal: ", stringFinal);
        //console.log("legacyFile: ", legacyFile);
      }
    },

    async imHere() {
      if (this.networkStatus.connected == false){// return si no tengo internet
        console.error("imHere :: omitido - No tengo internet::C");
        return;
      }
      if (this.enLinea == 2) {// return si no tengo internet
        console.error("imHere :: omitido - No tengo internet::L");
        return;
      }
      try {

        let sucAux = 0;
        let suc = this.currentSucursal ? this.currentSucursal : 0;
        if (suc != 0 && Array.isArray(this.clientData.identifiers)) {
          // currentSucursal puede ser ID (número, desde URL ?sucursal=ID) o nombre
          // (string, desde localStorage). Intentar primero por ID, luego por nombre.
          let suc2 = this.clientData.identifiers.find(identifiers => identifiers.id == suc)
                  || this.clientData.identifiers.find(identifiers =>
                       this.normalizeIdentifierString(identifiers.identifier) == this.normalizeIdentifierString(suc)
                     );
          sucAux = suc2 ? suc2.id : 0;
        }

        // console.log("imHere() - sucursal: " + sucAux + " - variante: " + this.currentVariante + " - categoria: " + this.currentCategoria + " - playing: " + this.isPlaying + " - volume: " + this.player.volume * 100 + " - audio_id: " + this.audio_id + " - version: " + this.clientVersion + " - audio_name: " + this.title + " - token: " + this.token);

        let deviceId = this.getOrCreateDeviceId();
        let sessionId = this.getOrCreateSessionId();
        let url = "api/im_here";
        if (Capacitor.getPlatform() == 'ios' || Capacitor.getPlatform() == 'android') url = "https://panel.vybroo.net/im_here";

        // Fingerprint y metadata del navegador (ligero, ~2ms)
        let canvasHash = '';
        let browserMeta = {};
        try {
          canvasHash = await this.generateCanvasFingerprint();
          browserMeta = this.getBrowserMetadata();
        } catch (e) {
          console.warn('Fingerprint no disponible:', e);
        }

        await axios.post(url, {
          stream: this.clientData.stream,
          suc: sucAux,
          var: this.currentVariante ? this.currentVariante : 0,
          cat: this.currentCategoria ? this.currentCategoria : 0,
          ip: this.ip,
          playing: this.isPlaying,
          volume: this.sound.volume * 100,
          audio_id: this.audio_id,
          version: this.clientVersion,
          audio_name: this.title,
          token: this.token,
          device_id: deviceId,
          session_id: sessionId,
          // Fingerprint data
          canvas_hash: canvasHash,
          user_agent: browserMeta.user_agent || '',
          platform: browserMeta.platform || '',
          screen_resolution: browserMeta.screen_resolution || '',
          device_pixel_ratio: browserMeta.device_pixel_ratio || 0,
          cpu_cores: browserMeta.cpu_cores || 0,
          device_memory: browserMeta.device_memory || 0,
          connection_type: browserMeta.connection_type || '',
          timezone: browserMeta.timezone || '',
          language: browserMeta.language || '',
        })
          .then(r => {
            // console.log("---im_here: r.data:", r.data);
            if (r.data && r.data.request_logs) {
              console.log("Device logs requested by server, uploading...");
              return this.uploadDeviceLogs();
            }
          }).catch(error => {
            console.log("im_here: 1Error en función validateToken de Conexiones: " + error.message);
          });
      } catch (error) {
        console.log("im_here: 2Error en función validateToken de Conexiones: " + error.message);
      }
    },

    async uploadDeviceLogs() {
      try {
        const logs = await deviceLogger.export(5000);
        if (!logs || logs.length === 0) {
          console.log("No hay logs para subir");
          return;
        }
        const vback = await this.db.getAll('vback');
        const speedtest = JSON.parse(localStorage.getItem('speedTestHistory') || '[]');

        const payload = {
          device_id: this.getOrCreateDeviceId(),
          session_id: this.getOrCreateSessionId(),
          version: this.clientVersion,
          logs: logs.slice(0, 5000),
          vback_export: Array.isArray(vback) ? vback.slice(-50) : [],
          speedtest_history: Array.isArray(speedtest) ? speedtest.slice(-20) : [],
        };

        const url = "api/device_logs_upload";
        const fullUrl = Capacitor.getPlatform() == 'ios' || Capacitor.getPlatform() == 'android'
          ? "https://panel.vybroo.net/device_logs_upload"
          : url;

        await axios.post(fullUrl, payload);
        console.log("Device logs uploaded successfully: " + logs.length + " events");
        await deviceLogger.clear();
        await deviceLogger.log('log_uploaded', { count: logs.length, vback_count: payload.vback_export.length });
      } catch (e) {
        console.warn("Error al subir device logs:", e);
      }
    },
    speedTestRegistration(time, mbps, successfulSpeeds, totalSamples, failedSamples) {
      // Almacenar solo 10 registros de speedtest en localStorage para evitar saturación
      const maxRecords = 10;
      //registrar todos los datos en cada elemento del array
      const newRecord = {
        time,
        mbps,
        successfulSpeeds,
        totalSamples,
        failedSamples
      };
      let speedTestHistory = JSON.parse(localStorage.getItem('speedTestHistory') || '[]');
      speedTestHistory.push(newRecord);
      if (speedTestHistory.length > maxRecords) {
        speedTestHistory = speedTestHistory.slice(-maxRecords);
      }
      this.speedTestHistory = speedTestHistory;
      localStorage.setItem('speedTestHistory', JSON.stringify(speedTestHistory));
    },
    async speedTestRun() {
      
      if (this.networkStatus.connected == false){// return si no tengo internet
        console.error("speedTest :: omitido - No tengo internet::C");
        return;
      }
      if (this.enLinea == 2) {// return si no tengo internet
        console.error("speedTest :: omitido - No tengo internet::L");
        return;
      }
      try {
        const downloadSize = 116720; // bytes
        const downloadUrl = 'https://media.vybroo.com/images/vybroo-test.jpg';
        const totalSamples = 10;
        const sampleTimeoutMs = 9000;

        const downloadSpeed = (index) => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              const startTime = Date.now();
              const download = new Image();
              const cacheBuster = "?nnn=" + startTime + "-" + index;
              let completed = false;

              const timeoutId = setTimeout(() => {
                if (completed) return;
                completed = true;
                reject(new Error(`Timeout en la descarga del paquete: ${index}`));
              }, sampleTimeoutMs);

              download.onload = () => {
                if (completed) return;
                completed = true;
                clearTimeout(timeoutId);

                const endTime = Date.now();
                const duration = (endTime - startTime) / 1000;
                if (!duration || duration <= 0) {
                  reject(new Error(`Duración inválida en la descarga del paquete: ${index}`));
                  return;
                }
                const bitsLoaded = downloadSize * 8;
                const speedBps = bitsLoaded / duration;
                const speedKbps = speedBps / 1024;
                // console.log(`Connection Speed Index: ${index}\n${speedBps} bps\n${speedKbps} kbps`);
                resolve(speedKbps);
              };

              download.onerror = () => {
                if (completed) return;
                completed = true;
                clearTimeout(timeoutId);
                console.log(`Error en la descarga del paquete: ${index}`);
                reject(new Error(`Error en la descarga del paquete: ${index}`));
              };

              download.src = downloadUrl + cacheBuster;
            }, index * 1000);
          });
        };

        const promises = [];
        for (let index = 0; index < totalSamples; index++) {
          promises.push(downloadSpeed(index));
        }

        const settledResults = await Promise.allSettled(promises);
        const successfulSpeeds = settledResults
          .filter(result => result.status === 'fulfilled')
          .map(result => result.value)
          .filter(value => Number.isFinite(value) && value > 0);

        if (successfulSpeeds.length === 0) {
          throw new Error('No se pudo completar ninguna muestra del speedtest');
        }

        const sortedSpeeds = [...successfulSpeeds].sort((a, b) => a - b);
        const trimCount = sortedSpeeds.length >= 5 ? 1 : 0;
        const trimmedSpeeds = sortedSpeeds.slice(trimCount, sortedSpeeds.length - trimCount || sortedSpeeds.length);
        const baseForAverage = trimmedSpeeds.length > 0 ? trimmedSpeeds : sortedSpeeds;
        const suma = baseForAverage.reduce((acc, speed) => acc + speed, 0);
        const promedio = suma / baseForAverage.length;
        const speedMbps = (promedio / 1024).toFixed(2);
        this.speedTest = `${speedMbps} Mbps`;

            var  SPCurrentVariante = this.currentVariante ? this.currentVariante : 0 ;
            var  SPCurrentCategoria = this.currentCategoria ? this.currentCategoria : 0 ;
        const failedSamples = settledResults.length - successfulSpeeds.length;

        var SPText = "SPEEDTEST | Canal: " + this.clientData.stream +
            " | " + this.speedTest +
            " | muestras: " + successfulSpeeds.length + "/" + totalSamples +
            " | fallidas: " + failedSamples +
            " | Hora local: " + this.horaActual +
            " | var: " + SPCurrentVariante +
            " | cat: " + SPCurrentCategoria +
            " | ip: " + this.ip +
            " |";
        // console.log(SPText);
        const dataParameters = {
          chat: '-715319368',
          text: SPText
        };
        
        this.speedTestRegistration(this.horaActual, this.speedTest, successfulSpeeds.length, totalSamples, failedSamples);

        try {
          await axios.post("/api/sendmessage", dataParameters);
          console.log("%cSpeedTest Enviado ✅", "color: green; font-weight: bold; background-color: #eee; padding: 5px; border-radius: 5px; font-size: 14px; border: 2px solid green;");
          console.log("Velocidad de internet: " + this.speedTest + " (muestras exitosas: " + successfulSpeeds.length + "/" + totalSamples + ")");
        } catch (error) {
          console.error("Error en sendStats:", error.toString());
        }


      } catch (error) {
        console.log(`Error al medir la velocidad de internet: ${error}`);
      }
    },
    changeVolume(volume) {
      this.sound.volume = volume; // Actualizar el volumen base del slider
      // Recalcular el volumen del player según el tipo de contenido actual
      if (this.type === 'song' || this.type === 'videosong' || this.type === 'time') {
        this.player.volume = this.linearToLog(volume * this.sound.musicVolume);
      } else if (this.type === 'spot') {
        this.player.volume = this.linearToLog(volume * this.sound.spotsVolume);
      } else {
        this.player.volume = volume;
      }
      // Los audios a demanda se tratan como spots para volumen.
      this.applyAudioDemandaVolume();
      // Aplicar también al video si está reproduciéndose
      this.emitter.emit("video-changeVolume", this.player.volume);
      // console.log("changeVolume("+this.player.volume+")");
    },
    applyAudioDemandaVolume() {
      try {
        if (!this.playerAudioDemanda) return;
        this.playerAudioDemanda.volume = this.linearToLog(this.sound.volume * this.sound.spotsVolume);
      } catch (error) {
        console.log("No se pudo aplicar volumen a audio demanda:", error);
      }
    },
    getHighestSongQuality(song_id, song_file) {
      // post a la api para obtener la calidad mas alta de una cancion
      // console.log("getHighestSongQuality(" + song_id + ")");
      try {
        let url = "api/get_song_quality/";
        if (Capacitor.getPlatform() == 'ios' || Capacitor.getPlatform() == 'android') url = "https://panel.vybroo.net/get_song_quality_m";
        axios.post(url, {
          songId: song_id
        }, {
          headers: {
            'Access-Control-Allow-Origin': '*'
          }
        })
          .then(response => {
            // console.log("getHighestSongQuality() response: ", response);
            if (response.data.success == true && Array.isArray(response.data.quality) && response.data.quality.length > 0) {
              const mp3Candidates = response.data.quality.filter((item) => {
                if (!item) return false;
                const location = (item.location || '').toString().toLowerCase();
                const format = (item.format || item.file_type || '').toString().toLowerCase();
                // Blindaje: aceptar solo entradas de audio MP3 y descartar cualquier video.
                return location.includes('.mp3') || format.includes('mp3');
              });

              if (mp3Candidates.length > 0) {
                const parseBitrate = (value) => {
                  const parsed = parseInt((value ?? '').toString().trim(), 10);
                  return Number.isFinite(parsed) ? parsed : 0;
                };

                const bestMp3 = mp3Candidates.reduce((best, current) => {
                  return parseBitrate(current.bit_r) > parseBitrate(best.bit_r) ? current : best;
                }, mp3Candidates[0]);

                const bestBitrate = parseBitrate(bestMp3.bit_r);
                const bestLocation = bestMp3.location ? bestMp3.location : song_file;

                console.log("FIJANDO CALIDAD MP3 MÁS ALTA: " + bestBitrate);
                this.sound.quality = "mp3_320";
                this.sound.fileExtension = ".mp3";
                this.buildAudioUrl(bestLocation);
              } else {
                console.log("No se encontraron calidades MP3 válidas; usando fallback seguro MP3 320");
                this.sound.quality = "mp3_320";
                this.sound.fileExtension = ".mp3";
                this.buildAudioUrl(song_file);
              }
            } else {
              console.log("FIJANDO CALIDAD A 320")
              this.sound.quality = "mp3_320";
              this.sound.fileExtension = ".mp3";
              this.buildAudioUrl(song_file);
            }
          })
          .catch(error => {
            console.log("FIJANDO CALIDAD A 320")
            this.sound.quality = "mp3_320";
            this.sound.fileExtension = ".mp3";
            this.buildAudioUrl(song_file);
          });
      } catch (error) {
        console.log("getHighestSongQuality() error: ", error);
        console.log("FIJANDO CALIDAD A 320")
        this.sound.quality = "mp3_320";
        this.sound.fileExtension = ".mp3";
        this.buildAudioUrl(song_file);
      }
    },
    showQualityOptionsButton() {
      //mostrar menu contextual de opciones de calidad
      console.log("showQualityOptionsButton()");
      //opciones de calidad con el formato y bitrate oscurecidos, mostrando el seleccionado actualmente con radio button
      const options = [
        {
          title: "Calidad de audio",
          subTitle: "Selecciona la calidad de audio que deseas escuchar",
          text: "Bajo (M4A 32kb/s)",
          soundQuality: "m4a_32",
          handler: () => {
            this.sound.quality = "m4a_32";
            this.sound.fileExtension = ".m4a";
            this.buildAudioUrl();
            this.player.currentTime = this.sound.previousTime;
          }
        },
        {
          text: "Estándar (MP3 128kb/s)",
          soundQuality: "mp3_128",
          handler: () => {
            this.sound.quality = "mp3_128";
            this.sound.fileExtension = ".mp3";
            this.buildAudioUrl();
            this.player.currentTime = this.sound.previousTime;
          }
        },
        {
          text: "Superior (MP3 320kb/s)",
          soundQuality: "mp3_320",
          handler: () => {
            this.sound.quality = "mp3_320";
            this.sound.fileExtension = ".mp3";
            this.buildAudioUrl();
            this.player.currentTime = this.sound.previousTime;
          }
        },
        {
          text: "Cancelar",
          role: "cancel"
        }
      ];
      this.presentActionSheet(options);
    },
    async setNormalizeSongsMode(enabled) {
      this.normalizeSongsEnabled = !!enabled;
      const shouldBeOriginal = !this.normalizeSongsEnabled;
      if (this.type !== 'song' && this.type !== 'videosong') {
        this.isOriginalABMode = shouldBeOriginal;
        return;
      }
      if (this.abSwitchInProgress) return;
      if (this.isOriginalABMode === shouldBeOriginal) return;

      const isPlayingNow = !!(this.player && !this.player.paused && !this.player.ended);
      // Si está pausado, no hacemos hot-switch de source para evitar auto-play accidental.
      if (!isPlayingNow) {
        this.isOriginalABMode = shouldBeOriginal;
        return;
      }

      await this.toggleSongSourceAB();
    },
    sanitizeNormalizeStorageSegment(value) {
      const text = (value || '').toString().trim().toLowerCase();
      if (!text) return 'default';
      return text.replace(/[^a-z0-9_-]/g, '-');
    },
    getNormalizeSongsScope() {
      const streamRaw = (this.clientData && this.clientData.stream)
        ? this.clientData.stream
        : this.clientName;
      const linkRaw = (this.clientData && this.clientData.link)
        ? this.clientData.link
        : 'nolink';
      return {
        stream: this.sanitizeNormalizeStorageSegment(streamRaw),
        link: this.sanitizeNormalizeStorageSegment(linkRaw),
      };
    },
    buildNormalizeSongsPreferenceKey() {
      const scope = this.getNormalizeSongsScope();
      return `vybroo:normalizeSongs:${this.normalizeSongsPreferenceVersion}:${scope.stream}:${scope.link}`;
    },
    ensureNormalizeSongsPreferenceKey() {
      this.normalizeSongsPreferenceKey = this.buildNormalizeSongsPreferenceKey();
      return this.normalizeSongsPreferenceKey;
    },
    readNormalizeSongsPreferenceFromStorage() {
      if (!this.normalizeSongsPersistenceEnabled) return null;
      if (typeof window === 'undefined' || !window.localStorage) return null;
      try {
        const key = this.ensureNormalizeSongsPreferenceKey();
        const raw = window.localStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed === 'boolean') {
          return { enabled: parsed, updatedAt: 0 };
        }
        if (!parsed || typeof parsed.enabled !== 'boolean') return null;
        return {
          enabled: !!parsed.enabled,
          updatedAt: Number(parsed.updatedAt) || 0,
        };
      } catch (error) {
        console.log('No se pudo leer preferencia de normalizacion:', error);
        return null;
      }
    },
    saveNormalizeSongsPreferenceToStorage(enabled) {
      if (!this.normalizeSongsPersistenceEnabled) return;
      if (typeof window === 'undefined' || !window.localStorage) return;
      try {
        const key = this.ensureNormalizeSongsPreferenceKey();
        const payload = {
          enabled: !!enabled,
          updatedAt: Date.now(),
        };
        window.localStorage.setItem(key, JSON.stringify(payload));
        this.normalizeSongsPreferenceUpdatedAt = payload.updatedAt;
      } catch (error) {
        console.log('No se pudo guardar preferencia de normalizacion:', error);
      }
    },
    async applyNormalizeSongsPreference(enabled, options = {}) {
      const shouldPersist = !!options.persist;
      const shouldEmit = options.emit !== false;
      const updatedAt = Number(options.updatedAt) || Date.now();

      await this.setNormalizeSongsMode(!!enabled);
      this.normalizeSongsPreferenceUpdatedAt = Math.max(this.normalizeSongsPreferenceUpdatedAt, updatedAt);

      if (shouldPersist) {
        this.saveNormalizeSongsPreferenceToStorage(this.normalizeSongsEnabled);
      }
      if (shouldEmit) {
        this.emitter.emit("normalize-songs-setting", this.normalizeSongsEnabled);
      }
    },
    async initializeNormalizeSongsPreference() {
      const saved = this.readNormalizeSongsPreferenceFromStorage();
      if (saved && typeof saved.enabled === 'boolean') {
        await this.applyNormalizeSongsPreference(saved.enabled, {
          persist: false,
          emit: true,
          updatedAt: saved.updatedAt,
        });
        return;
      }

      await this.applyNormalizeSongsPreference(this.normalizeSongsDefaultEnabled, {
        persist: true,
        emit: true,
      });
    },
    handleNormalizeSongsStorageSync(event) {
      if (!this.normalizeSongsPersistenceEnabled) return;
      if (!event || !event.key) return;
      if (!this.normalizeSongsPreferenceKey) return;
      if (event.key !== this.normalizeSongsPreferenceKey) return;
      if (!event.newValue) return;

      try {
        const incoming = JSON.parse(event.newValue);
        if (!incoming || typeof incoming.enabled !== 'boolean') return;
        const incomingUpdatedAt = Number(incoming.updatedAt) || 0;
        if (incomingUpdatedAt && incomingUpdatedAt <= this.normalizeSongsPreferenceUpdatedAt) return;

        this.applyNormalizeSongsPreference(incoming.enabled, {
          persist: false,
          emit: true,
          updatedAt: incomingUpdatedAt,
        });
      } catch (error) {
        console.log('No se pudo sincronizar preferencia entre pestañas:', error);
      }
    },
    presentActionSheet(options) {
      console.log("presentActionSheet()");
      const actionSheet = document.createElement("ion-action-sheet");
      actionSheet.header = "Calidad de sonido";
      actionSheet.buttons = options;

      actionSheet.buttons.forEach((button, index) => {
        if (button.soundQuality == this.sound.quality) {
          //AGREGAR CLASE PARA QUE SE VEA SELECCIONADO
          button.cssClass = "action-sheet-selected";
        } else {
          button.cssClass = "";
        }
      });
      actionSheet.buttons.push({
        text: "Cancelar",
        role: "cancel"
      });
      document.body.appendChild(actionSheet);
      return actionSheet.present();
    },
    getSongPathForAB(url) {
      if (!url || typeof url !== 'string') return '';
      if (url.startsWith('blob:')) return '';
      let clean = url.split('?')[0].split('#')[0];
      clean = clean.replace(/^https?:\/\/[^/]+\//i, '');
      clean = clean.replace(/^\/+/, '');
      return clean;
    },
    toOriginalSongUrl(url) {
      const path = this.getSongPathForAB(url);
      if (!path) return '';
      let result = path;
      result = result.replace(/^mp3_320_norm\//i, 'mp3_320/');
      result = result.replace(/_norm\.mp3$/i, '.mp3');
      result = this.normalizeMediaPath(result);
      return 'https://media.vybroo.com/' + result;
    },
    toNormalizedSongUrl(url) {
      const path = this.getSongPathForAB(url);
      if (!path) return '';
      let result = path;
      result = result.replace(/^mp3_320\//i, 'mp3_320_norm/');
      result = result.replace(/\.m4a$/i, '.mp3');
      if (!/_norm\.mp3$/i.test(result)) result = result.replace(/\.mp3$/i, '_norm.mp3');
      result = this.normalizeMediaPath(result);
      return 'https://media.vybroo.com/' + result;
    },
    resolveOfflineStoreUrl(url, type) {
      if (!url || (type !== 'song' && type !== 'videosong')) return url;
      if (this.offlineSongsStoreNormalized) {
        return this.toNormalizedSongUrl(url) || url;
      }
      return this.toOriginalSongUrl(url) || url;
    },
    syncPlayUiState(isPlaying) {
      this.isPlaying = !!isPlaying;
      this.globalPlay = !!isPlaying;
      this.emitter.emit("rep-isPlaying", this.isPlaying);
      this.emitter.emit("rep-globalPlay", this.globalPlay);
    },
    getAlternateSongUrl(currentUrl) {
      if (!currentUrl || (this.type !== 'song' && this.type !== 'videosong')) return '';
      return this.isOriginalABMode
        ? this.toNormalizedSongUrl(currentUrl)
        : this.toOriginalSongUrl(currentUrl);
    },
    getABPlayableUrl(remoteUrl) {
      if (!remoteUrl) return '';
      return this.abBlobUrlByRemote[remoteUrl] || remoteUrl;
    },
    async cacheABUrl(remoteUrl) {
      // Se desactiva la caché en blob para evitar consumo de red oculto (doble descarga).
      // Solo retornamos la URL tal cual para que el audio se encargue de hacer el streaming.
      if (!this.enableOriginalABTest || !remoteUrl || remoteUrl.startsWith('blob:')) return '';
      return remoteUrl;
    },
    primeABAlternateSource(referenceUrl) {
      // Se desactiva la precarga agresiva para evitar doble consumo de ancho de banda.
      // El cambio de versión A/B dependerá del streaming normal del navegador.
      return;
    },
    async toggleSongSourceAB() {
      if (!this.enableOriginalABTest) return;
      if (this.abSwitchInProgress) return;
      if (this.type !== 'song' && this.type !== 'videosong') {
        await Toast.show({ text: 'AB solo aplica para canciones' });
        return;
      }

      const currentSource = this.playerAudioSource || (this.player && this.player.src ? this.player.src : '');
      if (!currentSource || currentSource.startsWith('blob:')) {
        await Toast.show({ text: 'AB no disponible para esta fuente' });
        return;
      }

      const normalizedUrl = this.toNormalizedSongUrl(currentSource);
      const originalUrl = this.toOriginalSongUrl(currentSource);
      if (!normalizedUrl || !originalUrl) {
        await Toast.show({ text: 'No se pudo construir URL AB' });
        return;
      }

      const wasPlaying = this.player && !this.player.paused;
      const currentTime = this.player && Number.isFinite(this.player.currentTime) ? this.player.currentTime : 0;
      const nextUrlRemote = this.isOriginalABMode ? normalizedUrl : originalUrl;
      const nextUrlPlayable = this.getABPlayableUrl(nextUrlRemote);

      this.abSwitchInProgress = true;
      this.isOriginalABMode = !this.isOriginalABMode;
      this.playerAudioSource = nextUrlRemote;
      const player = this.player;
      this.setPauseReason('ab-switch');
      player.pause();
      this.setPlayerSource(nextUrlPlayable, 'ab-switch');
      player.load();

      // Si aun no estaba en cache, arrancar cache ahora para siguientes toggles.
      this.cacheABUrl(nextUrlRemote);

      const applySeekAndResume = async () => {
        try {
          if (Number.isFinite(currentTime) && currentTime > 0) {
            player.currentTime = currentTime;
          }
          if (wasPlaying) {
            await player.play();
            this.syncPlayUiState(true);
          } else {
            this.syncPlayUiState(false);
          }
        } catch (error) {
          console.error('AB toggle play error:', error);
          this.syncPlayUiState(false);
        } finally {
          this.abSwitchInProgress = false;
        }
      };

      const onReady = () => {
        player.removeEventListener('loadedmetadata', onReady);
        player.removeEventListener('canplay', onReady);
        applySeekAndResume();
      };

      player.addEventListener('loadedmetadata', onReady, { once: true });
      player.addEventListener('canplay', onReady, { once: true });
      setTimeout(() => {
        if (this.abSwitchInProgress) onReady();
      }, 650);

      // En cuanto hacemos switch, precargamos el lado opuesto para el siguiente toque.
      this.primeABAlternateSource(nextUrlRemote);

      await Toast.show({ text: this.isOriginalABMode ? 'Modo ORIGINAL' : 'Modo NORMALIZADO' });
    },
    buildAudioUrl(fileToRebuild) {
      this.fileLocationReBuild(fileToRebuild);
      if (fileToRebuild) {
        fileToRebuild = fileToRebuild.startsWith("/a/") ? fileToRebuild.replace("/a/", "") : fileToRebuild;
        let split = fileToRebuild.split("/");
        //imprimir la ultima posición del array
        // console.log("Ultima posición del array: " + split[split.length - 1]);
        this.sound.legacyFile = split[split.length - 2] + "/" + split[split.length - 1];
        //Poner cada una de las palabras solo con la primera letra en mayúscula y el resto en minúscula
        let capitalized = split[split.length - 1].replace(/\w\S*/g, function (txt) { return txt.charAt(0).toLowerCase() + txt.substr(1).toLowerCase(); });
        //imprimir la ultima posición del array capitalizada
        // console.log("Ultima posición del array capitalizada: " + capitalized);
        //juntar las ultimas dos posiciones del array con un / entre medio e imprimirlo
        let stringFinal = split[split.length - 2] + "/" + capitalized;
        let stringFinalLegacy = this.sound.legacyFile;
        //eliminar la extensiòn del archivo
        stringFinal = stringFinal.replace(".mp3", "");
        stringFinal = stringFinal.replace(".m4a", "");
        stringFinalLegacy = stringFinalLegacy.replace(".mp3", "");
        stringFinalLegacy = stringFinalLegacy.replace(".m4a", "");

        // Codificar por segmento para evitar URLs inválidas como "%%".
        stringFinal = this.normalizeMediaPath(stringFinal);
        stringFinalLegacy = this.normalizeMediaPath(stringFinalLegacy);

        this.sound.legacyFile = stringFinalLegacy;
        this.sound.file = stringFinal;
        // console.log("String final: " + stringFinal);
        // console.log("String final legacy: " + stringFinalLegacy);
      }
      // console.log("this.sound.quality: " + this.sound.quality); 
      this.sound.quality == "m4a_32" ? this.sound.fileExtension = ".m4a" : "";
      this.sound.quality == "mp3_128" ? this.sound.fileExtension = ".mp3" : "";
      this.sound.quality == "mp3_320" ? this.sound.fileExtension = ".mp3" : "";

      // Construir URL normalizada solo para canciones.
      if (this.type == 'song' || this.type == 'videosong') {
        const normalizedFile = this.sound.file.endsWith('_norm') ? this.sound.file : this.sound.file + '_norm';
        this.sound.url = this.urlSongsApi + 'mp3_320_norm/' + normalizedFile + '.mp3';
        if (!this.normalizeSongsEnabled) {
          this.sound.url = this.toOriginalSongUrl(this.sound.url);
        }
      } else if (this.sound.quality == "m4a_32") {
        this.sound.url = this.urlSongsApi + "music/" + this.sound.legacyFile + ".m4a";
      } else {
        this.sound.url = this.urlSongsApi + this.sound.quality + "/" + this.sound.file + this.sound.fileExtension;
      }
      // console.log("this.sound.url: " + this.sound.url);
      console.log("Reproduciendo actualmente: " + this.title + " - " + this.artist);
      // Mantener modo alineado con el switch lateral de normalizacion.
      if (this.type == 'song' || this.type == 'videosong') this.isOriginalABMode = !this.normalizeSongsEnabled;
      this.playerAudioSource = this.sound.url;
      this.setPlayerSource(this.getABPlayableUrl(this.sound.url), 'source-change');
      this.cacheABUrl(this.sound.url);
      // Precargar en segundo plano la versión alterna para reducir latencia del switch AB.
      this.primeABAlternateSource(this.sound.url);
      // Aplicar volumen: slider manual × musicVolume con conversión logarítmica
      this.player.volume = this.linearToLog(this.sound.volume * this.sound.musicVolume);
      console.log("buildAudioUrl();");
      this.audioExistsDB(this.getStorageId(this.sound.url));
    },
    playIntro() {
      console.log("play() - INTRO");
      console.log("ES SONARA: " + this.sonara);
      if (this.sonara) {
        this.playerAudioSource = 'https://media.vybroo.com/intros/sonara_1.mp3';
        this.artist = "Sonara";
        console.log("Reproduciendo intro de Sonara");
      }else{
        this.playerAudioSource = 'https://media.vybroo.com/intros/intro_1.mp3';
        this.artist = "Vybroo";
        console.log("Reproduciendo intro de Vybroo");
      }

  this.setPlayerSource(this.playerAudioSource, 'source-change');
      this.token = -1;
      this.title = "Intro";
      this.audio_id = '0';
      this.type = "spot";
      this.emitter.emit("rep-token", this.token);
      this.emitter.emit("rep-title", this.title);
      this.emitter.emit("rep-artist", this.artist);
      this.emitter.emit("rep-type", this.type);
      console.log("playIntro();");
      this.play();
    },
    async loadApi(streamName) {
      try {
        if (this.networkStatus.connected == false) {
          console.log("Error de conexión, reintentando... (loadApi)", error);
          this.title = "Error de conexión";
          this.artist = "Reintentando...";
          this.audio_id = '0';
          this.emitter.emit("rep-title", this.title);
          this.emitter.emit("rep-artist", this.artist);
          /*setTimeout(() => {
            this.loadApi(this.clientData.stream);
          }, 2000);*/
          this.vBackNext();
        } else {
           console.log("cargando api del canal: " + streamName);
          await this.getApiRequestData();
          const intro_expired = await this.intro_expired();
          const dataParameters = { stream: streamName.toLowerCase(), token: this.token, cid: this.currentSucursal, music_variant: this.currentCategoria, variant: this.currentVariante, video: this.clientData.video_enabled };
           console.log("Parámetros loadApi:");
           console.log(dataParameters);
          await axios.post("https://vybroo.net/api", dataParameters)
            .then(data => {
              if (data.data) {

                if (this.clientData.video_enabled) {
                  // console.log("REPRODUCIENDO VIDEO INTRO");
                  if (this.sonara) {
                    this.showVideoModal('https://media.vybroo.com/videos/intros/sonaraelda.mp4');
                  } else {
                    this.showVideoModal('https://media.vybroo.com/videos/intros/vybrooelda.mp4');
                  }
                } else {
                  if (this.clientData.play_intro && intro_expired) {
                    // console.log("REPRODUCIENDO AUDIO INTRO");
                    this.playIntro();
                    return;
                  } else {
                    // console.log("REPRODUCIENDO CANCIÓN NORMAL");
                    if (this.clientData.play_intro == false) {
                      console.log("No se reproducirá intro porque está deshabilitado desde panel");
                    }
                  }
                  this.token = Number(data.data.token);
                  this.previousToken = Number(data.data.token);
                  console.log("TOKEN: " + this.token);
                  this.type = data.data.type;
                  // console.log("TYPE: " + this.type + " desde loadApi" );
                  this.title = data.data.title ? data.data.title : 'Cargando...';
                  this.bkTitle = data.data.title ? data.data.title : 'Cargando...';
                  this.audio_id = data.data.id ? data.data.id : '0';
                  this.tags = data.data.tags ? data.data.tags : '';
                  this.formula = data.data.formula ? data.data.formula : '';
                  this.filter = data.data.filter ? data.data.filter : '';
                  this.emitter.emit("rep-token", this.token);
                  this.emitter.emit("rep-title", this.title);
                  this.emitter.emit("rep-type", this.type);
                  this.emitter.emit("rep-artist", this.artist);
                  if (data.data.type != 'video') {

                    if (this.sonara) {
                      this.artist = data.data.artist ? data.data.artist : 'Sonara';
                      this.bkArtist = data.data.artist ? data.data.artist : 'Sonara';
                    } else {
                      this.artist = data.data.artist ? data.data.artist : 'Vybroo';
                      this.bkArtist = data.data.artist ? data.data.artist : 'Vybroo';
                    }
                    this.location = data.data.file;
                    if (data.data.type == 'time') {
                      this.playerAudioSource = this.getTimeFile();
                      this.title = 'Hora';
                      this.artist = 'Vybroo';
                      this.audio_id = '0';
                      this.setPlayerSource(this.playerAudioSource, 'source-change');
                    }
                    //si data.data.file comienza con "/a/" borrar eso y dejar solo el "/audios/..."
                    if (data.data.type == 'song' || data.data.type == 'videosong') {
                      console.log("Reproduciendo canción...");
                      if (data.data.id) { this.getHighestSongQuality(data.data.id, data.data.file) }
                    }
                    if (data.data.type == 'spot') {
                      console.log("Reproduciendo spot...");
                      // Usar CDN en lugar del servidor para spots
                      let spotPath = (data.data.file).replace(/ /g, "%20");
                      // Remover /a/ del inicio si existe
                      if (spotPath.startsWith('/a/')) {
                        spotPath = spotPath.substring(3);
                      }
                      this.playerAudioSource = this.cdnBaseUrl + spotPath;
                      this.setPlayerSource(this.playerAudioSource, 'source-change');
                      this.player.filter = data.data.category ? data.data.category : 's';
                    }
                    this.emitter.emit("rep-title", this.title);
                    this.emitter.emit("rep-artist", this.artist);
                    // this.playerAudioSource = 'https://vybroo.net' + (data.data.file).replace(/ /g,"%20");
                    // console.log(this.playerAudioSource);
                    // Aplicar volumen: slider manual × musicVolume/spotsVolume con conversión logarítmica
                    if (this.type === 'song' || this.type === 'videosong' || this.type === 'time') {
                      this.player.volume = this.linearToLog(this.sound.volume * this.sound.musicVolume);
                    } else if (this.type === 'spot') {
                      this.player.volume = this.linearToLog(this.sound.volume * this.sound.spotsVolume);
                    } else {
                      this.player.volume = this.sound.volume;
                    }
                    this.player.preload = "auto";
                  } else { // ES VIDEO
                    /*this.filter = data.data.category ? data.data.category : ''; 
                    this.playerAudioSource = 'https://vybroo.net/videos/' + (data.data.file).replace(/ /g, "%20");
                    this.emitter.emit("rep-VideoSource", this.playerAudioSource);*/
                    
                    this.filter = data.data.category ? data.data.category : '';
                    this.playerAudioSource = 'https://media.vybroo.com/videos/' + (data.data.file).replace(/ /g, "%20");
                    this.videoExistsDB(this.playerAudioSource);
                  

                  }

                }
                //enviar a endpoint de telegram
                this.sendStats();
                // this.getTimeFile();
              } else {
                this.presentAlertConfirm("Error", "La lista de canciones está vacía, favor de contactar a su asesor en caso de que el error persista.");
              }
            })
            .catch(error => {
              if (this.enLinea == 2) {
                console.log("Error de conexión, reintentando... (loadApi)", error);
                this.title = "Error de conexión";
                this.artist = "Reintentando...";
                this.audio_id = '0';
                this.emitter.emit("rep-title", this.title);
                this.emitter.emit("rep-artist", this.artist);
                setTimeout(() => {
                  //this.loadApi(this.clientData.stream);
                }, 2000);
              }
              console.error("Error en loadApi:", error.toString());
              this.sendErrorReport("loadApi(axios)", error.toString());
              this.vBackNext();
            });
        }
      } catch (e) {
        this.presentAlertConfirm("Error en la función loadApi", e.toString());
        this.sendErrorReport("loadApi", e.toString());
      }
    },
    async sendErrorReport(funcion, error) {
      
      if (this.networkStatus.connected == false){// return si no tengo internet
        console.error("sendErrorReport :: omitido - No tengo internet::C");
        return;
      }
      if (this.enLinea == 2) {// return si no tengo internet
        console.error("sendErrorReport :: omitido - No tengo internet::L");
        return;
      }
      try {
        // const ip = await axios.get("https://api.ipify.org/?format=json");
        const zonaHoraria = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const zonaHorariaG = zonaHoraria.replace(/\//g, "-");
        if (this.horaActual == "") {
          const horaServer = await axios.get('/api/hora/' + zonaHorariaG);
          this.horaActual = horaServer.data.hora ? horaServer.data.hora = horaServer.data.hora : horaServer.data.hora = "No disponible";
        }

        const identifier_name = this.clientData.identifiers.find(item => item.id === this.currentSucursal);
        const identifier = identifier_name ? identifier_name.identifier : undefined;

        const music_variant_name = this.clientData.music_variants.find(item => item.id === this.currentCategoria);
        const music_variant = music_variant_name ? music_variant_name.name : undefined;

        const is_localhost_message = window.location.href.includes("localhost") ? "LOCALHOST:" : null;
        const message =
          (is_localhost_message ? is_localhost_message : "") + "\n" +
          "Error en: " + funcion + "\n" +
          "Error: " + JSON.stringify(error) + "\n" +
          "Canal: " + this.clientData.stream + "\n" +
          "Token: " + this.token + "\n" +
          "ID Sucursal: " + (this.currentSucursal != '' ? this.currentSucursal : 'Sin selección') + "\n" +
          "ID Categoría musical: " + this.currentCategoria + "\n" +
          "ID Variante de contenido: " + this.currentVariante + "\n" +
          "Zona Horaria: " + zonaHoraria + "\n" +
          "Hora local: " + this.horaActual + "\n" +
          "Navegador/OS: " + navigator.userAgent + "\n" +
          "Versión de App: " + this.updateInfo + "\n" +
          "Device ID: " + this.getOrCreateDeviceId() + "\n" +
          "Session ID: " + this.getOrCreateSessionId() + "\n" +
          "URL: " + window.location.href;
        // "IP: " + ip.data.ip;

        const uniqueMessage =
          (is_localhost_message ? is_localhost_message : "") + "\n" +
          "Error en: " + funcion + "\n" +
          "Error: " + JSON.stringify(error) + "\n" +
          "Canal: " + this.clientData.stream + "\n" +
          "Token: " + this.token + "\n" +
          "ID Sucursal: " + (this.currentSucursal != '' ? this.currentSucursal : 'Sin selección') + "\n" +
          "ID Categoría musical: " + this.currentCategoria + "\n" +
          "ID Variante de contenido: " + this.currentVariante + "\n" +
          "Zona Horaria: " + zonaHoraria + "\n" +
          "Navegador/OS: " + navigator.userAgent + "\n" +
          "Versión de App: " + this.updateInfo;

        if (this.errorReport.uniqueMessage != uniqueMessage) {
          this.errorReport.errorCount = 0; //resetear el contador de errores
        } else {
          this.errorReport.errorCount++; //incrementar el contador de errores
        }
        this.errorReport.uniqueMessage = uniqueMessage;



        //esperar a que se carguen los datos de message
        await new Promise(r => setTimeout(r, 1000));
        // console.log(message);


        // const messageJson = {
        //   "tipo": "error",
        //   "error": error,
        //   "funcion": funcion,
        //   "canal": this.clientData.stream,
        //   "token": this.token,
        //   "sucursal_id": this.currentSucursal,
        //   "categoria_id": this.currentCategoria,
        //   "variante_id": this.currentVariante,
        //   "zona_horaria": zonaHoraria,
        //   "hora_local": horaServer.data.hora,
        //   "ip": ip.data.ip,
        //   "navegador": navigator.userAgent
        // }
        // console.log(messageJson);
        if (this.errorReport.errorCount < 3) {
          console.log("Enviando reporte de error a Telegram...");
          // console.log(message);

          const dataParameters = {
            chat: '-1001908685177',
            text: message,
          };

          await axios.post('/api/sendmessage', dataParameters)
            .then(response => {
              if (response.data.stat == "error") {
                console.error("Error al enviar mensaje de error a Telegram:", response.data.stat, response.data.stat_message);
              } else {
                console.log("Mensaje de error enviado a Telegram", response);
              }
            })
            .catch(error => {
              console.error("Error al enviar mensaje de error a Telegram:", error.toString());
            });
        } else {
          console.log("No se envió el reporte de error a Telegram porque ya se habían enviado 3 reportes del mismo error");
        }
      } catch (e) {
        console.error("Error en sendErrorReport:", e.toString());
      }
    },
    async sendStats() {
      try {
        //calcular dirección IP
        // const ip = await axios.get("https://api.ipify.org/?format=json");
        const zonaHoraria = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const zonaHorariaG = zonaHoraria.replace(/\//g, "-");
        if (this.horaActual == "") {
          const horaServer = await axios.get('/api/hora/' + zonaHorariaG);
          this.horaActual = horaServer.data.hora ? horaServer.data.hora = horaServer.data.hora : horaServer.data.hora = "No disponible";
        }

        // horaServer.data.hora?horaServer.data.hora = horaServer.data.hora:horaServer.data.hora = "No disponible";
        // console.log("Hora en sendStats: " + horaServer.data.hora);
        // ip.data.ip?"":ip.data.ip = "No disponible";

        const dataParameters = {
          chat: '-715319368',
          text: "| Canal: " + this.clientData.stream +
            " | TOKEN: " + this.token +
            " | ID de sucursal: " + this.currentSucursal +
            " | Categoría musical: " + this.currentCategoria +
            " | Variante de contenido: " + this.currentVariante +
            " | Version de App: " + this.updateInfo +
            " | Navegador/OS: " + navigator.userAgent + "\n" +
            " | Hora local: " + this.horaActual +
            " | Zona horaria: " + zonaHoraria +
            // " | IP: " + ip.data.ip +
            " |"
        };
        // console.log("Parámetros sendStats:");
        // console.log(dataParameters);
        await axios.post("/api/sendmessage", dataParameters)
          .then(data => {
            console.log("%cStats enviados ✅", "color: green; font-weight: bold; background-color: #eee; padding: 5px; border-radius: 5px; font-size: 14px; border: 2px solid green;");
          })
          .catch(error => {
            console.error("Error en sendStats:", error.toString());
          });
      } catch (e) {
        console.error("Error en la función sendStats", e.toString());
        this.sendErrorReport("sendStats", e.toString());
      }
    },
    async getServerTime() {
      try {
        const zonaHoraria = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const zonaHorariaG = zonaHoraria.replace(/\//g, "-");
        // console.log("Zona horaria en getServerTime: " + zonaHorariaG);
        const horaServer = await axios.get('/api/hora/' + zonaHorariaG);
        horaServer.data.hora ? horaServer.data.hora = horaServer.data.hora : horaServer.data.hora = "Hora no disponible";
        //guardarlo en formato h:mm:ss a
        this.horaServer = horaServer.data.hora;

        // console.log("Hora del servidor desde tabReproductor: " + this.horaServer);
        return Promise.resolve(this.horaServer);
      } catch (e) {
        setTimeout(() => {
          this.getServerTime();
        }, 60 * 1000);
        console.error("Error en la función getServerTime", e.toString());
        this.sendErrorReport("getServerTime", e.toString());
      }
    },
    async getTimeFile() {
      try {
        this.playerAudioSource = "";
        this.pause('source-change');
        this.horaServer = await this.getServerTime();

        // // guardar la hora menor en una variable
        // if (this.horaServer < this.horaLocal){
        //   this.horaMenor = this.horaServer;
        // } else {
        //   this.horaMenor = this.horaLocal;
        // }
        // console.log("Hora menor: " + this.horaMenor);

        if (this.horaServer == "No disponible" || this.horaServer == "" || this.horaServer == null) {
          console.log("No se pudo obtener la hora del servidor");
          var message = (
            "No se pudo obtener la hora del servidor" +
            "\n Canal: " + this.clientData.stream +
            "\n Hora local: " + horaServer.data.hora +
            "\n Versión del cliente: " + this.updateInfo
          )
          console.error("enviando mensaje de error..." + message);
          this.sendReport(message);
          return;
        }

        //calcular horas y minutos de hora del servidor
        var hora = this.horaServer.split(":")[0];
        var minutos = this.horaServer.split(":")[1];
        var current = new Date(0, 0, 0, hora, minutos, 0, 0);
        console.log("Hora del Date: " + current.toString());
        var fileCalc = (current.getHours() * 60 + current.getMinutes()) % 720;
        var timeFile = 'https://vybroo.net/a/music/Time/' + fileCalc + '.m4a';
        console.log("Solicitando audio de hora para las: " + current.getHours() + ":" + current.getMinutes() + " Archivo:" + timeFile)
        var message = (
          "Solicitud de hora nueva:" +
          "\n Canal: " + this.clientData.stream +
          "\n Hora server/local: " + this.horaServer +
          "\n Versión del cliente: " + this.updateInfo +
          "\n Archivo audio hora: " + timeFile
        );
        console.log(message);
        this.sendReport(message);
        // console.log(timeFile);
        this.playerAudioSource = timeFile;
        this.setPlayerSource(this.playerAudioSource, 'source-change');
        return timeFile;
      } catch (e) {
        console.error("Error en la función getTimeFile", e.toString());
        this.sendErrorReport("getTimeFile", e.toString());
      } finally {
        console.log("getTimeFile() finalizado");
        this.play();
      }
    },

    async sendReport(message) {
      try {
        const dataParameters = { text: message };
        console.log("Enviando mensaje: " + message);
        await axios.post("/api/sendmessage", dataParameters)
          .then(data => {
            if (data.data.stat == "ok") {
              console.log(data.data.stat_message);
            } else {
              console.error("error en la función SendReport");
            }
          })
          .catch(error => {
            console.error("error en la función axios.post de SendReport - ", error);
          });
      } catch (e) {
        console.error("Error en la función sendReport", e.toString());
      }
    },

    getOrCreateDeviceId() {
      const key = 'vybroo:device_id';
      try {
        let id = window.localStorage.getItem(key);
        if (!id) {
          id = 'dev_' + this.generateUUID();
          window.localStorage.setItem(key, id);
        }
        return id;
      } catch (e) {
        console.debug('localStorage no disponible para device_id, usando volátil');
        return 'dev_mem_' + this.generateUUID();
      }
    },

    getOrCreateSessionId() {
      const key = 'vybroo:session_id';
      try {
        let id = sessionStorage.getItem(key);
        if (!id) {
          id = 'sess_' + this.generateUUID();
          sessionStorage.setItem(key, id);
        }
        return id;
      } catch (e) {
        console.debug('sessionStorage no disponible para session_id, usando volátil');
        return 'sess_mem_' + this.generateUUID();
      }
    },

    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    /**
     * Genera un hash SHA-256 a partir de un canvas invisible.
     * Este hash es estable por hardware + navegador (mismo GPU, drivers, OS = mismo hash).
     * Se cachea en localStorage para no regenerarlo en cada heartbeat.
     */
    async generateCanvasFingerprint() {
      // Cache en memoria (funciona incluso sin localStorage, incógnito, etc.)
      if (this._canvasHashCache) return this._canvasHashCache;

      try {
        // Intentar usar el caché persistente primero
        const cached = window.localStorage.getItem('vybroo:canvas_hash');
        if (cached && (cached.length === 64 || cached.length === 16)) {
          this._canvasHashCache = cached;
          return cached;
        }
      } catch (e) {
        // localStorage no disponible
      }

      try {
        const canvas = document.createElement('canvas');
        canvas.width = 200;
        canvas.height = 50;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          this._canvasHashCache = '';
          return '';
        }

        ctx.textBaseline = 'top';
        ctx.font = '14px Arial';
        ctx.fillStyle = '#f60';
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = '#069';
        ctx.fillText('Vybroo', 2, 15);
        ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
        ctx.fillText('Canvas', 4, 30);

        const dataUrl = canvas.toDataURL();
        const hash = await this.sha256(dataUrl);

        this._canvasHashCache = hash;
        try {
          if (hash) window.localStorage.setItem('vybroo:canvas_hash', hash);
        } catch (e) {}

        return hash;
      } catch (e) {
        console.warn('Canvas fingerprint no disponible:', e);
        this._canvasHashCache = '';
        return '';
      }
    },

    /**
     * SHA-256 usando Web Crypto API (disponible en todos los navegadores modernos).
     */
    async sha256(str) {
      // SHA-256 via Web Crypto API (requiere HTTPS o localhost)
      try {
        if (typeof crypto !== 'undefined' && crypto.subtle && crypto.subtle.digest) {
          const encoder = new TextEncoder();
          const data = encoder.encode(str);
          const hashBuffer = await crypto.subtle.digest('SHA-256', data);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        }
      } catch (e) {
        console.warn('SHA-256 no disponible, usando fallback:', e);
      }
      // Fallback: hash rápido FNV-1a para entornos HTTP no seguros
      return this.fnv1aHash(str);
    },

    /**
     * Hash FNV-1a de 64 bits (fallback para entornos sin crypto.subtle).
     * Rápido, determinista, suficiente para fingerprinting.
     */
    fnv1aHash(str) {
      let hash = 0x811c9dc5;
      for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
      }
      // Convertir a hex de 64 bits
      const hex = (hash >>> 0).toString(16).padStart(8, '0');
      // Segunda pasada para mayor longitud
      let hash2 = 0x811c9dc5;
      for (let i = str.length - 1; i >= 0; i--) {
        hash2 ^= str.charCodeAt(i);
        hash2 = Math.imul(hash2, 0x01000193);
      }
      const hex2 = (hash2 >>> 0).toString(16).padStart(8, '0');
      return hex + hex2;
    },

    /**
     * Recolecta metadatos del navegador/dispositivo.
     * No incluye canvas_hash (se genera aparte).
     */
    getBrowserMetadata() {
      return {
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        platform: typeof navigator !== 'undefined' ? (navigator.platform || '') : '',
        language: typeof navigator !== 'undefined' ? (navigator.language || '') : '',
        timezone: typeof Intl !== 'undefined' ? Intl.DateTimeFormat().resolvedOptions().timeZone : '',
        screen_resolution: typeof screen !== 'undefined' ? screen.width + 'x' + screen.height : '',
        device_pixel_ratio: typeof screen !== 'undefined' ? (window.devicePixelRatio || 0) : 0,
        cpu_cores: (typeof navigator !== 'undefined' && navigator.hardwareConcurrency) ? navigator.hardwareConcurrency : 0,
        device_memory: (typeof navigator !== 'undefined' && navigator.deviceMemory) ? navigator.deviceMemory : 0,
        connection_type: (typeof navigator !== 'undefined' && navigator.connection && navigator.connection.effectiveType) ? navigator.connection.effectiveType : '',
      };
    },

    async reportAutoResumeSuccess() {
      try {
        // Solo reportar si efectivamente se usó auto-resume
        if (this.pauseRetryAttempts <= 0) return;

        const message =
          "🔄 AUTO-RESUME EXITOSO\n" +
          "======================\n" +
          "Link: " + this.clientData.link + "\n" +
          "Stream: " + this.clientData.stream + "\n" +
          "Token: " + this.token + "\n" +
          "Razón de pausa: " + this.lastPauseReason + "\n" +
          "Intentos para recuperar: " + this.pauseRetryAttempts + "\n" +
          "Tipo de contenido: " + this.type + "\n" +
          "Título: " + this.title + "\n" +
          "Artista: " + this.artist + "\n" +
          "Navegador/OS: " + navigator.userAgent + "\n" +
          "Versión de App: " + this.updateInfo;

        console.log("%c✅ Reporte de auto-resume enviado", "color: green; font-weight: bold;");
        await this.sendReport(message);
      } catch (e) {
        console.error("Error en reportAutoResumeSuccess:", e.toString());
        // No abortar por error en reporte, silenciar para no afectar reproducción
      }
    },

    // ==========================================
    // MEJORAS DE ROBUSTEZ
    // ==========================================

    // FASE 1a: stalled timeout - avanzar pista si el buffer se congela 15s
    addPlayerStalledHandler() {
      try {
        if (!this.player) return;
        this.player.addEventListener("stalled", () => {
          if (!this.isPlaying || !this.globalPlay || this.type === 'video') return;
          console.warn("stalled: buffer congelado, timeout 15s");
          this.isWaitingForData = true;
          if (this.playerStalledTimer) clearTimeout(this.playerStalledTimer);
          this.playerStalledTimer = setTimeout(() => {
            this.playerStalledTimer = null;
            if (this.isWaitingForData && this.isPlaying && !this.player.ended) {
              console.warn("stalled 15s - forzando next");
              this.isWaitingForData = false;
              this.next();
            }
          }, 15000);
        });
      } catch (e) {
        console.error("addPlayerStalledHandler:", e);
      }
    },
    removePlayerStalledHandler() {
      if (this.playerStalledTimer) {
        clearTimeout(this.playerStalledTimer);
        this.playerStalledTimer = null;
      }
    },

    // FASE 1b: waiting event - marcar buffering
    addPlayerWaitingHandler() {
      try {
        if (!this.player) return;
        this.player.addEventListener("waiting", () => {
          if (!this.isPlaying || !this.globalPlay || this.type === 'video') return;
          this.isWaitingForData = true;
        });
      } catch (e) {
        console.error("addPlayerWaitingHandler:", e);
      }
    },
    removePlayerWaitingHandler() {},

    // FASE 1c: canplay - buffer recuperado, limpiar stalled
    addPlayerCanPlayHandler() {
      try {
        if (!this.player) return;
        this.player.addEventListener("canplay", () => {
          if (this.isWaitingForData) {
            this.isWaitingForData = false;
          }
          if (this.playerStalledTimer) {
            clearTimeout(this.playerStalledTimer);
            this.playerStalledTimer = null;
          }
        });
      } catch (e) {
        console.error("addPlayerCanPlayHandler:", e);
      }
    },
    removePlayerCanPlayHandler() {},

    // FASE 4: online/offline listeners
    addNetworkListeners() {
      if (typeof window === 'undefined' || this.networkListenersRegistered) return;
      try {
        // Almacenar referencias de handlers como propiedades de instancia para poder removerlas
        this._onOnlineHandler = () => {
          this.enLinea = 1;
          console.log(new Date().toLocaleTimeString() + " Red recuperada, reintentando play si aplica");
          this.disconnectStartAt = null;
          deviceLogger.log('connection_change', { from: false, to: true }, {
            device_id: this.getOrCreateDeviceId(),
            session_id: this.getOrCreateSessionId(),
            version: this.clientVersion,
          });
          if (this.globalPlay && this.playerAudioSource && !this.isPlaying && !this.userPaused) {
            this.play('network-recovered');
          }
        };
        this._onOfflineHandler = () => {
          this.enLinea = 2;
          console.warn(new Date().toLocaleTimeString() + " Red perdida, enLinea=2");
          if (!this.disconnectStartAt) {
            this.disconnectStartAt = Date.now();
          }
          deviceLogger.log('connection_change', { from: true, to: false }, {
            device_id: this.getOrCreateDeviceId(),
            session_id: this.getOrCreateSessionId(),
            version: this.clientVersion,
          });
        };
        window.addEventListener('online', this._onOnlineHandler);
        window.addEventListener('offline', this._onOfflineHandler);
        this.networkListenersRegistered = true;
      } catch (e) {
        console.error("addNetworkListeners:", e);
      }
    },
    removeNetworkListeners() {
      if (typeof window === 'undefined' || !this.networkListenersRegistered) return;
      try {
        if (this._onOnlineHandler) {
          window.removeEventListener('online', this._onOnlineHandler);
        }
        if (this._onOfflineHandler) {
          window.removeEventListener('offline', this._onOfflineHandler);
        }
        this.networkListenersRegistered = false;
        this._onOnlineHandler = null;
        this._onOfflineHandler = null;
      } catch (e) {
        console.error("removeNetworkListeners:", e);
      }
    },

    play(playTrigger = 'manual') {
      try {
        // Reset userPaused al iniciar reproducción (por si venía de una pausa previa)
        this.userPaused = false;
        const isAutoRetry = typeof playTrigger === 'string' && playTrigger.indexOf('auto-retry') === 0;

        if (this.autoplayBlocked && isAutoRetry) {
          // Evitar reintentos automáticos en bucle hasta detectar interacción de usuario.
          return;
        }

        if (this.playRequestInFlight) {
          return;
        }

        if (!isAutoRetry) {
          this.stopAutoResumeLoop('play-manual-attempt');
        }

        if (this.playingAudioDemanda) this.killAudioDemanda();
        if (this.muted) {
          this.player.volume = this.unmutedVolume;
          this.muted = false;
          this.emitter.emit("rep-muted", this.muted);
          // if(!this.isPlaying)this.player.play();
        } else {
          if (this.playerAudioSource == "" && this.playerError == false) {
            // this.pause();
            // this.errorNext();
            if (this.token == NaN || isNaN(this.token) || this.token == undefined || this.token == null || this.token == "") {
              console.log("No hay audio source, dando next desde play()...");

              this.token = -1;
              this.errorNext();
            }
            return;

          } else {
            if (this.type != "video") {
              if (this.player && typeof this.player.play === 'function') {
                try {
                  this.playRequestInFlight = true;
                  const playPromise = this.player.play();
                  if (playPromise && typeof playPromise.then === 'function') {
                    playPromise.then(() => {
                      this.lastContentFailureToken = null;
                      this.syncPlayUiState(true);
                      this.onPlaybackStarted('play-success');
                    }).catch(error => {
                      if (this.isAbortPlaybackError(error)) {
                        console.log("Reproducción interrumpida (AbortError), la fuente pudo cambiar durante play().");
                        return;
                      }

                      this.syncPlayUiState(false);
                      console.log("Error al intentar reproducir audio: " + error + "");
                      console.log(error)
                      // si el error comienza por "NotAllowedError" es porque el autoplay está bloqueado, pausar
                      if (error.toString().startsWith("NotAllowedError")) {
                        console.log("PAUSANDO POR AUTOPLAY BLOQUEADO");
                        this.setAutoplayBlocked(error.toString());
                        this.pause('autoplay-blocked');
                        return;
                      }
                      if (this.isNotSupportedPlaybackError(error)) {
                        console.log("NO SE ENCONTRÓ EL ARCHIVO DE AUDIO, DANDO NEXT ON ERROR...");
                        this.sendErrorReport("play", "ARCHIVO DE AUDIO DAÑADO: " + this.playerAudioSource);
                        this.advanceTokenAfterContentFailure('play-not-supported');
                        this.errorNext();
                        return;
                      }
                      // this.pause();
                    }).finally(() => {
                      this.playRequestInFlight = false;
                    });
                  } else {
                    this.playRequestInFlight = false;
                    this.lastContentFailureToken = null;
                    this.syncPlayUiState(true);
                    this.onPlaybackStarted('play-sync-success');
                  }
                } catch (e) {
                  console.error("ha ocurrido un error en la función play().catch - " + e);
                  this.playRequestInFlight = false;
                  this.syncPlayUiState(false);
                  // this.presentAlertConfirm("Error en la función play(catch)",e.toString());
                }
              } else {
                console.error('No se puede reproducir el audio: this.player.play no está definido');
                this.playRequestInFlight = false;
                console.log(this.player.play.catch);
                this.presentAlertConfirm("Error al reproducir audio", "Ha ocurrido un error al reproducir el audio, por favor recargue la página. Si el error persiste contacte a su asesor.");
                this.syncPlayUiState(false);
                this.pause('manual-pause');
                return;
              }
            }
          }
        }
      } catch (e) {
        console.error("ha ocurrido un error play - " + e);
        this.playRequestInFlight = false;
        this.syncPlayUiState(false);
        // this.presentAlertConfirm("Error en la función play",e.toString());
        if (e !== "TypeError: this.player.play is not a function")
          this.sendErrorReport("play", e.toString());
        else
          console.error("No enviando mensaje de error");
      }
    },
    vBackPlay() {
      console.log("this.vBackToken: " + this.vBackToken);
      try {
        if (this.playingAudioDemanda) this.killAudioDemanda();
        if (this.muted) {
          this.player.volume = this.unmutedVolume;
          this.muted = false;
          this.emitter.emit("rep-muted", this.muted);
          // if(!this.isPlaying)this.player.play();
        } else {
          if (this.playerAudioSource == "" && this.playerError == false) {
            // this.pause();
            // this.errorNext();
            if (this.vBackToken == NaN || isNaN(this.vBackToken) || this.vBackToken == undefined || this.vBackToken == null || this.vBackToken == "") {
              console.log("No hay audio source, dando next desde vBackPlay()...");
              this.vBackNext();
            }
            return;

          } else {
            if (this.vBackList[this.vBackToken].type != "video") {
                this.playerAudioSource = this.playerAudioSource.startsWith("/a/") ? this.playerAudioSource.replace("/a/", "") : this.playerAudioSource;

                if (this.vBackList[this.vBackToken].type == "song" || this.vBackList[this.vBackToken].type == "videosong") {
                  //https://media.vybroo.com/mp3_320_norm/E/ameritz%20spanish%20karaoke%20-%20frente%20a%20frente%20(in%20the%20style%20of%20enrique%20bunbury)%20%5Bkaraoke%20version%5D_norm.mp3
                  //   music/C/CALONCHO - De día bien.m4a
                  this.playerAudioSource = this.playerAudioSource.startsWith("/a/") ? this.playerAudioSource.replace("/a/", "") : this.playerAudioSource;
                  let split = this.playerAudioSource.split("/");
                  let capitalized = split[split.length - 1].replace(/\w\S*/g, function (txt) { return txt.charAt(0).toLowerCase() + txt.substr(1).toLowerCase(); });
                  let stringFinal = split[split.length - 2] + "/" + capitalized;
                  stringFinal = stringFinal.replace(".m4a", ".mp3");
                  stringFinal = stringFinal.replace(/\.mp3$/i, '_norm.mp3');
                  stringFinal = this.normalizeMediaPath(stringFinal);
                  this.playerAudioSource = 'mp3_320_norm/' + stringFinal;
                }


              if (this.player && typeof this.player.play === 'function') {
                try {
                  this.playerAudioSource = 'https://media.vybroo.com/' + this.playerAudioSource;
                  // console.log("this.playerAudioSource2: " + this.playerAudioSource);
                  // console.log("===============================================");
                  this.setPlayerSource(this.playerAudioSource, 'source-change');
                  const playPromise = this.player.play();
                  if (playPromise && typeof playPromise.then === 'function') {
                    playPromise.then(() => {
                      this.syncPlayUiState(true);
                      this.onPlaybackStarted('vBackPlay-success');
                    }).catch(error => {
                      if (this.isAbortPlaybackError(error)) {
                        console.log("Reproducción interrumpida (AbortError) en vBackPlay(), la fuente pudo cambiar.");
                        return;
                      }

                      this.syncPlayUiState(false);
                      console.log("Error al intentar reproducir audio en vBack: " + error + "");
                      console.log(error)
                      // si el error comienza por "NotAllowedError" es porque el autoplay está bloqueado, pausar
                      if (error.toString().startsWith("NotAllowedError")) {
                        console.log("PAUSANDO POR AUTOPLAY BLOQUEADO");
                        this.setAutoplayBlocked(error.toString());
                        this.pause('autoplay-blocked');
                        return;
                      }
                      if (this.isNotSupportedPlaybackError(error)) {
                        console.log("NO SE ENCONTRÓ EL ARCHIVO DE AUDIO, DANDO NEXT ON ERROR...");
                        this.sendErrorReport("vBackPlay", "ARCHIVO DE AUDIO DAÑADO: " + this.playerAudioSource);
                        this.vBackNext();
                        return;
                      }
                      // this.pause();
                    });
                  } else {
                    this.syncPlayUiState(true);
                    this.onPlaybackStarted('vBackPlay-sync-success');
                  }
                } catch (e) {
                  console.error("ha ocurrido un error en la función play().catch - " + e);
                  this.syncPlayUiState(false);
                  // this.presentAlertConfirm("Error en la función play(catch)",e.toString());
                }
              } else {
                console.error('No se puede reproducir el audio: this.player.play no está definido');
                console.log(this.player.play.catch);
                this.presentAlertConfirm("Error al reproducir audio", "Ha ocurrido un error al reproducir el audio, por favor recargue la página. Si el error persiste contacte a su asesor.");
                this.syncPlayUiState(false);
                this.pause('manual-pause');
                return;
              }
            }else{
              try {
                  this.playerAudioSource = 'https://media.vybroo.com/videos/' + (data.data.file).replace(/ /g, "%20");
                  //this.pause();
                  if (this.videoOn == false) {
                    this.showVideoModal(this.playerAudioSource);
                  } else {
                    this.emitter.emit("rep-VideoSource", this.playerAudioSource);
                  }
                } catch (error) {
                  console.log("Error en nextApiRequest - video - NEXTEMIT", error);
                  this.sendErrorReport("nextApiRequest - video - NEXTEMIT", error);
                }
            }
          }
        }
      } catch (e) {
        console.error("ha ocurrido un error play - " + e);
        this.syncPlayUiState(false);
        // this.presentAlertConfirm("Error en la función play",e.toString());
        if (e !== "TypeError: this.player.play is not a function")
          this.sendErrorReport("play", e.toString());
        else
          console.error("No enviando mensaje de error");
      }
    },
    pause(reason = 'manual-pause') {
      try {
        this.setPauseReason(reason);
        this.stopAutoResumeLoop('pause-explicita');
        this.userPaused = (reason === 'user-click' || reason === 'manual-pause');
        if (!this.muted) {
          // this.unmutedVolume = this.player.volume;
          // this.player.volume = 0;
          // this.muted = true;
          this.emitter.emit("rep-muted", this.muted);
          this.player.pause();
        }
        this.isPlaying = false;
        this.emitter.emit("rep-isPlaying", this.isPlaying);
        // Alertas: registrar inicio de pausa
        if (!this.pauseStartAt) {
          this.pauseStartAt = Date.now();
        }
      } catch (e) {
        console.error("ha ocurrido un error pause - " + e);
        // this.presentAlertConfirm("Error en la función pause",e.toString());
        this.sendErrorReport("pause", e.toString());
      }
    },
    listenerOnPause() {
      try {
        this.player.addEventListener("pause", function (e) {
          if (!this.player.ended) {
            console.log("pausando...");
            this.isPlaying = false;
            this.emitter.emit("rep-isPlaying", this.isPlaying);

            if (this.shouldAutoResumePlayback()) {
              this.setPauseReason('system-pause');
              this.scheduleAutoResumeLoop('audio-pause-event');
            }
          }
        }.bind(this)
        );
      } catch (e) {
        console.error("ha ocurrido un error listenerOnPause - " + e);
        // this.presentAlertConfirm("Error en la función listenerOnPause",e.toString());
        this.sendErrorReport("listenerOnPause", e.toString());
      }
    },
    listenerOnPlay() {
      try {
        this.player.addEventListener("play", function () {
          console.log("reproduciendo...");
          this.isPlaying = true;
          this.emitter.emit("rep-isPlaying", this.isPlaying);
          this.onPlaybackStarted('play-event');
          // Alertas: limpiar pausa
          this.pauseStartAt = null;
        }.bind(this)
        );
      } catch (e) {
        console.error("ha ocurrido un error listenerOnPlay - " + e);
        // this.presentAlertConfirm("Error en la función listenerOnPlay",e.toString());
        this.sendErrorReport("listenerOnPlay", e.toString());
      }
    },
    millisToMinutesAndSeconds(millis) {
      try {
        // console.log(millis);
        millis = millis.toString().replace(",", ".");
        millis = parseInt(millis);
        var minutes = Math.floor(millis / 60000);
        var seconds = ((millis % 60000) / 1000).toFixed(0);
        return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
      } catch (e) {
        console.error("ha ocurrido un error millisToMinutesAndSeconds - " + e);
        // this.presentAlertConfirm("Error en la función millisToMinutesAndSeconds",e.toString());
        this.sendErrorReport("millisToMinutesAndSeconds", e.toString());
      }
    },
    listenerOnEnded() {
      // console.log("listenerOnEnded llamado");
      if (!this.nextRunning) {
        try {
          this.player.addEventListener("ended", function () {
            if (this.isPlaying == true)
              // console.log("next triggered from function listenerOnEnded()");
            this.next();
          }.bind(this)
          );
        } catch (e) {
          console.error("ha ocurrido un error listenerOnEnded - " + e);
          // this.presentAlertConfirm("Error en la función listenerOnEnded",e.toString());
          this.sendErrorReport("listenerOnEnded", e.toString());
        }
      }
    },
    errorNext() {
      try {
        if (this.playerError == false && this.isPlaying == true && this.globalPlay == true) {
          this.playerError = true;
          this.title = "Cargando...";
          this.artist = "Vybroo";
          this.audio_id = '0';
          this.emitter.emit("rep-title", this.title);
          this.emitter.emit("rep-artist", this.artist);
          setTimeout(() => {
            console.log("ERROR AL CARGAR LA CANCIÓN, SALTANDO DESDE errorNext()...");
            // console.log("cambiando...");
            // this.killAudio();
            this.playerError = false;
            this.playErrorCount++;
            console.log("playErrorCount: " + this.playErrorCount);
            if (this.playErrorCount >= 3) {
              this.artist = "Error al cargar la canción";
              this.title = "Error";
              this.audio_id = '0';
              this.emitter.emit("rep-title", this.title);
              this.emitter.emit("rep-artist", this.artist);
              // this.pause();
              // this.presentAlertConfirm("Error al cargar la canción", "Ha ocurrido un error al cargar la canción, por favor recargue la página. Si el error persiste contacte a su asesor.");
              this.playErrorCount = 0;
              this.vBackNext();
              this.sendErrorReport("ATENCIÓN", "SE HAN INTENTADO REPRODUCIR 3 CANCIONES CONSECUTIVAS CON ERROR ENTRAMOS EN vBack");
              return;
              // ACTIVATE VBACK TO BASE FUNCTION HERE IF ERROR PERSISTS AFTER 10 SONGS IN A ROW WITH ERROR

            } else {
              this.next();
              return;
            }
            this.next();

          }, 3000);
        } else {
          console.log("No entró al listener de error: " + this.isPlaying + " " + this.globalPlay);
          this.next();
        }
      } catch (e) {
        console.error("ha ocurrido un error errorNext - " + e);
        // this.presentAlertConfirm("Error en la función errorNext - ",e.toString());
        this.sendErrorReport("errorNext", e.toString());
        this.next();
      }

    },
    listenerOnError() {
      try {
        this.player.addEventListener("error", function (e) {
          if (this.playerError == false && this.isPlaying == true && this.globalPlay == true) {
            //enviar reporte de error con el mensaje de error
            // this.sendErrorReport("listenerOnError", e.error?e.error:e);
            if (this.token == NaN || this.token == undefined || this.token == null || this.token == "") {

              console.log("token no definido, no se envía reporte de error, token: " + this.token);
            } else {
              // si los ultimos 5 tokens consecutivos dan error y la lastCategorieError es la misma, enviar error de que la categoría está vacía y regresar a la base

              if (this.lastCategoriaError == this.currentCategoria && this.tokenErrorCount >= 5 && (this.currentCategoria != "0" || this.currentCategoria != 0)) {
                console.error("enviando reporte de error, token: " + this.token);
                this.sendErrorReport("listenerOnError", "CATEGORÍA MUSICAL VACÍA: " + this.currentCategoria);
                this.presentAlertConfirm("Aviso", "Se regresó a la categoría musical base debido a un error en la categoría musical seleccionada, si el error persiste, por favor de reportarlo a su asesor. Gracias.");
                this.tokenErrorCount = 0;
                this.returnToBase();
                return;
              }

              if (this.lastTokenError == this.token - 1 && this.lastCategoriaError == this.currentCategoria) {
                this.tokenErrorCount++;
                console.error("tokenErrorCount: " + this.tokenErrorCount);
              } else {
                this.tokenErrorCount = 0;
                console.error("tokenErrorCount: " + this.tokenErrorCount);
                console.error("No es el mismo token o no es la misma categoría musical, enviando reporte de error, token: " + this.token);
                if (!this.token || this.token == NaN || this.token == undefined || this.token == null || this.token == "") {
                  console.error("token no definido, no se envía reporte de error, token: " + this.token);
                } else {
                  // console.error("enviando reporte de error, token: " + this.token);
                  // this.sendErrorReport("listenerOnError", "Error al cargar la canción, token: " + this.token + ", categoría: " + this.currentCategoria);
                }
              }
              this.lastCategoriaError = this.currentCategoria;
              this.lastTokenError = this.token;
            }
            this.errorNext();
          }
        }.bind(this)
        );
      } catch (e) {
        console.error("ha ocurrido un error listenerOnError - " + e);
        // this.presentAlertConfirm("Error en la función listenerOnError",e.toString());
        this.sendErrorReport("listenerOnError", e.toString());
      }
    },
    listenerOnEndedAudioDemanda() {
      try {
        this.playerAudioDemanda.addEventListener("ended", function () {
          console.log("audio terminó de sonar");
          this.killAudioDemanda();
          this.play();
        }.bind(this)
        );
      } catch (e) {
        console.error("ha ocurrido un error listenerOnEndedAudioDemanda - " + e);
        // this.presentAlertConfirm("Error en la función listenerOnEndedAudioDemanda",e.toString());
        this.sendErrorReport("listenerOnEndedAudioDemanda", e.toString());
      }
    },
    killAudioDemanda() {
      try {
        Storage.remove({ key: 'audioDemanda' });
        this.playerAudioDemanda.pause();
        this.playerAudioDemandaSource = '';
        this.playingAudioDemanda = false;
        // this.playerAudioDemanda.stop();
      } catch (e) {
        console.error("ha ocurrido un error killAudioDemanda - " + e);
        // this.presentAlertConfirm("Error en la función killAudioDemanda",e.toString());
        this.sendErrorReport("killAudioDemanda", e.toString());
      }
    },
    killAudio() {
      try {
        this.setPauseReason('kill-audio');
        this.stopAutoResumeLoop('kill-audio');
        this.player.pause();
        this.playerAudioSource = '';
        this.playingAudio = false;
      } catch (e) {
        console.error("ha ocurrido un error killAudio - " + e);
        // this.presentAlertConfirm("Error en la función killAudio",e.toString());
        this.sendErrorReport("killAudio", e.toString());
      }
    },
    async next() {
      // console.log("===:next: llamado");
      if (this.networkStatus.connected == false) {
        this.vBackNext();
        return;
      }
      if (!this.nextRunning) {
        this.nextRunning = true;
        try {
          if (this.playerError == false) {

            this.checkOnline();
            if (this.token !== -1 && this.token && this.token == this.previousToken) {
              this.token += 1;
            }

            await this.nextApiRequest();
          } else {
            this.token = -1;
          }
        } catch (e) {
          console.error("ha ocurrido un error next - " + e);
          // this.presentAlertConfirm("Error en la función next",e.toString());
          this.sendErrorReport("next", e.toString());
        }
        this.nextRunning = false;
      }
    },
    /*async vBackNext() {
      this.vBackStatus = true;
      this.vBackToken++;
        if (this.vBackToken >= this.vBackList.length) {
          this.vBackToken = 0;
        }
      // console.log("===:vBackNext: llamado");
      if (this.vBackList.length > 0) {
        console.log("Reproduciendo siguiente canción en vBackList...");

        if (this.vBackList[this.vBackToken].type == 'spot') {
            let spotFiltrado = false;
            while (spotFiltrado == false) {
              //if (this.vBackList[this.vBackToken].cat_filter == "Promociones") {
              if (this.vBackList[this.vBackToken].cat_filter == "Promociones" ||
                  this.vBackList[this.vBackToken].cat_filter == "Productos" ||
                  this.vBackList[this.vBackToken].cat_filter == "Publicidad de la Marca" ||
                  this.vBackList[this.vBackToken].cat_filter == "") {
                this.vBackToken++;
              } else {
                spotFiltrado = true;
              }
            }
        }

        this.title = this.vBackList[this.vBackToken].title;
        this.artist = this.vBackList[this.vBackToken].artist;
        this.audio_id = this.vBackList[this.vBackToken].id;
        this.emitter.emit("rep-title", this.title);
        this.emitter.emit("rep-artist", this.artist);
        this.playerAudioSource = this.vBackList[this.vBackToken].file;
        this.player.src = this.playerAudioSource;
        this.vBackPlay();

      }else{
        console.log("Llenando la vBackList...");
        try {
          await axios.get('/transmito/vbk_get_sequence/?stream='+this.clientData.stream)
            .then(data => {
              // console.log(data);
              this.vBackList = data.data;
              this.vBackNext();
            })
            .catch(error => {
              console.error("Error en vBackNext - axios.get", error);
              this.sendErrorReport("vBackNext - axios.get", error);
            });

        }catch (e) {
          console.error("Error en vBackNext", e);
          this.sendErrorReport("vBackNext", e);
        }
      }
    },*/ 
    async vBackNext() { // NUEVA FUNCIÓN 
      if (!this.db) {
        console.log("Inicializando base de datos.");
        await this.initDB();
      }
      this.vBackStatus = true;
      console.log("===:vBackNext: llamado");
      console.log("vBackToken: " + this.vBackToken);
      const idList = await this.db.getAll('vback');
      if(this.vBackToken == -1){
        this.vBackToken = idList[0].id;
        console.log("getting first vBackToken: " + this.vBackToken);
      }else{
        const item = idList.find(item => item.id == this.vBackToken);
        const index = idList.indexOf(item);
        if (idList[index + 1] && idList[index + 1].id) {
          this.vBackToken = idList[index + 1].id;
        }else{
          this.vBackToken = idList[0].id;
          console.log("summing vBackToken: " + this.vBackToken);
        }
        console.log("summing vBackToken: " + this.vBackToken);
      }
      console.log("Reproduciendo siguiente token en vBackList...");
        const vBackItem = await this.db.get('vback', this.vBackToken);
        //console.log("vBackItem: " , vBackItem);
        //console.log("vBackItem.filter: " , vBackItem.filter);
        if (vBackItem.filter == "Promociones" ||
            vBackItem.filter == "Productos" ||
            vBackItem.filter == "Publicidad de la Marca" ||
            vBackItem.filter == "") {
          console.log("::Saltando token en vBackList... No podemos reproducir spots de Promociones, Productos o Publicidad de la Marca offline.");
          this.vBackNext();
          return;
        }else{
          console.log("::filter: " + vBackItem.filter + ": No es Promociones ni Productos");
        }
        this.emitter.emit("rep-type", vBackItem.type); 
        if(vBackItem.type == 'video'){
          this.videoExistsDB(vBackItem.url);
        }else{
          this.audioExistsDB(vBackItem.url);
        }

    },

    tokenId(id) {
      var idString = id.toString();
      var idLength = idString.length;
      var idFinal = idString;
      if (idLength < 5) {
        for (var i = 0; i < 5 - idLength; i++) {
          idFinal = "0" + idFinal;
        }
      }
      return idFinal;
    },

    async nextApiRequest() {
      // console.log("===:nextApiRequest: llamado");
      if (this.networkStatus.connected == false){// return si no tengo internet
        console.error("nextApiRequest :: omitido - No tengo internet::C");
        this.vBackNext();
        return;
      }
      if (this.enLinea == 2) {// return si no tengo internet
        console.error("nextApiRequest :: omitido - No tengo internet::L");
        this.vBackNext();
        return;
      }
      try {
        this.getApiRequestData();
        const dataParameters = { stream: this.clientName.toLowerCase(), token: this.token, cid: this.currentSucursal, music_variant: this.currentCategoria, variant: this.currentVariante, video: this.clientData.video_enabled };
        // console.log(dataParameters);
        await axios.post("https://vybroo.net/api", dataParameters)
          .then(data => {
            // console.log(data);
            const responseCode = Number(data && data.data ? data.data.code : 0);
            const isContentFailure = responseCode === 404;
            if (responseCode == 503 || data.data.error || this.token == NaN || isNaN(this.token) || this.token == undefined || this.token == null || responseCode == 404) {
              // this.token = -1;
              setTimeout(() => {
                console.error("Saltando por error en servidor, intentando nuevamente...");
                this.title = "Error, reintentando...";
                this.artist = "Vybroo";
                this.audio_id = '0';
                this.emitter.emit("rep-title", this.title);
                this.emitter.emit("rep-artist", this.artist);
                if (isContentFailure) {
                  this.advanceTokenAfterContentFailure('api-404');
                }
                if (this.nextApiErrors >= 3) {
                  this.vBackNext();
                }else{
                  this.nextApiErrors++;
                  this.nextApiRequest();
                }
                return;
              }, 2000);
            } else {
              this.vBackStatus = false;
              this.nextApiErrors = 0;
              this.lastContentFailureToken = null;
              this.killAudio();
              this.token = Number(data.data.token);
              console.log("TOKEN actual: " + this.token + " - TOKEN previo: " + this.previousToken);
              this.previousToken = this.token;
              this.type = data.data.type;
              // console.log("TYPE: " + this.type + " desde NEXT" );
              this.title = data.data.title ? data.data.title : 'Cargando...';
              this.bkTitle = data.data.title ? data.data.title : 'Cargando...';
                  this.tags = data.data.tags ? data.data.tags : '';
                  this.formula = data.data.formula ? data.data.formula : '';
                  this.filter = data.data.filter ? data.data.filter : '';
                  this.filter += data.data.category ? data.data.category : '';
              this.audio_id = data.data.id ? data.data.id : '0';
              if (this.sonara) {
                this.artist = data.data.artist ? data.data.artist : 'Sonara';
                this.bkArtist = data.data.artist ? data.data.artist : 'Sonara';
              } else {
                this.artist = data.data.artist ? data.data.artist : 'Vybroo';
                this.bkArtist = data.data.artist ? data.data.artist : 'Vybroo';
              }
              // console.info("Llamando emits desde nextApiRequestData()...");
              this.emitter.emit("rep-token", this.token);
              this.emitter.emit("rep-title", this.title);
              this.emitter.emit("rep-artist", this.artist);
              this.emitter.emit("rep-type", this.type);
              // console.info("Emits llamados desde nextApiRequestData()...");

              if (data.data.type != 'video') {

                // this.artist = this.token;
                if (data.data.type == 'time') {
                  this.playerAudioSource = this.getTimeFile();
                  this.title = 'Hora';
                  this.audio_id = '0';
                  if (this.sonara) {
                    this.artist = 'Sonara';
                  } else {
                    this.artist = 'Vybroo';
                  }
                }

                if (data.data.type == 'song' || data.data.type == 'videosong') {
                  console.log("Reproduciendo canción...");
                  if (data.data.id) { this.getHighestSongQuality(data.data.id, data.data.file) }
                }
                if (data.data.type == 'spot') {
                  console.log("Reproduciendo spot...");
                  // Usar CDN en lugar del servidor para spots
                  let spotPath = (data.data.file).replace(/ /g, "%20");
                  // Remover /a/ del inicio si existe
                  if (spotPath.startsWith('/a/')) {
                    spotPath = spotPath.substring(3);
                  }
                  this.playerAudioSource = this.cdnBaseUrl + spotPath;
                  this.setPlayerSource(this.playerAudioSource, 'source-change');
                  // Aplicar volumen: slider manual × spotsVolume con conversión logarítmica
                  this.player.volume = this.linearToLog(this.sound.volume * this.sound.spotsVolume);
                  this.audioExistsDB(this.getStorageId(this.playerAudioSource));
                }
                this.emitter.emit("rep-title", this.title);
                this.emitter.emit("rep-artist", this.artist);
                // console.log(this.playerAudioSource);
                // Aplicar volumen: slider manual × musicVolume/spotsVolume con conversión logarítmica
                if (this.type === 'song' || this.type === 'videosong' || this.type === 'time') {
                  this.player.volume = this.linearToLog(this.sound.volume * this.sound.musicVolume);
                } else if (this.type === 'spot') {
                  this.player.volume = this.linearToLog(this.sound.volume * this.sound.spotsVolume);
                } else {
                  this.player.volume = this.sound.volume;
                }
                this.player.preload = "auto";
                this.liked = 0;
                this.emitter.emit("rep-liked", this.liked);
                if (this.saveMusicVariant.nextSwitch === true && this.currentCategoria !== 0) {
                  console.log("nextSwitch activado, saltando a la variante base...");
                  this.token = -1;
                  this.returnToBase();
                  return;
                }
                if (data.data.type == 'song' || data.data.type == 'videosong') return;
                this.play();
              } else { // ES VIDEO
                try {
                  this.filter = data.data.category ? data.data.category : '';
                  this.playerAudioSource = 'https://media.vybroo.com/videos/' + (data.data.file).replace(/ /g, "%20");
                  this.videoExistsDB(this.playerAudioSource);
                  
                } catch (error) {
                  console.log("Error en nextApiRequest - video - NEXTEMIT", error);
                  this.sendErrorReport("nextApiRequest - video - NEXTEMIT", error);
                }

              }

              // if(this.muted) this.player.volume = 0;
            }
          })
          .catch(error => {
            if (this.enLinea == 2) {
              console.log("Error de conexión, reintentando... (nextApiRequest)", error);
              this.sendErrorReport("nextApiRequest (error de conexión)", error);
              this.vBackNext();
            }else{
              if (this.nextApiErrors >= 3) {
                  this.vBackNext();
                }else{
                  this.nextApiErrors++;
                  this.nextApiRequest();
              }
            }

            // this.presentAlertConfirm("Error en loadApi de la función nextApiRequest",error);
          });
      } catch (e) {
        console.error("ha ocurrido un error en la función nextApiRequest - " + e);
        // this.presentAlertConfirm("ha ocurrido un error en la función nextApiRequest",e.toString());
        this.sendErrorReport("nextApiRequest", e.toString());
      }
    },


    async getClientData() {
      try {
        this.checkOnline();
        const ret = await Storage.get({ key: "clientData" });
        if (ret.value) {
          this.clientData = JSON.parse(ret.value);
          // this.sendReport("Inicio de sesión nuevo: \n Canal: " + this.clientData.stream);
          this.emitter.emit("g-data", this.clientData);
          //imagen reproductor
          this.clientImageSrc = 'https://media.vybroo.com/images/' + this.clientData.image;
          // console.log(this.clientImageSrc);
          //Client data en get:
          this.clientName = this.clientData.stream;

          // Aplicar preferencia persistida del toggle por canal (stream + link).
          await this.initializeNormalizeSongsPreference();


          if (this.clientData.permissions) {
            this.emitter.emit("permissions", this.clientData.permissions);
            this.listenedChanges.permissions = this.clientData.permissions;
          }

          if (this.clientData.sonara) {
            this.emitter.emit("sonara", this.clientData.sonara);
            this.listenedChanges.sonara = this.clientData.sonara;
            console.log("Sonará: " + this.clientData.sonara);
          }

          if (this.clientData.default_quality) {
            this.clientData.default_quality == "32" ? this.sound.quality = "m4a_32" : "";
            this.clientData.default_quality == "128" ? this.sound.quality = "mp3_128" : this.sound.quality = "m4a_32";
            this.clientData.default_quality == "320" ? this.sound.quality = "mp3_320" : this.sound.quality = "m4a_32";
          } else {
            this.sound.quality = "m4a_32";
          }

          if (this.clientData.quality_controls) {
            this.sound.controls = this.clientData.quality_controls;
            this.emitter.emit("quality-controls", this.sound.controls);
          } else {
            this.sound.controls = false;
          }

          // Cargar config de alertas
          if (this.clientData.config && this.clientData.config.alerts) {
            this.alertConfig = this.clientData.config.alerts;
            console.log("Alertas configuradas:", JSON.stringify(this.alertConfig));
          }

          // Cargar volúmenes de normalización desde el backend
          if (this.clientData.music_volume !== undefined && this.clientData.music_volume > 0 && this.clientData.music_volume <= 100) {
            this.sound.musicVolume = this.clientData.music_volume / 100;
            console.log("🎵 Volumen música: " + this.clientData.music_volume + "% → logarítmico: " + this.linearToLog(this.sound.musicVolume).toFixed(3));
          }
          
          if (this.clientData.spots_volume !== undefined && this.clientData.spots_volume > 0 && this.clientData.spots_volume <= 100) {
            this.sound.spotsVolume = this.clientData.spots_volume / 100;
            console.log("📢 Volumen spots: " + this.clientData.spots_volume + "% → logarítmico: " + this.linearToLog(this.sound.spotsVolume).toFixed(3));
          }
          this.applyAudioDemandaVolume();

          // console.log(this.clientData);

          // console.log(this.clientName);
          //color de fondo
          this.clientColor = "#" + this.clientData.color;
          // console.log(this.clientData.color);

          //GUARDAR PREFERENCIAS EN CATEGORÍA MUSICAL
          this.saveMusicVariant = {
            enabled: this.clientData.save_m_variant,
            time: 0,
            timeString: "00:00:00",
            nextSwitch: false,
            timerRunning: false
          };
          // console.log("SAVE MUSIC VARIANT: " + this.clientData.save_m_variant);
          if (this.saveMusicVariant.enabled == false) {
            // console.log("Save Music Variant disabled - save_m_variant: " + this.saveMusicVariant.enabled);
            Storage.remove({ key: 'categoriaSeleccionada' });
          }

          // CAPTAR SUCURSAL EN PARÁMETROS DE URL
          this.urlParams.sucursalMatch = false;
          this.clientData.identifiers.forEach(element => {
            if (element.id == this.urlParams.sucursal) {
              console.log("La sucursal del URL existe en la lista de sucursales del canal: " + this.urlParams.sucursal + " = " + element.id);
              // this.presentAlertConfirm("Sucursal activada:",element.identifier);
              this.urlParams.sucursalMatch = true;
              this.urlParams.sucursalMatchName = element.identifier;
              this.currentSucursal = Number(this.urlParams.sucursal);
              this.emitter.emit("rep-currentSucursal", this.currentSucursal);
              Storage.remove({ key: 'sucursalSeleccionada' });
              Storage.set({
                key: "sucursalSeleccionada",
                value: JSON.stringify(element.identifier),
              })
                .then
              console.log("STORAGE: sucursal guardada: " + element.identifier);
            }
          });
          if (this.urlParams.sucursalMatch == false && Number(this.urlParams.sucursal) >= 0 && this.urlParams.sucursal) {
            this.presentAlertConfirm("Atención", "El ID de sucursal ingresado (" + this.urlParams.sucursal + ") en el URL no coincide con ninguna sucursal registrada, revise si el URL se pegó completo.");
          }

          // CAPTAR SUCURSALNAME EN PARÁMETROS DE URL
          this.urlParams.sucursalNameMatch = false;
          this.clientData.identifiers.forEach(element => {
            if (element.identifier == this.urlParams.sucursalName) {
              console.log("La sucursalName del URL existe en la lista de sucursales del canal: " + this.urlParams.sucursalName + " = " + element.identifier);
              // this.presentAlertConfirm("Sucursal activada:",element.identifier);
              this.urlParams.sucursalNameMatch = true;
              this.urlParams.sucursalNameMatchName = element.identifier;
              this.currentSucursal = element.id;
              this.emitter.emit("rep-currentSucursal", element.id);
              Storage.remove({ key: 'sucursalSeleccionada' });
              Storage.set({
                key: "sucursalSeleccionada",
                value: JSON.stringify(element.identifier),
              })
                .then
              console.log("STORAGE: sucursalName guardada: " + element.identifier);
            }
          });
          if (this.urlParams.sucursalNameMatch == false && this.urlParams.sucursalName) {
            this.presentAlertConfirm("Atención", "El ID de sucursal ingresado (" + this.urlParams.sucursalName + ") en el URL no coincide con ninguna sucursal registrada, revise si el URL se pegó completo.");
          }

          // CAPTAR CATEGORÍA MUSICAL EN PARÁMETROS DE URL
          this.urlParams.categoriaMatch = false;
          this.clientData.music_variants.forEach(element => {
            if (element.id == this.urlParams.categoria) {
              console.log("La categoría del URL existe en la lista de sucursales del canal: " + this.urlParams.categoria + " = " + element.id);
              // this.presentAlertConfirm("Categoría musical activada:",element.name);
              this.urlParams.categoriaMatch = true;
              this.urlParams.categoriaMatchName = element.name;
              this.currentCategoria = Number(this.urlParams.categoria);
              this.currentCategoriaAux = Number(this.urlParams.categoria);
              this.emitter.emit("rep-currentCategoria", this.currentCategoria);
              Storage.remove({ key: 'categoriaSeleccionada' });
              Storage.set({
                key: "categoriaSeleccionada",
                value: JSON.stringify(this.urlParams.categoria),
              })
                .then
              console.log("STORAGE: variante musical guardada: " + this.urlParams.categoria);
            }
          });
          if (this.urlParams.categoriaMatch == false && Number(this.urlParams.categoria) >= 0 && this.urlParams.categoria) {
            this.presentAlertConfirm("Atención", "El ID de categoría musical ingresado (" + this.urlParams.categoria + ") en el URL no coincide con ninguna categoría registrada, revise si el URL se pegó completo.");
          }

          // CAPTAR VARIANTE DE CONTENIDO EN PARÁMETROS DE URL
          this.urlParams.varianteMatch = false;
          // console.log(this.clientData.variants);
          this.clientData.variants.forEach(element => {
            if (element.id == this.urlParams.variante) {
              console.log("La variante del URL existe en la lista de sucursales del canal: " + this.urlParams.variante + " = " + element.id);
              // this.presentAlertConfirm("Variante de contenido activada:",element.name);
              this.urlParams.varianteMatch = true;
              this.urlParams.varianteMatchName = element.name;
              this.currentVariante = Number(this.urlParams.variante);
              this.currentVarianteAux = Number(this.urlParams.variante);
              this.emitter.emit("rep-currentVariante", this.currentVariante);
              Storage.remove({ key: 'varianteSeleccionada' });
              Storage.set({
                key: "varianteSeleccionada",
                value: JSON.stringify(this.urlParams.variante),
              })
                .then
              console.log("STORAGE: variante de contenido guardada: " + this.urlParams.variante);
            }
          });
          if (this.urlParams.varianteMatch == false && Number(this.urlParams.variante) >= 0 && this.urlParams.variante) {
            this.presentAlertConfirm("Atención", "El ID de variante de contenido ingresado (" + this.urlParams.variante + ") en el URL no coincide con ninguna variante registrada, revise si el URL se pegó completo.");
          }

          if (this.urlParams.sucursalMatch || this.urlParams.sucursalNameMatch || this.urlParams.categoriaMatch || this.urlParams.varianteMatch) {
            var sucursalInfo = this.urlParams.sucursalMatch ? "<strong>ID de sucursal: </strong>" + this.urlParams.sucursalMatchName + ".<br>" : "";
            var sucursalNameInfo = this.urlParams.sucursalNameMatch ? "<strong>ID de sucursal: </strong>" + this.urlParams.sucursalNameMatchName + ".<br>" : "";
            var categoriaInfo = this.urlParams.categoriaMatch ? "<strong>Categoría musical: </strong>" + this.urlParams.categoriaMatchName + ".<br>" : "";
            var varianteInfo = this.urlParams.varianteMatch ? "<strong>Variante de contenido: </strong>" + this.urlParams.varianteMatchName + ".<br>" : "";
            // this.presentAlertConfirm("Se cargó la siguiente configuración:", sucursalInfo + sucursalNameInfo + categoriaInfo + varianteInfo)
          }


          this.loadApi(this.clientData.stream);
        } else {
          Storage.clear();
          this.$router.replace("/login/loginUser");
        }
      } catch (e) {
        console.error("ha ocurrido un error getClientData - " + e);
        // this.presentAlertConfirm("Error en la función getClientData",e.toString());
        this.sendErrorReport("getClientData", e.toString());
      }
    },
    async intro_expired() {
      try {
        const introKey = "intro_expires";
        const ret = await Storage.get({ key: introKey });
        const currentDate = new Date();

        const setNextIntroDate = async () => {
          const nextIntroDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
          await Storage.set({
            key: introKey,
            value: JSON.stringify(nextIntroDate.toISOString()),
          });
          return nextIntroDate;
        };

        if (!ret.value) {
          console.log("intro_expires no existe en storage, se creará con fecha de vencimiento de 24 horas");
          const nextIntroDate = await setNextIntroDate();
          console.log("new_intro_expires: " + nextIntroDate.toLocaleString());
          return true;
        }

        const introExpiresRaw = this.isJson(ret.value);
        const introDate = new Date(introExpiresRaw);

        if (Number.isNaN(introDate.getTime())) {
          console.log("intro_expires inválido en storage, se reprogramará por 24 horas");
          await setNextIntroDate();
          return true;
        }

        if (introDate <= currentDate) {
          await setNextIntroDate();
          return true;
        }

        return false;
      } catch (e) {
        console.error("ha ocurrido un error intro_expired - " + e);
        // this.presentAlertConfirm("Error en la función getIntroPlayedExpirationDate",e.toString());
        this.sendErrorReport("intro_expired", e.toString());
        return false;
      }
    },
    async getSucursal() {
      try {
        const retSucursal = await Storage.get({ key: "sucursalSeleccionada" });
        if (retSucursal.value) {
          this.currentSucursal = this.isJson(retSucursal.value);
          this.emitter.emit("rep-currentSucursal", this.currentSucursal);
          // console.log("Sucursal actual: " + this.currentSucursal);
        } else {
          if (!this.urlParams.sucursalMatch && !this.urlParams.sucursalNameMatch) {
            // console.log("no hay sucursal seleccionada");
            this.currentSucursal = "";
          }
          this.emitter.emit("rep-currentSucursal", this.currentSucursal);
        }
      } catch (e) {
        console.error("ha ocurrido un error getSucursal - " + e);
        // this.presentAlertConfirm("Error en la función getSucursal",e.toString());
        this.sendErrorReport("getSucursal", e.toString());
      }
    },
    msToTime(duration) {
      try { return moment.utc(duration).format("HH:mm:ss"); }
      catch (e) {
        console.error("ha ocurrido un error msToTime - " + e);
        // this.presentAlertConfirm("Error en la función msToTime",e.toString());
        this.sendErrorReport("msToTime", e.toString());
      }
    },
    async getSucursalByName() {
      const retSucursal = await Storage.get({ key: "sucursalSeleccionada" });
      if (retSucursal.value) {
        const sucursalSeleccionada = this.isJson(retSucursal.value);
        const sucursal = this.clientData.identifiers.find(s => s.identifier === sucursalSeleccionada);
        return sucursal ? sucursal.id : null;
      } else {
        return null;
      }
    },
    async getCategoria() {
      try {
        const retCategoria = await Storage.get({ key: "categoriaSeleccionada" });
        if (retCategoria.value) {
          this.currentCategoria = this.isJson(retCategoria.value);
          this.emitter.emit("rep-currentCategoria", this.currentCategoria);
          // console.log("Categoría actual: " + this.currentCategoria);
          if (retCategoria.value != this.currentCategoriaAux && this.currentCategoriaAux != null) {
            console.log("se cambió la categoría de " + this.currentCategoriaAux + " a " + this.currentCategoria);
            if (this.clientData.save_m_variant === true && this.clientData.smv_time > 0) {
              console.log("saveMusicVariant está activado");
              if (this.currentCategoria === 0) {
                //reiniciar valores de saveMusicVariant
                console.log("reiniciando valores de saveMusicVariant")
                this.saveMusicVariant.enabled = false;
                this.saveMusicVariant.time = 0;
                this.saveMusicVariant.timeString = "00:00:00";
                Storage.remove({ key: 'saveMusicVariantTime' });

              } else {
                //registrar en storage el valor de smv_time mas la fecha actual para que se guarde la variante musical
                console.log("Iniciando temporizador de saveMusicVariant");
                var date = new Date();
                console.log("fecha actual:" + date);
                var minutes = date.getMinutes() + this.clientData.smv_time;
                date.setMinutes(minutes);
                console.log("fecha actual + smv_time:" + date);
                Storage.set({
                  key: "saveMusicVariantTime",
                  value: date.toISOString(),
                })
                console.log("Storage saveMusicVariantTime guardado:");
                var storageDate = await Storage.get({ key: "saveMusicVariantTime" });
                console.log(storageDate.value);
              }
            }

            // this.presentAlertConfirm("Atención","Se cambió de varante musical - " + this.currentCategoria);
            this.globalPlay = true;
            // this.isPlaying = true;
            if (this.playerError == false) {
              console.log("ejecutando next() desde getCategoria()");
              this.token = -1;
              this.next();
              this.play();
            }
          }
          // Revisar si existe en el storage saveMusicVariantTime y si es mayor a la fecha actual, si es así, se guarda la variante musical, si no se borra el storage y se reinician los valores de saveMusicVariant y la categoría se cambia a 0
          var storageDate = await Storage.get({ key: "saveMusicVariantTime" });
          if (storageDate.value) {
            // revisar la fecha del storage y la diferencia respecto a la fecha actual
            var date = new Date();
            var storageDate = new Date(storageDate.value);
            var diff = storageDate.getTime() - date.getTime();
            // console.log("Tiempo restante: " + this.msToTime(diff));
            if (diff > 0) {
              // guardar la variante musical
              // console.log("guardando variante musical");
              this.saveMusicVariant.enabled = true;
              this.saveMusicVariant.time = diff;
              this.saveMusicVariant.timeString = this.msToTime(diff);
              this.saveMusicVariant.nextSwitch = false;

            } else {
              if (this.saveMusicVariant.nextSwitch === false) {
                console.log("Se regresará a base al terminar la canción actual");
                Toast.show({ text: 'AVISO: Se regresará a base al terminar la canción actual.', duration: 'long' });
                this.saveMusicVariant.nextSwitch = true;
              }


            }
          }


          this.currentCategoriaAux = retCategoria.value;
        } else {
          if (!this.urlParams.categoriaMatch) {
            // console.log("no hay categoría seleccionada");
            this.currentCategoria = 0;
          }
          this.currentCategoriaAux = this.currentCategoria;
          this.emitter.emit("rep-currentCategoria", this.currentCategoria);
          this.emitter.emit("rep-currentCategoriaAux", this.currentCategoriaAux);
        }

        //TIMER DE !SAVE MUSIC VARIANT
        if (!this.saveMusicVariant.enabled && !this.saveMusicVariant.timerRunning) {
          console.log("Categoría seleccionada: " + this.currentCategoria)
          this.saveMusicVariant.timerRunning = true;
        }
      } catch (e) {
        console.error("ha ocurrido un error getCategoria - " + e);
        // this.presentAlertConfirm("Error en la función getCategoria",e.toString());
        this.sendErrorReport("getCategoria", e.toString());
      }
    },
    returnToBase() {
      try {
        console.log("Regresando a la variante base - INICIO")
        // borrar el storage y reiniciar los valores de saveMusicVariant
        this.saveMusicVariant.nextSwitch = false;
        console.log("borrando storage y reiniciando valores de saveMusicVariant");
        Storage.remove({ key: 'saveMusicVariantTime' });
        this.saveMusicVariant.enabled = false;
        this.saveMusicVariant.time = 0;
        this.saveMusicVariant.timeString = "00:00:00";
        this.saveMusicVariant.timerRunning = false;
        this.currentCategoria = 0;
        this.currentCategoriaAux = 0;

        Storage.set({
          key: "categoriaSeleccionada",
          value: JSON.stringify(this.currentCategoria),
        });

        this.emitter.emit("cambio-categoria", this.currentCategoria);
        this.emitter.emit("rep-currentCategoria", this.currentCategoria);
        this.emitter.emit("rep-currentCategoriaAux", this.currentCategoriaAux);
        this.globalPlay = true;
        this.isPlaying = true;
        console.log("Regresando a la variante base - FIN")
        this.next();
      } catch (e) {
        console.error("ha ocurrido un error en returnToBase - " + e);
        // this.presentAlertConfirm("Error en la función returnToBase",e.toString());
        this.sendErrorReport("returnToBase", e.toString());
      }
    },
    async getAudioDemanda() {
      try {
        const retAudio = await Storage.get({ key: "audioDemanda" });
        if (retAudio.value && this.globalPlay) {
          this.killAudioDemanda();
          const audioDemanda = JSON.parse(retAudio.value);
          let file = (audioDemanda && audioDemanda.file ? audioDemanda.file : '').toString().trim();

          if (/^https?:\/\//i.test(file)) {
            // Soporta URLs completas y corrige rutas legacy /a/spots/.
            this.playerAudioDemandaSource = file.replace('/a/spots/', '/spots/').replace(/ /g, "%20");
          } else {
            // Soporta rutas relativas y normaliza a /spots/ (producción).
            file = file.replace(/^\/+/, '');
            file = file.replace(/^a\/spots\//i, '');
            file = file.replace(/^spots\//i, '');
            this.playerAudioDemandaSource = 'https://vybroo.net/spots/' + file.replace(/ /g, "%20");
          }

          console.log(this.playerAudioDemandaSource);
          this.playerAudioDemanda.src = this.playerAudioDemandaSource;
          this.applyAudioDemandaVolume();
          //pausar reproductor normal
          this.pause('audio-demanda');
          Storage.remove({ key: 'audioDemanda' });
          this.playerAudioDemanda.play();
          // this.presentAlertConfirm("Reproduciendo audio", isJson(retAudio.value.name));
          this.playingAudioDemanda = true;
          this.listenerOnEndedAudioDemanda();
        } else {
          // console.log("----- AUDIOS ERROR ----");
          // if(!retAudio.value) console.log("no hay audios a demanda en storage")
          // if(this.playingAudioDemanda) console.log("playingAudioDemanda = true")
          // if(!this.globalPlay) console.log("globalPlay = false")
          // console.log("----- AUDIOS ERROR ----");
          // this.playingAudioDemanda = false;

          // console.log(this.playingAudioDemanda);

        }
      } catch (e) {
        console.log("error en la función getAudioDemanda - " + e);
        // this.presentAlertConfirm("Error en la función getAudioDemanda",e.toString());
        this.sendErrorReport("getAudioDemanda", e.toString());
        // this.playingAudioDemanda = false;
      }
    },
    async getVariante() {
      try {
        const retVariante = await Storage.get({ key: "varianteSeleccionada" });
        if (retVariante.value) {
          this.currentVariante = this.isJson(retVariante.value);
          this.emitter.emit("rep-currentVariante", this.currentVariante);
          //guardar también el nombre de la variante
          this.clientData.variants.forEach(element => {
            if (element.id == this.currentVariante) {
              this.currentVarianteName = element.name;
              this.emitter.emit("rep-currentVarianteName", this.currentVarianteName);
              // console.log("Variante actual: " + this.currentVarianteName);
            }
          });
          // console.log("Categoría actual: " + this.currentCategoria);
          if (retVariante.value != this.currentVarianteAux && this.currentVarianteAux != null) {
            console.log("se cambió la varante de " + this.currentVarianteAux + " a " + this.currentVariante);
            // this.presentAlertConfirm("Atención","Se cambió de varante de contenido - " + this.currentVariante);
            this.globalPlay = true;
            // this.isPlaying = true;
            if (this.playerError == false) {
              console.log("ejecutando next() desde getVariante()");

              this.next();
            }
            this.play();
          }
          this.currentVarianteAux = retVariante.value;
        } else {
          if (!this.urlParams.varianteMatch) {
            this.currentVariante = 0;
            this.currentVarianteAux = 0;
          }
          this.emitter.emit("rep-currentVariante", this.currentVariante);
          this.emitter.emit("rep-currentVarianteAux", this.currentVarianteAux);
        }
      } catch (e) {
        console.log("error en la función getVariante - " + e);
        // this.presentAlertConfirm("Error en la función getVariante",e.toString());
        this.sendErrorReport("getVariante", e.toString());
      }
    },
    async getApiRequestData() {
      try {
        await this.getSucursal();
        await this.getCategoria();
        await this.getAudioDemanda();
        await this.getVariante();
        // this.currentSucursal!=""?console.log("Sucursal actual: " + this.currentSucursal):console.log("no hay sucursal seleccionada");
        // this.currentCategoria!=0?console.log("Categoría actual: " + this.currentCategoria):console.log("no hay categoría seleccionada");
        // this.playerAudioDemandaSource!=''?console.log("Audio a demanda actual: " + this.playerAudioDemandaSource):console.log("no hay audio a demanda sonando");
      } catch (e) {
        console.log("error en la función getApiRequestData - " + e);
        // this.presentAlertConfirm("Error en la función getApiRequestData",e.toString());
        this.sendErrorReport("getApiRequestData", e.toString());
      }

    },
    likeInteraction(likeValue) {
      try {
        var data = {
          title: this.title,
          artist: this.artist,
          type: this.type,
          location: this.location,
          stream: this.clientName,
          token: this.token,
          lat: 0,
          lon: 0,
          time: this.player.currentTime,
          liked: likeValue
        };
        // console.log(data);
        // this.liked = likeValue;
        // console.log("likeValue: " + this.liked)
        axios.post("https://vybroo.net/survey_api", data)
          .then(data => {
            console.log(data)
            this.liked = likeValue;
            this.emitter.emit("rep-liked", this.liked);
            console.log("likeValue: " + this.liked)
          })
          .catch(error => {
            console.error("Error en la post de like", e.toString());
            // this.presentAlertConfirm("Error en post de like",e.toString());
            this.sendErrorReport("likeInteraction", e.toString());
          });
      } catch (e) {
        console.error("ha ocurrido un error en la función likeInteraction - " + e);
        // this.presentAlertConfirm("Error en la función likeInteraction",e.toString());
        this.sendErrorReport("likeInteraction", e.toString());
      }
    },
    async presentAlertConfirm(headerAlert, messageAlert) {
      try {
        const alert = await alertController
          .create({
            header: headerAlert,
            message: messageAlert,
            buttons: ['Ok'],
          });
        return alert.present();
      } catch (e) {
        console.error("ha ocurrido un error en la función presentAlertConfirm - " + e);
        // this.presentAlertConfirm("Ha ocurrido un error en la función presentAlertConfirm",e.toString());
        this.sendErrorReport("presentAlertConfirm", e.toString());
      }
    },
    async presentAlertCustom(header, message, okFunction) {
      try {
        const alert = await alertController
          .create({
            header: header,
            message: message,
            backdropDismiss: false,
            buttons: [
              {
                text: 'Ok',
                handler: () => {
                  okFunction();
                }
              }
            ]
          });
        return alert.present();
      } catch (e) {
        console.error("ha ocurrido un error en la función presentAlertCustom - " + e);
        // this.presentAlertConfirm("Ha ocurrido un error en la función presentAlertCustom",e.toString());
        this.sendErrorReport("presentAlertCustom", e.toString());
      }
    },
    async presentAlertRefresh(headerAlert, messageAlert) {
      try {
        if (this.alertRefreshPresented == false) {
          const alert = await alertController
            .create({
              header: headerAlert,
              message: messageAlert,
              backdropDismiss: false,
              buttons: [
                {
                  text: 'Actualizar',
                  handler: () => {
                    this.$router.go();
                  }
                },
              ]
            });
          this.alertRefreshPresented = true;
          return alert.present();
        }
      } catch (e) {
        console.error("ha ocurrido un error en la función presentAlertRefresh - " + e);
        // this.presentAlertConfirm("Ha ocurrido un error en la función presentAlertRefresh",e.toString());
        this.sendErrorReport("presentAlertRefresh", e.toString());
      }
    },
    isJson(str) {
      try {
        const parsedStr = JSON.parse(str);
        return parsedStr;
      } catch (e) {
        return str;
      }
    },
    checkOnline() {
      try {
        if (window.navigator.onLine) {
          this.enLinea = 1;
          // console.log("En linea...");
        } else {
          this.enLinea = 2;
          // console.log("Fuera de linea, reintentando...");
        }
      } catch (e) {
        console.error("ha ocurrido un error en la función checkOnline - " + e);
        // this.presentAlertConfirm("Error en la función checkOnline",e.toString());
        this.sendErrorReport("checkOnline", e.toString());
      }
    },
    checkAlerts() {
      if (!this.alertConfig || Object.keys(this.alertConfig).length === 0) return;
      const now = Date.now();
      const ts = new Date().toLocaleTimeString();
      const vol = Math.round(this.sound.volume * 100);

      // Volume alert
      if (this.alertConfig.volume && this.alertConfig.volume.enabled) {
        const threshold = this.alertConfig.volume.threshold || 25;
        const cooldown = (this.alertConfig.volume.cooldown || 10) * 60000;
        const delay = (this.alertConfig.volume.delay || 0) * 60000;

        if (vol <= threshold) {
          if (!this.volumeLowSince) this.volumeLowSince = now;
          const lowForMs = now - this.volumeLowSince;
          if (lowForMs >= delay && now - (this.lastAlertFired.volume || 0) > cooldown) {
            this.lastAlertFired.volume = now;
            this.emitter.emit('alert-triggered', {
              type: 'volume',
              message: 'Volumen bajo: ' + vol + '%',
              duration: this.alertConfig.duration || 10,
            });
            console.log(ts + ' Alerta volumen bajo: ' + vol + '%');
          }
        } else {
          this.volumeLowSince = null;
        }
      }

      // Pause alert
      if (this.alertConfig.pause && this.alertConfig.pause.enabled) {
        const pauseThreshold = this.alertConfig.pause.threshold || 5;
        const cooldown = (this.alertConfig.pause.cooldown || 10) * 60000;
        const delay = (this.alertConfig.pause.delay || 0) * 60000;
        const effectiveThreshold = (pauseThreshold * 60000) + delay;
        const elapsedMs = this.pauseStartAt ? (now - this.pauseStartAt) : 0;
        const elapsedMin = Math.round(elapsedMs / 60000);
        const lastPause = this.lastAlertFired.pause || 0;
        const cooldownLeft = Math.round((cooldown - (now - lastPause)) / 60000);
        const ready = !this.isPlaying && !!this.pauseStartAt;
        console.log(ts + ' [pause-check] isPlaying=' + this.isPlaying + ' pauseStartAt=' + (this.pauseStartAt ? 'YES' : 'null') + ' elapsed=' + elapsedMin + 'min threshold=' + pauseThreshold + 'min ready=' + ready + ' cooldownLeft=' + cooldownLeft + 'min');
        if (ready && elapsedMs >= effectiveThreshold && now - lastPause > cooldown) {
          this.lastAlertFired.pause = now;
          this.emitter.emit('alert-triggered', {
            type: 'pause',
            message: 'Pausado por ' + elapsedMin + ' min',
            duration: this.alertConfig.duration || 10,
          });
          console.log(ts + ' Alerta pausa: ' + elapsedMin + ' min');
        }
      }

      // Disconnect alert
      if (this.alertConfig.disconnect && this.alertConfig.disconnect.enabled) {
        const disconnectThreshold = this.alertConfig.disconnect.threshold || 10;
        const cooldown = (this.alertConfig.disconnect.cooldown || 10) * 60000;
        const delay = (this.alertConfig.disconnect.delay || 0) * 60000;
        const effectiveThreshold = (disconnectThreshold * 60000) + delay;
        const elapsedMs = this.disconnectStartAt ? (now - this.disconnectStartAt) : 0;
        const elapsedMin = Math.round(elapsedMs / 60000);
        const lastDisc = this.lastAlertFired.disconnect || 0;
        const cooldownLeft = Math.round((cooldown - (now - lastDisc)) / 60000);
        const ready = this.enLinea === 2 && !!this.disconnectStartAt;
        console.log(ts + ' [disc-check] enLinea=' + this.enLinea + ' disconnectStartAt=' + (this.disconnectStartAt ? 'YES' : 'null') + ' elapsed=' + elapsedMin + 'min threshold=' + disconnectThreshold + 'min ready=' + ready + ' cooldownLeft=' + cooldownLeft + 'min');
        if (ready && elapsedMs >= effectiveThreshold && now - lastDisc > cooldown) {
          this.lastAlertFired.disconnect = now;
          this.emitter.emit('alert-triggered', {
            type: 'disconnect',
            message: 'Sin conexión por ' + elapsedMin + ' min',
            duration: this.alertConfig.duration || 10,
          });
          console.log(ts + ' Alerta desconexión: ' + elapsedMin + ' min');
        }
      }
    },
    updateClientData() {
      try {
        // console.log("------------------ updateClientData ------------------");
        // console.log(this.clientData);
        if (this.clientData.id && this.clientData.id > 0) {

          const clientId = { id: this.clientData.link };
          axios.post("https://vybroo.net/client", clientId)
            .then(response => {
              if (response.data.error == true || response.data.disabled == true) {
                //funcion para redirigir al login
                const okFunction = () => {
                  Storage.clear();
                  menuController.close('menustudio');
                  this.$router.replace("/login/loginPage");
                }
                if (response.data.error == true) {
                  this.presentAlertCustom("El canal ha sido desactivado", "", okFunction);
                  this.pause('manual-pause');
                }
                else if (response.data.disabled == true) {
                  this.presentAlertCustom("El canal ha sido deshabilitado", "", okFunction);
                  this.pause('manual-pause');
                }
                else this.presentAlertCustom("Aviso", "No se ha podido encontrar el canal " + this.mLoginInput.toLowerCase() + ".", okFunction);
              } else {
                // console.log("Canal encontrado");
                this.setClientData("clientData", response.data);

                //CAMBIOS EN PERMISSIONS
                if (JSON.stringify(this.clientData.permissions) !== JSON.stringify(response.data.permissions)) {
                  console.log("Se detectaron cambios en Permissions, se solicitará actualizar - clientData:" + JSON.stringify(this.clientData.permissions) + " clientApi:" + JSON.stringify(response.data.permissions));
                  this.presentAlertRefresh("Recarga necesaria", "Se realizaron cambios en la configuración del canal por lo cual es necesario volver a cargar el reproductor.");
                  this.listenedChanges.permissions = this.clientData.permissions;
                  // this.emitter.emit("permissions", this.clientData.permissions);
                }

                //CAMBIOS EN LOS CONTROLES DE CALIDAD
                if (this.clientData.quality_controls != response.data.quality_controls) {
                  this.sound.controls = response.data.quality_controls;
                  this.emitter.emit("quality-controls", this.sound.controls);
                }

                //CAMBIOS EN LOS VOLÚMENES DE NORMALIZACIÓN
                if (this.clientData.music_volume != response.data.music_volume || this.clientData.spots_volume != response.data.spots_volume) {
                  console.log("🔄 Cambios detectados en volúmenes:");
                  
                  if (response.data.music_volume !== undefined && response.data.music_volume > 0 && response.data.music_volume <= 100) {
                    this.sound.musicVolume = response.data.music_volume / 100;
                    console.log("   🎵 Música: " + this.clientData.music_volume + "% → " + response.data.music_volume + "% (logarítmico: " + this.linearToLog(this.sound.musicVolume).toFixed(3) + ")");
                  }
                  if (response.data.spots_volume !== undefined && response.data.spots_volume > 0 && response.data.spots_volume <= 100) {
                    this.sound.spotsVolume = response.data.spots_volume / 100;
                    console.log("   📢 Spots: " + this.clientData.spots_volume + "% → " + response.data.spots_volume + "% (logarítmico: " + this.linearToLog(this.sound.spotsVolume).toFixed(3) + ")");
                  }
                  
                  // Aplicar el nuevo volumen al audio actual si está reproduciéndose (multiplicando con el slider manual)
                  if (this.isPlaying) {
                    if (this.type === 'song' || this.type === 'videosong' || this.type === 'time') {
                      this.player.volume = this.linearToLog(this.sound.volume * this.sound.musicVolume);
                      console.log("   Aplicado inmediatamente a audio actual");
                    } else if (this.type === 'spot') {
                      this.player.volume = this.linearToLog(this.sound.volume * this.sound.spotsVolume);
                      console.log("   Aplicado inmediatamente a audio actual");
                    }
                  }
                  this.applyAudioDemandaVolume();
                }

                //VERIFICAR QUE SE TENGA LA VERSIÓN (clientVersion) más actualizada, solo si el cliente tiene versión entre su data
                //si esta usando navegador y no tiene la versión más actualizada, se le solicitará actualizar
                if (response.data.version && (this.clientData.version != response.data.version) && navigator.userAgent.includes("Mozilla")) {
                  console.log("Se detectaron cambios en la versión del canal, se solicitará actualizar - clientData:" + this.clientData.version + " clientApi:" + response.data.version);
                  this.presentAlertRefresh("Actualización disponible", " Por favor actualice la aplicación para utilizar la versión más reciente (v" + response.data.version + ").");
                }

                //ACTUALIZACIÓN DE LA VARIABLE clientData
                this.clientData = this.isJson(response.data);

                // Actualizar config de alertas si cambió
                if (this.clientData.config && this.clientData.config.alerts) {
                  this.alertConfig = this.clientData.config.alerts;
                }

                //CAMBIOS EN IMAGEN DEL CANAL
                if (this.clientData.image) {
                  this.listenedChanges.image = this.clientData.image;
                  this.clientImageSrc = 'https://media.vybroo.com/images/' + this.clientData.image;
                }
                //CAMBIOS EN COLOR DE FONDO DEL CANAL
                if (this.clientData.color) {
                  this.listenedChanges.color = this.clientData.color;
                  this.clientColor = "#" + this.clientData.color;
                }

                this.listenedChanges.save_m_variant = this.clientData.save_m_variant;
                // this.getStorageClientData("clientData");
                // console.log("---- clientData update successful ----")
              }
              // console.log(response.data);
              // console.log("------------------ updateClientData ------------------");

            })
            .catch(error => {
              console.error("Axios error en updateClientData", error);
            });
        }

      } catch (e) {
        console.error("ha ocurrido un error en la función updateClientData - " + e);
        // this.presentAlertConfirm("Error en la función updateClientData",e.toString());
        this.sendErrorReport("updateClientData", e.toString());
      }
      this.upgradeRepVersion();
    },
    async upgradeRepVersion() {
      console.log("upgradeRepVersion1::::::::::::::::::::::::::::::");
      try {
        const repVersion = this.clientData.rep_version ? this.clientData.rep_version : 0;
        const link = this.clientData.link ? this.clientData.link : "";
        const repVariante_id = this.currentVariante ? this.currentVariante : "";
        const repSucursal_id = await this.getSucursalByName();
        switch (repVersion) {
          case 1:
             console.log("Reproductor actualizado a versión 1.0.0");
            break;
          case 2:
             console.log("Reproductor actualizado a versión 2.0.0");
            break;
          case 3:
              if (link && link != "") {
                const url = new URL('https://vybroo.app/' + link);
                if (repVariante_id) url.searchParams.append('v', repVariante_id);
                if (repSucursal_id) url.searchParams.append('i', repSucursal_id);
                console.log("Redirigiendo a: " + url.toString());
                window.location.href = url.toString();
              }
             console.log("Reproductor actualizado a versión 3.0.0");
            break;
          default:
             console.log("Versión del reproductor desconocida.");
        }
      } catch (e) {
        console.error("ha ocurrido un error en la función upgradeRepVersion - " + e);
        // this.presentAlertConfirm("Error en la función upgradeRepVersion",e.toString());
      }
      console.log("upgradeRepVersion2::::::::::::::::::::::::::::::");
    },
    setClientData(keyName, dataValue) {
      try {
        Storage.set({
          key: keyName,
          value: JSON.stringify(dataValue),
        })
          .then
        // console.log("Asignado a storage exitosamente - " + keyName);
      } catch (e) {
        console.error("ha ocurrido un error en la función setClientData - " + e);
        // this.presentAlertConfirm("Ha ocurrido un error en la función setClientData",e.toString());
        this.sendErrorReport("setClientData", e.toString());
      }
    },
    async getStorageClientData(keyName) {
      try {
        const ret = await Storage.get({ key: keyName });
        this.clientData = this.isJson(ret.value);
        // this.emitter.emit("g-data", this.clientData);
        // console.log("Recuperado de storage - " + keyName);
      } catch (e) {
        console.error("ha ocurrido un error en la función getStorageClientData - " + e);
        // this.presentAlertConfirm("Ha ocurrido un error en la función getStorageClientData",e.toString());
        this.sendErrorReport("getStorageClientData", e.toString());
      }
    },
    skipToEnd() {
      try {
        const audio = this.player;
        if (!audio.paused) {
          audio.currentTime = audio.duration - 10;
        }
      } catch (e) {
        console.error("ha ocurrido un error en la función skipToEnd - " + e);
        // this.presentAlertConfirm("Error en la función skipToEnd",e.toString());
        this.sendErrorReport("skipToEnd", e.toString());
      }
    },
    async checkContest() {
      try {
        //hacer axios post a https://vybroo.net/contest con el id del cliente
        //si el cliente tiene un concurso activo, se debe mostrar el modal de concurso

        // console.log("Revisando si hay concursos...");
        const stream = { id: this.clientData.id };

        await axios.post("https://vybroo.net/contest", { stream: this.clientData.id })
          .then(response => {
            // console.log("contest response");
            // console.log(response.data);
            if (!response.data.success) {
              console.log("No hay concursos o hubo un error");
              console.log(response.data);
              return;
            }
            if (response.data.success && response.data.contest) {
              var optionsArray = null;
              var optionsLength = null;
              if (response.data.contest.contest && response.data.contest.contest.options) {
                // console.log("Hay opciones para el concurso (contest.contest.options)")
                this.contest = response.data.contest.contest;
                optionsArray = response.data.contest.contest.options ? response.data.contest.contest.options : response.data.contest.options;
                // console.log(optionsArray);
                optionsLength = optionsArray.length;
              } else {
                // console.log("No hay opciones para el concurso (no es contest.contest.options)");
                if (response.data.contest && response.data.contest.options) {
                  // console.log("Hay opciones para el concurso (contest.options)");
                  this.contest = response.data.contest;
                  optionsArray = response.data.contest.options;
                  // console.log(optionsArray);
                  optionsLength = optionsArray.length;
                } else {
                  // console.log("tampoco hay opciones para el concurso (no es contest.options)");
                  return;
                }
              }
              if (optionsLength && optionsLength == 2) {
                console.log("Hay un concurso activo");
                //hay un concurso activo, verificar en el storage si no se ha votado, si no se ha votado, mostrar un modal para votar que muestre el nombre de cada opción y su imagen
                this.contest.options = optionsArray;
                console.log("Revisando si ya se votó en el Storage...")
                this.checkStorageContestVote(this.contest.id);
                return;
                console.log("NO SE ENCONTRÓ CONTEST ID");

              }
            }

          })
          .catch(error => {
            console.error("Axios error en checkContest", error);
          });
      } catch (e) {
        console.error("ha ocurrido un error en la función checkContest - " + e);
        // this.presentAlertConfirm("Error en la función checkContest",e.toString());
        this.sendErrorReport("checkContest", e.toString());
      }
    },
    async checkStorageContestVote(contestId) {
      try {
        const keyStorage = 'contest_vote:' + contestId;
        console.log("key: " + keyStorage);
        await Storage.get({ key: keyStorage }).then((value) => {
          console.log(value);
          if (value.value) {
            console.log("Ya se votó en el Storage, no se mostrará el modal de concurso");
            console.log(value.value);
            this.concursoActivo = 'concursoInactivo';
          } else {
            console.log("No se ha votado en el Storage, se mostrará el modal de concurso");
            console.log(value.value);
            //modificar la url de las imágenes
            this.contest.options.forEach(element => {
              element.image = "https://media.vybroo.com/images/" + element.image;
            });
            console.log("Imprimiendo contest nuevo");
            console.log(this.contest);
            this.concursoActivo = 'concursoActivo';
            console.log("Mostrando modal de concurso");
            this.showContestModal();
          }
        });
      } catch (e) {
        console.error("ha ocurrido un error en la función checkStorageContestVote - " + e);
        // this.presentAlertConfirm("Error en la función checkStorageContestVote",e.toString());
        this.sendErrorReport("checkStorageContestVote", e.toString());
      }
    },
    async showContestModal() {
      try {
        if (this.modalisopen == true) {
          return;
        }
        if (this.modalWasClosed == true) {
          return;
        }
        this.modalisopen = true;
        const modal = await modalController.create({
          component: contestModal,
          //backdropDismiss: false,
          componentProps: {
            contestParam: this.contest,
          },
        });
        modal.onDidDismiss().then((dataReturned) => {
          if (dataReturned !== null) {
            this.modalisopen = false;
            this.modalWasClosed = true;
            console.log("Modal cerrado");
          }
        });
        return modal.present();
      } catch (e) {
        console.error("ha ocurrido un error en la función showContestModal - " + e);
        // this.presentAlertConfirm("Error en la función showContestModal",e.toString());
        this.sendErrorReport("showContestModal", e.toString());
      }
    },

    async showContestModalButton() {
      this.modalWasClosed = false;
      this.showContestModal();
    },

    //regresar solo el numero de la versión del navegador
    getBrowserVersionNumber() {
      var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/)
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(' ');
    },

    async showVideoModal(src) {
      try {
        //console.log("showVideoModal | videoOn:" + this.videoOn);
        if (this.videoOn == true) {
          return;
        }
        this.videoOn = true;
        const modal = await modalController.create({
          component: RepModal,
          //backdropDismiss: false,
          cssClass: 'full_modal',
          componentProps: {
            title: 'RepVideo',
            video: src,
            initialVolume: this.player.volume,
          },
          keyboardClose: false,
          backdropDismiss: false,
        });
        modal.onDidDismiss().then((dataReturned) => {
          if (dataReturned !== null) {
            this.videoOn = false;
            console.log("Modal cerrado");
          }
        });
        return modal.present();
      } catch (e) {
        console.error("ha ocurrido un error en la función showVideoModal - " + e);
        // this.presentAlertConfirm("Error en la función showVideoModal",e.toString());
        this.sendErrorReport("showVideoModal", e.toString());
      }
    },
    async getip() {
      try {
        const response = await axios.get('https://api.ipify.org?format=json');
        var ip = response.data.ip;
        this.ip = ip;
        this.emitter.emit("ip", this.ip);
        console.log("GETIP ", ip);
      } catch (error) {
        console.log("GETIP 1 Error en función getConnections de Conexiones: ", error.message);
      }
    },
    async wakeLockOn() {
      try {
        if (this.isNativePlatform()) {
          try {
            await KeepAwake.keepAwake();
            this.wakeLockNativeActive = true;
            console.log('KeepAwake nativo activo.');
          } catch (err) {
            this.wakeLockNativeActive = false;
            console.error('keepAwake:err:', err);
          }
          this.emitWakeLockStatus('wake-lock-on-native');
          return;
        }

        if (!this.supportsWebWakeLock()) {
          console.warn('Wake Lock API no disponible en este navegador/plataforma.');
          this.emitWakeLockStatus('wake-lock-web-unsupported');
          return;
        }

        if (typeof document !== 'undefined' && document.visibilityState !== 'visible') {
          console.log('WakeLock omitido porque la pestaña no está visible.');
          this.emitWakeLockStatus('wake-lock-web-hidden');
          return;
        }

        if (this.wakeLock) {
          this.emitWakeLockStatus('wake-lock-web-already-active');
          return;
        }

        console.log('Iniciando WakeLock web...');
        this.wakeLock = await navigator.wakeLock.request('screen');
        this.emitWakeLockStatus('wake-lock-on-web');
        this.wakeLock.addEventListener('release', () => {
          this.wakeLock = null;
          console.log('WakeLock web liberado por el sistema.');
          this.emitWakeLockStatus('wake-lock-web-release');
          if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
            setTimeout(() => {
              this.wakeLockOn();
            }, 600);
          }
        });
      } catch (e) {
        this.wakeLockError = true;
        this.wakeLockErrorMessage = e && e.message ? e.message : String(e);
        console.error("ha ocurrido un error en la función wakeLockOn - " + e);
      }
    },

  },
  mounted: function () {
    this.getip();
    try {
      this.platform = Capacitor.getPlatform();
      this.isLoaded = true;
      this.emitWakeLockStatus('mounted-init');

      //calculo de hora local
      this.getServerTime();

      this.emitter.on("sonara", (data) => {
        this.sonara = data;
      });

      this.emitter.on("rep-storeVideo", play => {
        console.log("storeVideo emitter recibido:: "+play);
        const offlineUrl = this.resolveOfflineStoreUrl(this.playerAudioSource, this.type);
        this.storeAudioFile(
          this.audio_id, 
          this.title, 
          this.artist, 
          offlineUrl,
          this.type,
          this.tags,
          this.formula,
          this.filter
        );
      });

      // console.log("Hora local en Zona Horaria: " + this.horaLocal);
      this.emitter.on("send-error-report", (functionName, error) => {
        console.log("send-error-report recibido");
        this.sendErrorReport(functionName, error);
      });
      this.emitter.on("rep-func-play", play => {
        console.log("play emitter recibido");
        this.play();
      });
      this.emitter.on("rep-func-pause", pause => {
        this.pause('user-click');
      });
      this.emitter.on("rep-func-quality-options", quality => {
        this.showQualityOptionsButton();
      });
      this.emitter.on("rep-func-volume", volume => {
        // console.log("volume emitter recibido");
        this.changeVolume(volume);
      });
      this.emitter.on("rep-func-likeInteraction", likeValue => {
        this.likeInteraction(likeValue);
      });
      this.emitter.on("rep-func-kill", kill => {
        this.killAudio(); this.killAudioDemanda();
        console.log("kill: " + kill);
      });
      this.emitter.on("concursoModal", status => {
        if (status == 'votado') {
          this.concursoActivo = 'concursoInactivo';
        }
        console.log("ConcursoStatus: " + status);
      });
      this.emitter.on("videoModalEnd", status => {
        this.next();
        console.log("videoModalEnd: " + status);
      });
      this.emitter.on("videoOn", status => {
        this.videoOn = status;
        console.log("emitter videoOn desde tabs: " + status);
      });
      this.emitter.on("fullScreenOn", status => {
        this.fullScreenOn = status;
        //console.log("emitter fullScreenOn desde TABREP: " + status);
      });
      this.emitter.on("hora_actual", hora => {
        this.horaActual = hora;
        // console.log("emitter hora_actual desde tabs: " + hora);
      });
      this.emitter.on("memorySizeFree", memory => { 
        console.log("emitter memorySizeFree desde tabs: " + memory);
        this.memorySizeFree();
      });
      this.emitter.on("rep-set-normalized-mode", async enabled => {
        await this.applyNormalizeSongsPreference(enabled, { persist: true, emit: true });
      });
      this.emitter.on("support-request-wakelock-status", () => {
        this.emitWakeLockStatus('support-request');
      });

      this.emitter.on("channel-switched", () => {
        console.log("channel-switched: reseteando estado de categoría musical");
        this.currentCategoria = 0;
        this.currentCategoriaAux = null;
        this.saveMusicVariant = {
          enabled: this.clientData.save_m_variant,
          time: 0,
          timeString: "00:00:00",
          nextSwitch: false,
          timerRunning: false
        };
        Storage.remove({ key: 'saveMusicVariantTime' });
        Storage.remove({ key: 'categoriaSeleccionada' });
      });

      // Estado inicial temporal antes de conocer el scope del canal.
      this.normalizeSongsEnabled = !!this.normalizeSongsDefaultEnabled;
      this.isOriginalABMode = !this.normalizeSongsEnabled;
      this.emitter.emit("normalize-songs-setting", this.normalizeSongsEnabled);

      if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener('storage', this.handleNormalizeSongsStorageSync);
        window.addEventListener('pointerdown', this.handleUserPlaybackGesture, { passive: true });
        window.addEventListener('touchstart', this.handleUserPlaybackGesture, { passive: true });
        window.addEventListener('keydown', this.handleUserPlaybackGesture);
        window.addEventListener('focus', this.handleWakeLockVisibilityChange);
        window.addEventListener('pageshow', this.handleWakeLockVisibilityChange);
      }
      if (typeof document !== 'undefined' && document.addEventListener) {
        document.addEventListener('visibilitychange', this.handleWakeLockVisibilityChange);
      }

      // console.log("Iniciando WakeLock...");
      // PowerManagement.acquire()
      // .then(res => {
      //   console.log('Wakelock aquire')
      // })
      // .catch(res => console.log('Error Wakelock acquired - ', res));

      // PARÁMETROS EN EL URL
      const queryString = window.location.search;
      const urlParametros = new URLSearchParams(queryString);
      this.urlParams.sucursal = urlParametros.get('sucursal');
      this.urlParams.sucursalName = urlParametros.get('sucursalName');
      this.urlParams.categoria = urlParametros.get('categoria');
      this.urlParams.variante = urlParametros.get('variante');
      // // const sucursalUrl = urlParametros.get('sucursal');
      // console.log("URL PARAMETRO SUCURSAL: " + this.urlParams.sucursal);
      // this.currentSucursal = this.urlParams.sucursal;
      // this.emitter.emit("rep-currentSucursal", this.currentSucursal);
      // console.log("URL PARAMETRO VARIABLE: " + this.currentSucursal);
      // console.log(this.currentlyTimer);
      this.player.autoplay = false;
      this.playerAudioDemanda.autoplay = false;

      menuController.enable(true, "menustudio");
      this.getClientData("clientData");
      setTimeout(() => {
        this.updateClientData();
        this.checkContest();
        this.imHere();
      }, 10000);
      // window.setInterval(() => {
      //   this.sendErrorReport("Carga de la app", "OK");
      // }, 10000);
      window.setInterval(() => {
        this.updateClientData();
        this.checkContest();
      }, 360000);
      window.setInterval(() => {
        this.imHere();
      }, 150000);
      window.setInterval(() => {
        this.checkAlerts();
      }, 30000);
      console.info("%c🖥️ VERSIÓN DE APP: " + this.updateInfo, "color: green; font-weight: bold; background-color: #eee; padding: 5px; border-radius: 5px; font-size: 14px; border: 2px solid green;");

      window.setInterval(() => {
        if (this.running500msInterval == false) {
          this.running500msInterval = true;
          this.currentlyTimer = this.millisToMinutesAndSeconds(Math.round(this.player.currentTime) * 1000);
          this.songProgress = this.player.currentTime / this.player.duration;
          // si songProgress tiene 5 segundos o más, reiniciar el contador de playErrorCount
          if (this.player.currentTime > 5) {
            // console.log("this.player.currentTime: " + this.player.currentTime);
            if (this.playErrorCount > 0 && (this.type == "song" || this.type == "videosong")) {
              this.playErrorCount = 0;
              console.log("Reiniciando playErrorCount: " + this.playErrorCount);
            }
            if (this.tokenErrorCount > 0 && (this.type == "song" || this.type == "videosong")) {
              this.tokenErrorCount = 0;
              console.log("Reiniciando tokenErrorCount: " + this.tokenErrorCount);
            }

            // next de pruebas
            // this.next();
          }
          this.sound.previousTime = this.player.currentTime;
          this.emitter.emit("rep-currentlyTimer", this.currentlyTimer);
          this.emitter.emit("rep-songProgress", this.songProgress);
           
          //storeAudioFile(id, title, artist, url, type, tags, formula, filter)
          // if currentlyTimer is equal to 5 secomds
          if (this.currentlyTimer == "0:05") {
            if (this.storedInterval == false) {
              this.storedInterval = true;
              //console.log("URL AUDIO: " + this.player.src);
              const offlineUrl = this.resolveOfflineStoreUrl(this.playerAudioSource || this.player.src, this.type);
                this.storeAudioFile(
                  this.audio_id, 
                  this.title, 
                  this.artist, 
                  offlineUrl,
                  this.type,
                  this.tags,
                  this.formula,
                  this.filter
                );
            }else{
              this.storedInterval = false;
            }
          }

          // console.log("currentlyTimer:" + this.currentlyTimer);
          if (this.player.duration)
            this.totalTimer = this.millisToMinutesAndSeconds(Math.round(this.player.duration) * 1000);
          this.emitter.emit("rep-totalTimer", this.totalTimer);
          if (this.clientData.video_enabled == false) {
            setTimeout(() => {
              this.getApiRequestData();
              if (!this.globalPlay && Capacitor.getPlatform() != 'ios' && !this.autoplayBlocked) {
                //si el dispositivo no es iOS, se reproduce automáticamente
                this.play();
              }
              //si el navegador está desactualizado mostrar alerta
              // const browserVersion = this.getBrowserVersionNumber();
              // if (Capacitor.getPlatform() == 'web' && browserVersion < 80) {
              //   this.presentAlertCustom("Aviso","Para garantizar una mejor experiencia, actualiza tu navegador a la última versión.");
              //   console.log("Versión de navegador: " + browserVersion);
              // } else {
              //   console.log("Navegador actualizado");
              //   console.log("Versión de navegador: " + browserVersion);
              // }
            }, 2000);
          }
          menuController.enable(true, "configMenu");
          this.running500msInterval = false;
        } else {
          console.log("500ms interval is already running");
        }
      }, 500);
      window.setInterval(() => {
        this.getApiRequestData();
        this.checkOnline();
      }, 2000);
      // this.presentAlertConfirm("Información",JSON.stringify({"currentSucursal:": this.currentSucursal, "currentCategoria": this.currentCategoria, "playerAudioDemandaSource:": this.playerAudioDemandaSource}))
      this.listenerOnPause();
      this.listenerOnPlay();
      this.listenerOnEnded();
      this.listenerOnError();
      // === MEJORAS DE ROBUSTEZ ===
      this.addPlayerStalledHandler();
      this.addPlayerWaitingHandler();
      this.addPlayerCanPlayHandler();
      this.addNetworkListeners();
      if (Capacitor.getPlatform() == 'ios') {
        const okFunction = () => {
          console.log("okFunction");
          this.play();
        };
        // this.presentAlertCustom("Aviso","Para garantizar el correcto funcionamiento de la aplicación es necesario que esta se encuentre siempre funcionando en primer plano y con la pantalla encendida.", okFunction);
        // this.presentAlertConfirm("Aviso","Para garantizar el correcto funcionamiento de la aplicación es necesario que esta se encuentre siempre funcionando en primer plano y con la pantalla encendida.");
      };
    } catch (e) {
      console.error("ha ocurrido un error en mounted - " + e);
      // this.presentAlertConfirm("Error en la función mounted",e.toString());
      this.sendErrorReport("error-mounted", e.toString());
    }

    // Activar captura de console.warn/error para diagnóstico remoto
    try { deviceLogger.captureConsole(); } catch (e) { /* fail silent */ }

    // Registrar montaje inicial para tener siempre al menos un evento
    deviceLogger.log('app_mount', {
      url: window.location.href,
      stream: this.streamName,
      variant: this.contentVariant,
      version: this.clientVersion,
    }, {
      device_id: this.getOrCreateDeviceId(),
      session_id: this.getOrCreateSessionId(),
      version: this.clientVersion,
      app_mode: 'browser',
    });

    window.setInterval(() => {
      this.speedTestRun();
    }, 3 * 60 * 60 * 1000); // 3 horas en milisegundos
    setTimeout(() => {
      this.speedTestRun();
    }, 30 * 1000); // 30 segundos en milisegundos

    this.wakeLockOn();
    this.emitWakeLockStatus('mounted-after-wakelock-request');

  },
  beforeUnmount() {
    this.setPauseReason('before-unmount');
    this.stopAutoResumeLoop('before-unmount');
    // === MEJORAS DE ROBUSTEZ ===
    this.removePlayerStalledHandler();
    this.removePlayerWaitingHandler();
    this.removePlayerCanPlayHandler();
    this.removeNetworkListeners();
    if (typeof window !== 'undefined' && window.removeEventListener) {
      window.removeEventListener('storage', this.handleNormalizeSongsStorageSync);
      window.removeEventListener('pointerdown', this.handleUserPlaybackGesture);
      window.removeEventListener('touchstart', this.handleUserPlaybackGesture);
      window.removeEventListener('keydown', this.handleUserPlaybackGesture);
      window.removeEventListener('focus', this.handleWakeLockVisibilityChange);
      window.removeEventListener('pageshow', this.handleWakeLockVisibilityChange);
    }
    if (typeof document !== 'undefined' && document.removeEventListener) {
      document.removeEventListener('visibilitychange', this.handleWakeLockVisibilityChange);
    }
    deviceLogger.restoreConsole();
    this.wakeLockOff();
    this.emitter.off("channel-switched");
  },
  async created() {
    try {
      await this.initDB();
      // POWER MANAGEMENT
      // this.powerManagement.acquire()
      // .then(
      //   this.presentAlertConfirm("Power management acquired")
      // )
      // .catch(
      //   this.presentAlertConfirm("Power management error - ", onError)
      // );
      if (Capacitor.getPlatform() != 'web') {
        // PowerManagement.acquire(function() {
        //   console.log('Wakelock acquired');
        // }, function() {
        //   console.log('Failed to acquire wakelock');
        // });
      }

      // console.log("Navegador o plataforma: "+ Capacitor.getPlatform());
      if (Capacitor.getPlatform() != 'ios') {
        this.nativeBackgroundConfigured = true;
        App.addListener('appStateChange', state => {
          this.appIsActive = !!state.isActive;
          if (!state.isActive) { // if isActive is true, App got sent to foreground, if it is false, it got sent to the background
            // console.log("APP ON BACKGROUND --------------------------------------------------")
            BackgroundMode.enable();
            BackgroundMode.setEnabled(true);
            this.nativeBackgroundConfigured = true;
            BackgroundMode.on('activate', () => {
              BackgroundMode.disableBatteryOptimizations();
              BackgroundMode.disableWebViewOptimizations();
            })
          } else {
            // console.log("APP ON SCREEN --------------------------------------------------")
            // BackgroundMode.disable();
            // BackgroundMode.setEnabled(false);
            BackgroundMode.enable();
            BackgroundMode.setEnabled(true);
            this.nativeBackgroundConfigured = true;
            BackgroundMode.on('activate', () => {
              BackgroundMode.disableBatteryOptimizations();
              BackgroundMode.disableWebViewOptimizations();
            })
          }
          this.emitWakeLockStatus('app-state-change');
        });
        // App.addListener('backButton', ({canGoBack}) => {
        //   if(!canGoBack){
        //     console.log('Cant go back')
        //     this.$router.push('/tabs/tabReproductor')
        //   } else {
        //     console.log('Can go back')
        //   }
        // });
        // App.addListener('appStateChange', ({ isActive }) => {
        //   // console.log('App state changed. Is active?', isActive);
        // });

        Network.addListener('networkStatusChange', status => {
          console.log('Network status changed', status.connected);
          console.log(status);
          if (status.connected == false) {
            Toast.show({ text: 'AVISO: Se perdió la conexión a internet.', duration: 'long' });
            this.title = "Sin conexión";
            this.artist = "Por favor verifique su red";
            this.audio_id = '0';
            this.emitter.emit("rep-title", this.title);
            this.emitter.emit("rep-artist", this.artist);

          } else if (status.connected == true) {
            if (this.networkStatus.connected == false) {
              Toast.show({ text: 'Conexión a internet establecida.', duration: 'long' });
            }
            this.title = this.bkTitle;
            this.artist = this.bkArtist;
            this.audio_id = '0';
            this.emitter.emit("rep-title", this.title);
            this.emitter.emit("rep-artist", this.artist);
          }
          this.networkStatus = status;
          // console.log('Network status:', this.networkStatus.connected);
        });
        // const logCurrentNetworkStatus = async () => {
        //   const status = await Network.getStatus();

        // };
        // logCurrentNetworkStatus();
      }
    } catch (e) {
      console.error("Error en la función created - ", e.toString());
      this.presentAlertConfirm("Error en la función created - ", e.toString());
    }

  }
}
</script>

<style scoped>
* {
  font-family: 'Montserrat', sans-serif;
}

/*=============================================================*/
/* SpeedTest */
/*=============================================================*/
.SpeedTestNotification{
    position: absolute;
    right: 10px;
    top: 90px;
}
.SpeedTestNotification .listSpeedTest{}
.SpeedTestNotification .listSpeedTest .itemSpeedTest{
  border-radius: 50px;
    padding: 4px 5px 4px 5px; 
    transition: all 0.3s;
}
.SpeedTestNotification .listSpeedTest .itemSpeedTest:hover{
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.5);
  padding: 4px 5px 6px 8px; 
}
.SpeedTestNotification .listSpeedTest .itemSpeedTest .avatarSpeedTest{
  text-align: right;
}
.SpeedTestNotification .listSpeedTest .itemSpeedTest .avatarSpeedTest .imgSpeedTest{
  animation : parpadeo 1.5s infinite;
  width: 35px;
}
.SpeedTestNotification .listSpeedTest .itemSpeedTest .labelSpeedTest{
  display: none;
}
.SpeedTestNotification .listSpeedTest .itemSpeedTest:hover .labelSpeedTest{
  display: block;
}
.SpeedTestNotification .listSpeedTest .itemSpeedTest .labelSpeedTest p{
  color: #fff;
}

/* animation parpadeo */
@keyframes parpadeo {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}

/*=============================================================*/
/* VBACK ON */
/*=============================================================*/
.loaderOutDiv {
  position: fixed;
  right: 30px;
  bottom: 10px;
  animation: vback 2s linear infinite;
  z-index: 2;
}
@keyframes vback {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
  100% {
    transform: translateY(0);
  }
}
.loaderOutDiv .vBackMessage {
  display: none;
  position: fixed;
  right: 5px;
  bottom: 32px;
  z-index: 2;
  color: rgb(198, 171, 123);
  border: solid rgb(108, 76, 11) 1px;
  font-size: 12px;
  text-align: center;
  background: rgb(47, 40, 5);
  border-radius: 3px;
  padding: 2px 5px;
  width: 120px;
  opacity: 0.9;
}
.loaderOutDiv:hover .vBackMessage {
  display: block;
}
.loaderOutDiv:hover .vBackMessage::before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid rgb(108, 76, 11);
  bottom: -8px;
  left: 88%;
  transform: translateX(-50%);
}

.loaderOutDiv .vbackimg {
  width: 36px;
  height: 36px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loaderr {
  position: relative;
  margin: auto;
  box-sizing: border-box;
  background-clip: padding-box;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.1);
  -webkit-mask: linear-gradient(
    rgba(24, 24, 24, 0.2),
    rgba(24, 24, 24, 0.9) 90%
  );
  transform-origin: 50% 60%;
  transform: perspective(200px) rotateX(66deg);
}

.loaderr:before,
.loaderr:after {
  content: '';
  position: absolute;
  margin: -4px;
  box-sizing: inherit;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  opacity: 0.05;
  border: inherit;
  border-color: transparent;
  animation: spinner-spin 1.2s cubic-bezier(0.6, 0.2, 0, 0.8) infinite,
    spinner-fade 1.2s linear infinite;
}

.loaderr:before {
  border-top-color: #66e6ff;
}

.loaderr:after {
  border-top-color: #f0db75;
  animation-delay: 0.3s;
}

@keyframes spinner-spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-fade {
  20% {
    opacity: 0.1;
  }

  40% {
    opacity: 1;
  }

  60% {
    opacity: 0.1;
  }
}

/*=============================================================*/
/* VBACK ON */
/*=============================================================*/

.concursoNotification {
  position: fixed;
  width: 50px;
  height: 50px;
  background-color: #f7f7f7;
  border-radius: 50px;
  left: 20px;
  bottom: 20px;
  border-style: solid;
  border-width: 1px;
  border-color: #dcdcdc;
  animation: slidebg 50s linear infinite;
  background-image: linear-gradient(
    90deg,
    #00c0ff 0%,
    #00ff22 20%,
    #ffcf00 40%,
    #fd1212 60%,
    #ba12fd 80%,
    #00c0ff 100%
  );
  z-index: 1;
}

@keyframes slidebg {
  to {
    background-position: 200vw;
  }
}

.concursoNotification::before {
  position: absolute;
  content: '';
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  background-color: #f7f7f7;
  left: 50%;
  top: 50%;
  border-radius: 100%;
  transform: translate(-50%, -50%);
  z-index: -1;
  opacity: 0.95;
}

.concursoNotification:hover {
  scale: 1.2;
}

.concursoNotification .tooltip {
  display: none;
}

.concursoNotification .tooltip {
  box-shadow: 0px 0px 1px #fff;
  background: #1c1c1c;
  position: absolute;
  right: 0;
  top: 50%;
  padding: 7px 10px;
  transform: translate(calc(100% + 15px), -50%);
  font-size: 14px;
  width: 145px;
  scale: 1;
  animation: tooltip 0.5s;
  border-radius: 2px;
  color: white !important;
}

@keyframes tooltip {
  0% {
    scale: 0.7;
    opacity: 0;
  }

  20% {
    scale: 0.7;
    opacity: 0;
  }

  100% {
    scale: 1;
    opacity: 1;
  }
}

.concursoNotification .tooltip:before {
  content: '';
  border-style: solid;
  position: absolute;
  left: -9px;
  border-color: transparent #1c1c1c transparent transparent;
  border-width: 5px 10px 5px 0px;
  top: calc(50% - 5px);
}

.concursoNotification:hover .tooltip {
  display: block;
}

.concursoNotification:hover::before {
  opacity: 0.8;
}

.concursoNotification ion-img {
  animation: notification_ticket 5s linear infinite;
}

@keyframes notification_ticket {
  0% {
    transform: rotate(0deg);
  }

  80% {
    transform: rotate(0deg);
  }

  85% {
    transform: rotate(15deg);
  }

  90% {
    transform: rotate(-15deg);
  }

  95% {
    transform: rotate(15deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

.concursoActivo {
  display: block;
}

.concursoInactivo {
  background-color: red;
  display: none;
}

.abTestFloating {
  position: fixed;
  left: 20px;
  bottom: 84px;
  min-width: 132px;
  height: 40px;
  border-radius: 24px;
  border: 1px solid #3b3b3b;
  background: #111;
  color: #f5f5f5;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  z-index: 2;
  opacity: 0.95;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.28);
}

.abTestFloating:hover {
  opacity: 1;
}

.abTestFloating:disabled {
  opacity: 0.6;
}

.abTestFloating.abOriginalMode {
  background: #7a1f1f;
  border-color: #ad3535;
}

.headerTop {
  background-color: black;
}

.playerImage {
  width: 80vw;
  height: 80vw;
  border-radius: 15px;
  margin: 20px auto 10px auto;
}

.songInfoCol {
  padding-left: 3vh;
  /* centrar contenido verticalmente sin display flex*/
  margin: auto;
}

.likeCol {
  margin: auto;
  text-align: right;
  padding-right: 3vh;
}

.progressBarCol {
  padding-left: 3vh;
  padding-right: 3vh;
}

.songTimeCol {
  padding-left: 3vh;
  color: white;
  margin: 0px;
}

.songTimeRemainingCol {
  margin: auto;
  text-align: right;
  padding-right: 3vh;
  color: white;
}

.songTimeCol .ios {
  color: white;
}

.songTimeRemainingCol .ios {
  color: white;
}

.playPauseCol {
  margin: auto;
  text-align: center;
  margin-top: -1.5vh;
  min-height: 90px !important;
}

.likeButton,
.dislikeButton {
  --padding-start: 18px;
  --padding-end: 18px;
}

.songName {
  font-weight: bold;
  font-size: 4vw;
  margin-bottom: 1.5vh;
  margin-top: 5px;
}

.songName .storeIcon {
    width: 26px;
    max-width: 26px;
    margin: 0px 10px 0px 0px;
    float: left;
} 

.playlistName {
  font-size: 3.8vw;
  margin-top: 0px;
}

.songTime,
.songTimeRemaining {
  font-size: 3vw;
  margin-top: 0;
}

.playPauseButton {
  font-size: 35px;
  border-radius: 100%;
  height: 80px;
  margin-bottom: 25px;
}

.volumeButton {
  font-size: 20px;
  border-radius: 100%;
  height: 80px;
  margin: auto;
  margin-left: 20px;
  padding: auto;
  /* transparencia */
  opacity: 0.7;
  /* fijo a la izquierda */
  position: fixed;
  left: 0;
}

.optionsButton {
  font-size: 25px;
  border-radius: 100%;
  height: 80px;
  margin: auto;
  margin-right: 20px;
  padding: auto;
  /* transparencia */
  opacity: 0.7;
  /* fijo a la derecha */
  position: fixed;
  right: 0;
}

.songName,
.playlistName {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
}

.songName:hover > *,
.playlistName:hover > * {
  display: inline-block;
  position: relative;
  animation: 5s linear 0s infinite move;
  min-width: 100%;
  text-overflow: initial;
  max-width: auto;
}

@keyframes move {
  0% {
    transform: translateX(0%);
    left: 0%;
  }

  20% {
    transform: translateX(0%);
    left: 0%;
  }

  100% {
    transform: translateX(-100%);
    left: 100%;
  }
}

.songName,
.playlistName {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
}

.songName:hover > *,
.playlistName:hover > * {
  display: inline-block;
  position: relative;
  animation: 5s linear 0s infinite move;
  min-width: 100%;
  text-overflow: initial;
  max-width: auto;
}

@keyframes move {
  0% {
    transform: translateX(0%);
    left: 0%;
  }

  20% {
    transform: translateX(0%);
    left: 0%;
  }

  100% {
    transform: translateX(-100%);
    left: 100%;
  }
}

.playerImage2_out {
  width: 100%;
  height: 100%;
  display: none;
}

.playerImage2 {
  width: 100%;
  height: 100%;
  background-size: 80%;
  background-repeat: no-repeat;
  background-position: center center;
  max-width: 700px;
  max-height: 700px;
  margin: auto;
}

.nextCol {
  margin: auto;
  text-align: center;
  padding-right: 3vh;
  padding-left: 3vh;
  margin-top: -1.5vh;
  display: none;
}

.nextButton {
  height: 50px;
  margin: auto;
  text-align: center;
  width: auto;
  transition: all 0.1s ease-in-out;
}

.nextButton:hover {
  transform: scale(1.05);
}

.nextButtonImg {
  filter: invert(100%);
  width: 100%;
  height: 100%;
}

@media only screen and (min-width: 767px) {
  .reproductor_small {
    display: none;
  }

  .playerImage {
    display: none;
  }

  .playerImage2_out {
    width: 100%;
    height: 100%;
    display: grid;
  }

  .playerImage2 {
    min-width: 60%;
    min-height: 60%;
    background-size: 90%;
  }
}

@media only screen and (min-width: 1125px) {
}

@media only screen and (max-width: 480px) {
  .likeButton,
  .dislikeButton {
    --padding-start: 9px;
    --padding-end: 9px;
  }
}

@media only screen and (max-width: 360px) {
  .likeButton,
  .dislikeButton {
    --padding-start: 5px;
    --padding-end: 5px;
  }
}

@media only screen and (max-height: 600px) {
  .songInfoCol {
    height: 70px;
  }

  .songName {
    margin-bottom: 10px;
    margin-top: 0;
  }

  .playlistName {
    margin: 10px 0 0 0;
  }

  .playerImage {
    width: 75vw;
    height: 75vw;
    border-radius: 1.5vh;
    margin: 3vh auto 1vh auto;
  }
}
</style>
